/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as RegisterImport } from './routes/register'
import { Route as LoginImport } from './routes/login'
import { Route as AppImport } from './routes/_app'
import { Route as IndexImport } from './routes/index'
import { Route as AppReturnOrderImport } from './routes/_app/return-order'
import { Route as AppPurchaseOrderImport } from './routes/_app/purchase-order'
import { Route as AppOrganizationImport } from './routes/_app/organization'
import { Route as AppInventoryImport } from './routes/_app/inventory'
import { Route as AppIntegrationsImport } from './routes/_app/integrations'
import { Route as AppFulfillmentImport } from './routes/_app/fulfillment'
import { Route as AppDashboardImport } from './routes/_app/dashboard'
import { Route as AppCatalogImport } from './routes/_app/catalog'
import { Route as AppAuditImport } from './routes/_app/audit'
import { Route as AppAccountImport } from './routes/_app/account'
import { Route as AppTimeIndexImport } from './routes/_app/time.index'
import { Route as AppTicketsIndexImport } from './routes/_app/tickets/index'
import { Route as AppShipmentsIndexImport } from './routes/_app/shipments.index'
import { Route as AppReturnOrdersIndexImport } from './routes/_app/return-orders.index'
import { Route as AppReportsIndexImport } from './routes/_app/reports.index'
import { Route as AppPurchaseOrdersIndexImport } from './routes/_app/purchase-orders.index'
import { Route as AppProjectsIndexImport } from './routes/_app/projects.index'
import { Route as AppPartsIndexImport } from './routes/_app/parts.index'
import { Route as AppNotificationsIndexImport } from './routes/_app/notifications.index'
import { Route as AppMovementsIndexImport } from './routes/_app/movements.index'
import { Route as AppLocationsIndexImport } from './routes/_app/locations.index'
import { Route as AppItemsIndexImport } from './routes/_app/items.index'
import { Route as AppIntegrationsIndexImport } from './routes/_app/integrations.index'
import { Route as AppFulfillmentsIndexImport } from './routes/_app/fulfillments.index'
import { Route as AppExchangesIndexImport } from './routes/_app/exchanges.index'
import { Route as AppExchangeIndexImport } from './routes/_app/exchange.index'
import { Route as AppCustomersIndexImport } from './routes/_app/customers.index'
import { Route as AppCostsIndexImport } from './routes/_app/costs.index'
import { Route as AppContactsIndexImport } from './routes/_app/contacts.index'
import { Route as AppCompaniesIndexImport } from './routes/_app/companies.index'
import { Route as AppCatalogIndexImport } from './routes/_app/catalog.index'
import { Route as AppBillingIndexImport } from './routes/_app/billing.index'
import { Route as AppAssetsIndexImport } from './routes/_app/assets.index'
import { Route as AppAssembliesIndexImport } from './routes/_app/assemblies.index'
import { Route as AppAccountingIndexImport } from './routes/_app/accounting.index'
import { Route as AppTicketsTicketKeyImport } from './routes/_app/tickets/$ticketKey'
import { Route as AppShipmentsShipmentKeyImport } from './routes/_app/shipments.$shipmentKey'
import { Route as AppReturnOrdersReturnOrderKeyImport } from './routes/_app/return-orders.$returnOrderKey'
import { Route as AppReturnOrderReturnOrderKeyImport } from './routes/_app/return-order.$returnOrderKey'
import { Route as AppReportsUpcomingProjectsImport } from './routes/_app/reports.upcoming-projects'
import { Route as AppReportsUpcomingProjectStartsImport } from './routes/_app/reports.upcoming-project-starts'
import { Route as AppReportsUpcomingProjectCompletionsImport } from './routes/_app/reports.upcoming-project-completions'
import { Route as AppReportsTransitImport } from './routes/_app/reports.transit'
import { Route as AppReportsPastProjectsImport } from './routes/_app/reports.past-projects'
import { Route as AppReportsInventoryImport } from './routes/_app/reports.inventory'
import { Route as AppReportsFulfillmentImport } from './routes/_app/reports.fulfillment'
import { Route as AppReportsFieldImport } from './routes/_app/reports.field'
import { Route as AppReportsDepreciationScheduleImport } from './routes/_app/reports.depreciation-schedule'
import { Route as AppReportsActiveProjectsImport } from './routes/_app/reports.active-projects'
import { Route as AppPurchaseOrdersPurchaseOrderKeyImport } from './routes/_app/purchase-orders.$purchaseOrderKey'
import { Route as AppPurchaseOrderPurchaseOrderKeyImport } from './routes/_app/purchase-order.$purchaseOrderKey'
import { Route as AppProjectsProjectKeyImport } from './routes/_app/projects.$projectKey'
import { Route as AppNotificationsSubscriptionsImport } from './routes/_app/notifications.subscriptions'
import { Route as AppLocationsLocationKeyImport } from './routes/_app/locations.$locationKey'
import { Route as AppFulfillmentsFulfillmentKeyImport } from './routes/_app/fulfillments.$fulfillmentKey'
import { Route as AppFulfillmentFulfillmentKeyImport } from './routes/_app/fulfillment.$fulfillmentKey'
import { Route as AppDashboardLocationImport } from './routes/_app/dashboard.location'
import { Route as AppDashboardCustomerImport } from './routes/_app/dashboard.customer'
import { Route as AppDashboardAssetImport } from './routes/_app/dashboard.asset'
import { Route as AppCustomersCustomerKeyImport } from './routes/_app/customers.$customerKey'
import { Route as AppContactsContactKeyImport } from './routes/_app/contacts.$contactKey'
import { Route as AppCompaniesCompanyKeyImport } from './routes/_app/companies.$companyKey'
import { Route as AppCatalogItemsImport } from './routes/_app/catalog.items'
import { Route as AppBillingPlansImport } from './routes/_app/billing.plans'
import { Route as AppBillingLifecycleImport } from './routes/_app/billing.lifecycle'
import { Route as AppBillingInvoiceLineItemsImport } from './routes/_app/billing.invoice-line-items'
import { Route as AppBillingChargesImport } from './routes/_app/billing.charges'
import { Route as AppBillingAgingImport } from './routes/_app/billing.aging'
import { Route as AppAssetsAssetKeyImport } from './routes/_app/assets.$assetKey'
import { Route as AppAssembliesRegistrationStatusImport } from './routes/_app/assemblies/$registrationStatus'
import { Route as AppAccountingPeriodReviewImport } from './routes/_app/accounting.period-review'
import { Route as AppAccountingInitialTrueUpImport } from './routes/_app/accounting.initial-true-up'
import { Route as AppAccountingCloseWorkflowImport } from './routes/_app/accounting.close-workflow'
import { Route as AppTicketsTicketKeyIndexImport } from './routes/_app/tickets/$ticketKey.index'
import { Route as AppReturnOrdersReturnOrderKeyIndexImport } from './routes/_app/return-orders.$returnOrderKey.index'
import { Route as AppPurchaseOrdersPurchaseOrderKeyIndexImport } from './routes/_app/purchase-orders.$purchaseOrderKey.index'
import { Route as AppProjectsProjectKeyIndexImport } from './routes/_app/projects.$projectKey.index'
import { Route as AppLocationsLocationKeyIndexImport } from './routes/_app/locations.$locationKey.index'
import { Route as AppItemsItemKeyIndexImport } from './routes/_app/items.$itemKey.index'
import { Route as AppFulfillmentsFulfillmentKeyIndexImport } from './routes/_app/fulfillments.$fulfillmentKey.index'
import { Route as AppCustomersCustomerKeyIndexImport } from './routes/_app/customers.$customerKey.index'
import { Route as AppContactsContactKeyIndexImport } from './routes/_app/contacts.$contactKey.index'
import { Route as AppCompaniesSuppliersIndexImport } from './routes/_app/companies.suppliers.index'
import { Route as AppCompaniesCustomersIndexImport } from './routes/_app/companies.customers.index'
import { Route as AppCompaniesCompanyKeyIndexImport } from './routes/_app/companies.$companyKey.index'
import { Route as AppCatalogItemsIndexImport } from './routes/_app/catalog.items.index'
import { Route as AppCatalogBundlesIndexImport } from './routes/_app/catalog.bundles.index'
import { Route as AppBillingInvoicesIndexImport } from './routes/_app/billing.invoices.index'
import { Route as AppAssetsAssetKeyIndexImport } from './routes/_app/assets.$assetKey.index'
import { Route as AppAccountingInitialTrueUpIndexImport } from './routes/_app/accounting.initial-true-up.index'
import { Route as AppTicketsTicketKeyAuditImport } from './routes/_app/tickets/$ticketKey.audit'
import { Route as AppTicketsTicketKeyAttachmentsImport } from './routes/_app/tickets/$ticketKey.attachments'
import { Route as AppReturnOrdersReturnOrderKeyShipmentsImport } from './routes/_app/return-orders.$returnOrderKey.shipments'
import { Route as AppReportsAssetSnapshotTabTypeImport } from './routes/_app/reports.asset-snapshot.$tabType'
import { Route as AppReportsAssetRollforwardTabTypeImport } from './routes/_app/reports.asset-rollforward.$tabType'
import { Route as AppReportsAssetBridgeTabTypeImport } from './routes/_app/reports.asset-bridge.$tabType'
import { Route as AppPurchaseOrdersPurchaseOrderKeyShipmentsImport } from './routes/_app/purchase-orders.$purchaseOrderKey.shipments'
import { Route as AppProjectsProjectKeyTicketsImport } from './routes/_app/projects.$projectKey.tickets'
import { Route as AppProjectsProjectKeyNotesImport } from './routes/_app/projects.$projectKey.notes'
import { Route as AppProjectsProjectKeyMembersImport } from './routes/_app/projects.$projectKey.members'
import { Route as AppProjectsProjectKeyFulfillmentImport } from './routes/_app/projects.$projectKey.fulfillment'
import { Route as AppProjectsProjectKeyCostsImport } from './routes/_app/projects.$projectKey.costs'
import { Route as AppProjectsProjectKeyBillingDetailsImport } from './routes/_app/projects.$projectKey.billing-details'
import { Route as AppProjectsProjectKeyAuditImport } from './routes/_app/projects.$projectKey.audit'
import { Route as AppProjectsProjectKeyAttachmentsImport } from './routes/_app/projects.$projectKey.attachments'
import { Route as AppLocationsLocationKeyRelatedShipmentsImport } from './routes/_app/locations.$locationKey.related-shipments'
import { Route as AppLocationsLocationKeyRelatedProjectsImport } from './routes/_app/locations.$locationKey.related-projects'
import { Route as AppLocationsLocationKeyRelatedAssetsImport } from './routes/_app/locations.$locationKey.related-assets'
import { Route as AppLocationsLocationKeyAuditImport } from './routes/_app/locations.$locationKey.audit'
import { Route as AppItemsItemKeyUnitsImport } from './routes/_app/items.$itemKey.units'
import { Route as AppItemsItemKeyPricingImport } from './routes/_app/items.$itemKey.pricing'
import { Route as AppItemsItemKeyMovementImport } from './routes/_app/items.$itemKey.movement'
import { Route as AppItemsItemKeyBomImport } from './routes/_app/items.$itemKey.bom'
import { Route as AppItemsItemKeyAuditImport } from './routes/_app/items.$itemKey.audit'
import { Route as AppItemsItemKeyAssetsImport } from './routes/_app/items.$itemKey.assets'
import { Route as AppItemsItemKeyAccountingImport } from './routes/_app/items.$itemKey.accounting'
import { Route as AppIntegrationsTriageItemsImport } from './routes/_app/integrations.triage.items'
import { Route as AppIntegrationsTriageCustomersImport } from './routes/_app/integrations.triage.customers'
import { Route as AppFulfillmentsFulfillmentKeyShipmentsImport } from './routes/_app/fulfillments.$fulfillmentKey.shipments'
import { Route as AppCustomersCustomerKeyProjectsImport } from './routes/_app/customers.$customerKey.projects'
import { Route as AppCustomersCustomerKeyOwnedAssetsImport } from './routes/_app/customers.$customerKey.owned-assets'
import { Route as AppCustomersCustomerKeyLocationsImport } from './routes/_app/customers.$customerKey.locations'
import { Route as AppCustomersCustomerKeyLocationAssetsImport } from './routes/_app/customers.$customerKey.location-assets'
import { Route as AppCustomersCustomerKeyFulfillmentImport } from './routes/_app/customers.$customerKey.fulfillment'
import { Route as AppCustomersCustomerKeyAuditImport } from './routes/_app/customers.$customerKey.audit'
import { Route as AppContactsContactKeyAuditImport } from './routes/_app/contacts.$contactKey.audit'
import { Route as AppCompaniesCompanyKeyProjectsImport } from './routes/_app/companies.$companyKey.projects'
import { Route as AppCompaniesCompanyKeyOwnedAssetsImport } from './routes/_app/companies.$companyKey.owned-assets'
import { Route as AppCompaniesCompanyKeyLocationsImport } from './routes/_app/companies.$companyKey.locations'
import { Route as AppCompaniesCompanyKeyLocationAssetsImport } from './routes/_app/companies.$companyKey.location-assets'
import { Route as AppCompaniesCompanyKeyFulfillmentImport } from './routes/_app/companies.$companyKey.fulfillment'
import { Route as AppCompaniesCompanyKeyContactsImport } from './routes/_app/companies.$companyKey.contacts'
import { Route as AppCompaniesCompanyKeyAuditImport } from './routes/_app/companies.$companyKey.audit'
import { Route as AppCatalogItemsItemKeyImport } from './routes/_app/catalog.items.$itemKey'
import { Route as AppCatalogBundlesBundleKeyImport } from './routes/_app/catalog.bundles.$bundleKey'
import { Route as AppBillingInvoicesInvoiceKeyImport } from './routes/_app/billing.invoices.$invoiceKey'
import { Route as AppAssetsAssetKeyTicketsImport } from './routes/_app/assets.$assetKey.tickets'
import { Route as AppAssetsAssetKeyMetadataImport } from './routes/_app/assets.$assetKey.metadata'
import { Route as AppAssetsAssetKeyAuditImport } from './routes/_app/assets.$assetKey.audit'
import { Route as AppAssetsAssetKeyAttachmentsImport } from './routes/_app/assets.$assetKey.attachments'
import { Route as AppAssetsAssetKeyAccountingImport } from './routes/_app/assets.$assetKey.accounting'
import { Route as AppAccountingInitialTrueUpIsoImport } from './routes/_app/accounting.initial-true-up.$iso'
import { Route as AppCatalogItemsItemKeyIndexImport } from './routes/_app/catalog.items.$itemKey.index'
import { Route as AppCatalogBundlesBundleKeyIndexImport } from './routes/_app/catalog.bundles.$bundleKey.index'
import { Route as AppReportsExceptionAssetTabTypeImport } from './routes/_app/reports.exception.asset.$tabType'
import { Route as AppCatalogItemsItemKeyUnitsImport } from './routes/_app/catalog.items.$itemKey.units'
import { Route as AppCatalogItemsItemKeyPricingImport } from './routes/_app/catalog.items.$itemKey.pricing'
import { Route as AppCatalogItemsItemKeyMovementImport } from './routes/_app/catalog.items.$itemKey.movement'
import { Route as AppCatalogItemsItemKeyBomImport } from './routes/_app/catalog.items.$itemKey.bom'
import { Route as AppCatalogItemsItemKeyAuditImport } from './routes/_app/catalog.items.$itemKey.audit'
import { Route as AppCatalogItemsItemKeyAssetsImport } from './routes/_app/catalog.items.$itemKey.assets'
import { Route as AppCatalogItemsItemKeyAccountingImport } from './routes/_app/catalog.items.$itemKey.accounting'
import { Route as AppCatalogBundlesBundleKeyAuditImport } from './routes/_app/catalog.bundles.$bundleKey.audit'

// Create/Update Routes

const RegisterRoute = RegisterImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const AppRoute = AppImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AppReturnOrderRoute = AppReturnOrderImport.update({
  id: '/return-order',
  path: '/return-order',
  getParentRoute: () => AppRoute,
} as any)

const AppPurchaseOrderRoute = AppPurchaseOrderImport.update({
  id: '/purchase-order',
  path: '/purchase-order',
  getParentRoute: () => AppRoute,
} as any)

const AppOrganizationRoute = AppOrganizationImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => AppRoute,
} as any)

const AppInventoryRoute = AppInventoryImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AppRoute,
} as any)

const AppIntegrationsRoute = AppIntegrationsImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AppRoute,
} as any)

const AppFulfillmentRoute = AppFulfillmentImport.update({
  id: '/fulfillment',
  path: '/fulfillment',
  getParentRoute: () => AppRoute,
} as any)

const AppDashboardRoute = AppDashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)

const AppCatalogRoute = AppCatalogImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => AppRoute,
} as any)

const AppAuditRoute = AppAuditImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppRoute,
} as any)

const AppAccountRoute = AppAccountImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)

const AppTimeIndexRoute = AppTimeIndexImport.update({
  id: '/time/',
  path: '/time/',
  getParentRoute: () => AppRoute,
} as any)

const AppTicketsIndexRoute = AppTicketsIndexImport.update({
  id: '/tickets/',
  path: '/tickets/',
  getParentRoute: () => AppRoute,
} as any)

const AppShipmentsIndexRoute = AppShipmentsIndexImport.update({
  id: '/shipments/',
  path: '/shipments/',
  getParentRoute: () => AppRoute,
} as any)

const AppReturnOrdersIndexRoute = AppReturnOrdersIndexImport.update({
  id: '/return-orders/',
  path: '/return-orders/',
  getParentRoute: () => AppRoute,
} as any)

const AppReportsIndexRoute = AppReportsIndexImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AppRoute,
} as any)

const AppPurchaseOrdersIndexRoute = AppPurchaseOrdersIndexImport.update({
  id: '/purchase-orders/',
  path: '/purchase-orders/',
  getParentRoute: () => AppRoute,
} as any)

const AppProjectsIndexRoute = AppProjectsIndexImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)

const AppPartsIndexRoute = AppPartsIndexImport.update({
  id: '/parts/',
  path: '/parts/',
  getParentRoute: () => AppRoute,
} as any)

const AppNotificationsIndexRoute = AppNotificationsIndexImport.update({
  id: '/notifications/',
  path: '/notifications/',
  getParentRoute: () => AppRoute,
} as any)

const AppMovementsIndexRoute = AppMovementsIndexImport.update({
  id: '/movements/',
  path: '/movements/',
  getParentRoute: () => AppRoute,
} as any)

const AppLocationsIndexRoute = AppLocationsIndexImport.update({
  id: '/locations/',
  path: '/locations/',
  getParentRoute: () => AppRoute,
} as any)

const AppItemsIndexRoute = AppItemsIndexImport.update({
  id: '/items/',
  path: '/items/',
  getParentRoute: () => AppRoute,
} as any)

const AppIntegrationsIndexRoute = AppIntegrationsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppIntegrationsRoute,
} as any)

const AppFulfillmentsIndexRoute = AppFulfillmentsIndexImport.update({
  id: '/fulfillments/',
  path: '/fulfillments/',
  getParentRoute: () => AppRoute,
} as any)

const AppExchangesIndexRoute = AppExchangesIndexImport.update({
  id: '/exchanges/',
  path: '/exchanges/',
  getParentRoute: () => AppRoute,
} as any)

const AppExchangeIndexRoute = AppExchangeIndexImport.update({
  id: '/exchange/',
  path: '/exchange/',
  getParentRoute: () => AppRoute,
} as any)

const AppCustomersIndexRoute = AppCustomersIndexImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AppRoute,
} as any)

const AppCostsIndexRoute = AppCostsIndexImport.update({
  id: '/costs/',
  path: '/costs/',
  getParentRoute: () => AppRoute,
} as any)

const AppContactsIndexRoute = AppContactsIndexImport.update({
  id: '/contacts/',
  path: '/contacts/',
  getParentRoute: () => AppRoute,
} as any)

const AppCompaniesIndexRoute = AppCompaniesIndexImport.update({
  id: '/companies/',
  path: '/companies/',
  getParentRoute: () => AppRoute,
} as any)

const AppCatalogIndexRoute = AppCatalogIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCatalogRoute,
} as any)

const AppBillingIndexRoute = AppBillingIndexImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => AppRoute,
} as any)

const AppAssetsIndexRoute = AppAssetsIndexImport.update({
  id: '/assets/',
  path: '/assets/',
  getParentRoute: () => AppRoute,
} as any)

const AppAssembliesIndexRoute = AppAssembliesIndexImport.update({
  id: '/assemblies/',
  path: '/assemblies/',
  getParentRoute: () => AppRoute,
} as any)

const AppAccountingIndexRoute = AppAccountingIndexImport.update({
  id: '/accounting/',
  path: '/accounting/',
  getParentRoute: () => AppRoute,
} as any)

const AppTicketsTicketKeyRoute = AppTicketsTicketKeyImport.update({
  id: '/tickets/$ticketKey',
  path: '/tickets/$ticketKey',
  getParentRoute: () => AppRoute,
} as any)

const AppShipmentsShipmentKeyRoute = AppShipmentsShipmentKeyImport.update({
  id: '/shipments/$shipmentKey',
  path: '/shipments/$shipmentKey',
  getParentRoute: () => AppRoute,
} as any)

const AppReturnOrdersReturnOrderKeyRoute =
  AppReturnOrdersReturnOrderKeyImport.update({
    id: '/return-orders/$returnOrderKey',
    path: '/return-orders/$returnOrderKey',
    getParentRoute: () => AppRoute,
  } as any)

const AppReturnOrderReturnOrderKeyRoute =
  AppReturnOrderReturnOrderKeyImport.update({
    id: '/$returnOrderKey',
    path: '/$returnOrderKey',
    getParentRoute: () => AppReturnOrderRoute,
  } as any)

const AppReportsUpcomingProjectsRoute = AppReportsUpcomingProjectsImport.update(
  {
    id: '/reports/upcoming-projects',
    path: '/reports/upcoming-projects',
    getParentRoute: () => AppRoute,
  } as any,
)

const AppReportsUpcomingProjectStartsRoute =
  AppReportsUpcomingProjectStartsImport.update({
    id: '/reports/upcoming-project-starts',
    path: '/reports/upcoming-project-starts',
    getParentRoute: () => AppRoute,
  } as any)

const AppReportsUpcomingProjectCompletionsRoute =
  AppReportsUpcomingProjectCompletionsImport.update({
    id: '/reports/upcoming-project-completions',
    path: '/reports/upcoming-project-completions',
    getParentRoute: () => AppRoute,
  } as any)

const AppReportsTransitRoute = AppReportsTransitImport.update({
  id: '/reports/transit',
  path: '/reports/transit',
  getParentRoute: () => AppRoute,
} as any)

const AppReportsPastProjectsRoute = AppReportsPastProjectsImport.update({
  id: '/reports/past-projects',
  path: '/reports/past-projects',
  getParentRoute: () => AppRoute,
} as any)

const AppReportsInventoryRoute = AppReportsInventoryImport.update({
  id: '/reports/inventory',
  path: '/reports/inventory',
  getParentRoute: () => AppRoute,
} as any)

const AppReportsFulfillmentRoute = AppReportsFulfillmentImport.update({
  id: '/reports/fulfillment',
  path: '/reports/fulfillment',
  getParentRoute: () => AppRoute,
} as any)

const AppReportsFieldRoute = AppReportsFieldImport.update({
  id: '/reports/field',
  path: '/reports/field',
  getParentRoute: () => AppRoute,
} as any)

const AppReportsDepreciationScheduleRoute =
  AppReportsDepreciationScheduleImport.update({
    id: '/reports/depreciation-schedule',
    path: '/reports/depreciation-schedule',
    getParentRoute: () => AppRoute,
  } as any)

const AppReportsActiveProjectsRoute = AppReportsActiveProjectsImport.update({
  id: '/reports/active-projects',
  path: '/reports/active-projects',
  getParentRoute: () => AppRoute,
} as any)

const AppPurchaseOrdersPurchaseOrderKeyRoute =
  AppPurchaseOrdersPurchaseOrderKeyImport.update({
    id: '/purchase-orders/$purchaseOrderKey',
    path: '/purchase-orders/$purchaseOrderKey',
    getParentRoute: () => AppRoute,
  } as any)

const AppPurchaseOrderPurchaseOrderKeyRoute =
  AppPurchaseOrderPurchaseOrderKeyImport.update({
    id: '/$purchaseOrderKey',
    path: '/$purchaseOrderKey',
    getParentRoute: () => AppPurchaseOrderRoute,
  } as any)

const AppProjectsProjectKeyRoute = AppProjectsProjectKeyImport.update({
  id: '/projects/$projectKey',
  path: '/projects/$projectKey',
  getParentRoute: () => AppRoute,
} as any)

const AppNotificationsSubscriptionsRoute =
  AppNotificationsSubscriptionsImport.update({
    id: '/notifications/subscriptions',
    path: '/notifications/subscriptions',
    getParentRoute: () => AppRoute,
  } as any)

const AppLocationsLocationKeyRoute = AppLocationsLocationKeyImport.update({
  id: '/locations/$locationKey',
  path: '/locations/$locationKey',
  getParentRoute: () => AppRoute,
} as any)

const AppFulfillmentsFulfillmentKeyRoute =
  AppFulfillmentsFulfillmentKeyImport.update({
    id: '/fulfillments/$fulfillmentKey',
    path: '/fulfillments/$fulfillmentKey',
    getParentRoute: () => AppRoute,
  } as any)

const AppFulfillmentFulfillmentKeyRoute =
  AppFulfillmentFulfillmentKeyImport.update({
    id: '/$fulfillmentKey',
    path: '/$fulfillmentKey',
    getParentRoute: () => AppFulfillmentRoute,
  } as any)

const AppDashboardLocationRoute = AppDashboardLocationImport.update({
  id: '/location',
  path: '/location',
  getParentRoute: () => AppDashboardRoute,
} as any)

const AppDashboardCustomerRoute = AppDashboardCustomerImport.update({
  id: '/customer',
  path: '/customer',
  getParentRoute: () => AppDashboardRoute,
} as any)

const AppDashboardAssetRoute = AppDashboardAssetImport.update({
  id: '/asset',
  path: '/asset',
  getParentRoute: () => AppDashboardRoute,
} as any)

const AppCustomersCustomerKeyRoute = AppCustomersCustomerKeyImport.update({
  id: '/customers/$customerKey',
  path: '/customers/$customerKey',
  getParentRoute: () => AppRoute,
} as any)

const AppContactsContactKeyRoute = AppContactsContactKeyImport.update({
  id: '/contacts/$contactKey',
  path: '/contacts/$contactKey',
  getParentRoute: () => AppRoute,
} as any)

const AppCompaniesCompanyKeyRoute = AppCompaniesCompanyKeyImport.update({
  id: '/companies/$companyKey',
  path: '/companies/$companyKey',
  getParentRoute: () => AppRoute,
} as any)

const AppCatalogItemsRoute = AppCatalogItemsImport.update({
  id: '/items',
  path: '/items',
  getParentRoute: () => AppCatalogRoute,
} as any)

const AppBillingPlansRoute = AppBillingPlansImport.update({
  id: '/billing/plans',
  path: '/billing/plans',
  getParentRoute: () => AppRoute,
} as any)

const AppBillingLifecycleRoute = AppBillingLifecycleImport.update({
  id: '/billing/lifecycle',
  path: '/billing/lifecycle',
  getParentRoute: () => AppRoute,
} as any)

const AppBillingInvoiceLineItemsRoute = AppBillingInvoiceLineItemsImport.update(
  {
    id: '/billing/invoice-line-items',
    path: '/billing/invoice-line-items',
    getParentRoute: () => AppRoute,
  } as any,
)

const AppBillingChargesRoute = AppBillingChargesImport.update({
  id: '/billing/charges',
  path: '/billing/charges',
  getParentRoute: () => AppRoute,
} as any)

const AppBillingAgingRoute = AppBillingAgingImport.update({
  id: '/billing/aging',
  path: '/billing/aging',
  getParentRoute: () => AppRoute,
} as any)

const AppAssetsAssetKeyRoute = AppAssetsAssetKeyImport.update({
  id: '/assets/$assetKey',
  path: '/assets/$assetKey',
  getParentRoute: () => AppRoute,
} as any)

const AppAssembliesRegistrationStatusRoute =
  AppAssembliesRegistrationStatusImport.update({
    id: '/assemblies/$registrationStatus',
    path: '/assemblies/$registrationStatus',
    getParentRoute: () => AppRoute,
  } as any)

const AppAccountingPeriodReviewRoute = AppAccountingPeriodReviewImport.update({
  id: '/accounting/period-review',
  path: '/accounting/period-review',
  getParentRoute: () => AppRoute,
} as any)

const AppAccountingInitialTrueUpRoute = AppAccountingInitialTrueUpImport.update(
  {
    id: '/accounting/initial-true-up',
    path: '/accounting/initial-true-up',
    getParentRoute: () => AppRoute,
  } as any,
)

const AppAccountingCloseWorkflowRoute = AppAccountingCloseWorkflowImport.update(
  {
    id: '/accounting/close-workflow',
    path: '/accounting/close-workflow',
    getParentRoute: () => AppRoute,
  } as any,
)

const AppTicketsTicketKeyIndexRoute = AppTicketsTicketKeyIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTicketsTicketKeyRoute,
} as any)

const AppReturnOrdersReturnOrderKeyIndexRoute =
  AppReturnOrdersReturnOrderKeyIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppReturnOrdersReturnOrderKeyRoute,
  } as any)

const AppPurchaseOrdersPurchaseOrderKeyIndexRoute =
  AppPurchaseOrdersPurchaseOrderKeyIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppPurchaseOrdersPurchaseOrderKeyRoute,
  } as any)

const AppProjectsProjectKeyIndexRoute = AppProjectsProjectKeyIndexImport.update(
  {
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsProjectKeyRoute,
  } as any,
)

const AppLocationsLocationKeyIndexRoute =
  AppLocationsLocationKeyIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppLocationsLocationKeyRoute,
  } as any)

const AppItemsItemKeyIndexRoute = AppItemsItemKeyIndexImport.update({
  id: '/items/$itemKey/',
  path: '/items/$itemKey/',
  getParentRoute: () => AppRoute,
} as any)

const AppFulfillmentsFulfillmentKeyIndexRoute =
  AppFulfillmentsFulfillmentKeyIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppFulfillmentsFulfillmentKeyRoute,
  } as any)

const AppCustomersCustomerKeyIndexRoute =
  AppCustomersCustomerKeyIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCustomersCustomerKeyRoute,
  } as any)

const AppContactsContactKeyIndexRoute = AppContactsContactKeyIndexImport.update(
  {
    id: '/',
    path: '/',
    getParentRoute: () => AppContactsContactKeyRoute,
  } as any,
)

const AppCompaniesSuppliersIndexRoute = AppCompaniesSuppliersIndexImport.update(
  {
    id: '/companies/suppliers/',
    path: '/companies/suppliers/',
    getParentRoute: () => AppRoute,
  } as any,
)

const AppCompaniesCustomersIndexRoute = AppCompaniesCustomersIndexImport.update(
  {
    id: '/companies/customers/',
    path: '/companies/customers/',
    getParentRoute: () => AppRoute,
  } as any,
)

const AppCompaniesCompanyKeyIndexRoute =
  AppCompaniesCompanyKeyIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCompaniesCompanyKeyRoute,
  } as any)

const AppCatalogItemsIndexRoute = AppCatalogItemsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCatalogItemsRoute,
} as any)

const AppCatalogBundlesIndexRoute = AppCatalogBundlesIndexImport.update({
  id: '/bundles/',
  path: '/bundles/',
  getParentRoute: () => AppCatalogRoute,
} as any)

const AppBillingInvoicesIndexRoute = AppBillingInvoicesIndexImport.update({
  id: '/billing/invoices/',
  path: '/billing/invoices/',
  getParentRoute: () => AppRoute,
} as any)

const AppAssetsAssetKeyIndexRoute = AppAssetsAssetKeyIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAssetsAssetKeyRoute,
} as any)

const AppAccountingInitialTrueUpIndexRoute =
  AppAccountingInitialTrueUpIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAccountingInitialTrueUpRoute,
  } as any)

const AppTicketsTicketKeyAuditRoute = AppTicketsTicketKeyAuditImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppTicketsTicketKeyRoute,
} as any)

const AppTicketsTicketKeyAttachmentsRoute =
  AppTicketsTicketKeyAttachmentsImport.update({
    id: '/attachments',
    path: '/attachments',
    getParentRoute: () => AppTicketsTicketKeyRoute,
  } as any)

const AppReturnOrdersReturnOrderKeyShipmentsRoute =
  AppReturnOrdersReturnOrderKeyShipmentsImport.update({
    id: '/shipments',
    path: '/shipments',
    getParentRoute: () => AppReturnOrdersReturnOrderKeyRoute,
  } as any)

const AppReportsAssetSnapshotTabTypeRoute =
  AppReportsAssetSnapshotTabTypeImport.update({
    id: '/reports/asset-snapshot/$tabType',
    path: '/reports/asset-snapshot/$tabType',
    getParentRoute: () => AppRoute,
  } as any)

const AppReportsAssetRollforwardTabTypeRoute =
  AppReportsAssetRollforwardTabTypeImport.update({
    id: '/reports/asset-rollforward/$tabType',
    path: '/reports/asset-rollforward/$tabType',
    getParentRoute: () => AppRoute,
  } as any)

const AppReportsAssetBridgeTabTypeRoute =
  AppReportsAssetBridgeTabTypeImport.update({
    id: '/reports/asset-bridge/$tabType',
    path: '/reports/asset-bridge/$tabType',
    getParentRoute: () => AppRoute,
  } as any)

const AppPurchaseOrdersPurchaseOrderKeyShipmentsRoute =
  AppPurchaseOrdersPurchaseOrderKeyShipmentsImport.update({
    id: '/shipments',
    path: '/shipments',
    getParentRoute: () => AppPurchaseOrdersPurchaseOrderKeyRoute,
  } as any)

const AppProjectsProjectKeyTicketsRoute =
  AppProjectsProjectKeyTicketsImport.update({
    id: '/tickets',
    path: '/tickets',
    getParentRoute: () => AppProjectsProjectKeyRoute,
  } as any)

const AppProjectsProjectKeyNotesRoute = AppProjectsProjectKeyNotesImport.update(
  {
    id: '/notes',
    path: '/notes',
    getParentRoute: () => AppProjectsProjectKeyRoute,
  } as any,
)

const AppProjectsProjectKeyMembersRoute =
  AppProjectsProjectKeyMembersImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AppProjectsProjectKeyRoute,
  } as any)

const AppProjectsProjectKeyFulfillmentRoute =
  AppProjectsProjectKeyFulfillmentImport.update({
    id: '/fulfillment',
    path: '/fulfillment',
    getParentRoute: () => AppProjectsProjectKeyRoute,
  } as any)

const AppProjectsProjectKeyCostsRoute = AppProjectsProjectKeyCostsImport.update(
  {
    id: '/costs',
    path: '/costs',
    getParentRoute: () => AppProjectsProjectKeyRoute,
  } as any,
)

const AppProjectsProjectKeyBillingDetailsRoute =
  AppProjectsProjectKeyBillingDetailsImport.update({
    id: '/billing-details',
    path: '/billing-details',
    getParentRoute: () => AppProjectsProjectKeyRoute,
  } as any)

const AppProjectsProjectKeyAuditRoute = AppProjectsProjectKeyAuditImport.update(
  {
    id: '/audit',
    path: '/audit',
    getParentRoute: () => AppProjectsProjectKeyRoute,
  } as any,
)

const AppProjectsProjectKeyAttachmentsRoute =
  AppProjectsProjectKeyAttachmentsImport.update({
    id: '/attachments',
    path: '/attachments',
    getParentRoute: () => AppProjectsProjectKeyRoute,
  } as any)

const AppLocationsLocationKeyRelatedShipmentsRoute =
  AppLocationsLocationKeyRelatedShipmentsImport.update({
    id: '/related-shipments',
    path: '/related-shipments',
    getParentRoute: () => AppLocationsLocationKeyRoute,
  } as any)

const AppLocationsLocationKeyRelatedProjectsRoute =
  AppLocationsLocationKeyRelatedProjectsImport.update({
    id: '/related-projects',
    path: '/related-projects',
    getParentRoute: () => AppLocationsLocationKeyRoute,
  } as any)

const AppLocationsLocationKeyRelatedAssetsRoute =
  AppLocationsLocationKeyRelatedAssetsImport.update({
    id: '/related-assets',
    path: '/related-assets',
    getParentRoute: () => AppLocationsLocationKeyRoute,
  } as any)

const AppLocationsLocationKeyAuditRoute =
  AppLocationsLocationKeyAuditImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => AppLocationsLocationKeyRoute,
  } as any)

const AppItemsItemKeyUnitsRoute = AppItemsItemKeyUnitsImport.update({
  id: '/items/$itemKey/units',
  path: '/items/$itemKey/units',
  getParentRoute: () => AppRoute,
} as any)

const AppItemsItemKeyPricingRoute = AppItemsItemKeyPricingImport.update({
  id: '/items/$itemKey/pricing',
  path: '/items/$itemKey/pricing',
  getParentRoute: () => AppRoute,
} as any)

const AppItemsItemKeyMovementRoute = AppItemsItemKeyMovementImport.update({
  id: '/items/$itemKey/movement',
  path: '/items/$itemKey/movement',
  getParentRoute: () => AppRoute,
} as any)

const AppItemsItemKeyBomRoute = AppItemsItemKeyBomImport.update({
  id: '/items/$itemKey/bom',
  path: '/items/$itemKey/bom',
  getParentRoute: () => AppRoute,
} as any)

const AppItemsItemKeyAuditRoute = AppItemsItemKeyAuditImport.update({
  id: '/items/$itemKey/audit',
  path: '/items/$itemKey/audit',
  getParentRoute: () => AppRoute,
} as any)

const AppItemsItemKeyAssetsRoute = AppItemsItemKeyAssetsImport.update({
  id: '/items/$itemKey/assets',
  path: '/items/$itemKey/assets',
  getParentRoute: () => AppRoute,
} as any)

const AppItemsItemKeyAccountingRoute = AppItemsItemKeyAccountingImport.update({
  id: '/items/$itemKey/accounting',
  path: '/items/$itemKey/accounting',
  getParentRoute: () => AppRoute,
} as any)

const AppIntegrationsTriageItemsRoute = AppIntegrationsTriageItemsImport.update(
  {
    id: '/triage/items',
    path: '/triage/items',
    getParentRoute: () => AppIntegrationsRoute,
  } as any,
)

const AppIntegrationsTriageCustomersRoute =
  AppIntegrationsTriageCustomersImport.update({
    id: '/triage/customers',
    path: '/triage/customers',
    getParentRoute: () => AppIntegrationsRoute,
  } as any)

const AppFulfillmentsFulfillmentKeyShipmentsRoute =
  AppFulfillmentsFulfillmentKeyShipmentsImport.update({
    id: '/shipments',
    path: '/shipments',
    getParentRoute: () => AppFulfillmentsFulfillmentKeyRoute,
  } as any)

const AppCustomersCustomerKeyProjectsRoute =
  AppCustomersCustomerKeyProjectsImport.update({
    id: '/projects',
    path: '/projects',
    getParentRoute: () => AppCustomersCustomerKeyRoute,
  } as any)

const AppCustomersCustomerKeyOwnedAssetsRoute =
  AppCustomersCustomerKeyOwnedAssetsImport.update({
    id: '/owned-assets',
    path: '/owned-assets',
    getParentRoute: () => AppCustomersCustomerKeyRoute,
  } as any)

const AppCustomersCustomerKeyLocationsRoute =
  AppCustomersCustomerKeyLocationsImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => AppCustomersCustomerKeyRoute,
  } as any)

const AppCustomersCustomerKeyLocationAssetsRoute =
  AppCustomersCustomerKeyLocationAssetsImport.update({
    id: '/location-assets',
    path: '/location-assets',
    getParentRoute: () => AppCustomersCustomerKeyRoute,
  } as any)

const AppCustomersCustomerKeyFulfillmentRoute =
  AppCustomersCustomerKeyFulfillmentImport.update({
    id: '/fulfillment',
    path: '/fulfillment',
    getParentRoute: () => AppCustomersCustomerKeyRoute,
  } as any)

const AppCustomersCustomerKeyAuditRoute =
  AppCustomersCustomerKeyAuditImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => AppCustomersCustomerKeyRoute,
  } as any)

const AppContactsContactKeyAuditRoute = AppContactsContactKeyAuditImport.update(
  {
    id: '/audit',
    path: '/audit',
    getParentRoute: () => AppContactsContactKeyRoute,
  } as any,
)

const AppCompaniesCompanyKeyProjectsRoute =
  AppCompaniesCompanyKeyProjectsImport.update({
    id: '/projects',
    path: '/projects',
    getParentRoute: () => AppCompaniesCompanyKeyRoute,
  } as any)

const AppCompaniesCompanyKeyOwnedAssetsRoute =
  AppCompaniesCompanyKeyOwnedAssetsImport.update({
    id: '/owned-assets',
    path: '/owned-assets',
    getParentRoute: () => AppCompaniesCompanyKeyRoute,
  } as any)

const AppCompaniesCompanyKeyLocationsRoute =
  AppCompaniesCompanyKeyLocationsImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => AppCompaniesCompanyKeyRoute,
  } as any)

const AppCompaniesCompanyKeyLocationAssetsRoute =
  AppCompaniesCompanyKeyLocationAssetsImport.update({
    id: '/location-assets',
    path: '/location-assets',
    getParentRoute: () => AppCompaniesCompanyKeyRoute,
  } as any)

const AppCompaniesCompanyKeyFulfillmentRoute =
  AppCompaniesCompanyKeyFulfillmentImport.update({
    id: '/fulfillment',
    path: '/fulfillment',
    getParentRoute: () => AppCompaniesCompanyKeyRoute,
  } as any)

const AppCompaniesCompanyKeyContactsRoute =
  AppCompaniesCompanyKeyContactsImport.update({
    id: '/contacts',
    path: '/contacts',
    getParentRoute: () => AppCompaniesCompanyKeyRoute,
  } as any)

const AppCompaniesCompanyKeyAuditRoute =
  AppCompaniesCompanyKeyAuditImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => AppCompaniesCompanyKeyRoute,
  } as any)

const AppCatalogItemsItemKeyRoute = AppCatalogItemsItemKeyImport.update({
  id: '/$itemKey',
  path: '/$itemKey',
  getParentRoute: () => AppCatalogItemsRoute,
} as any)

const AppCatalogBundlesBundleKeyRoute = AppCatalogBundlesBundleKeyImport.update(
  {
    id: '/bundles/$bundleKey',
    path: '/bundles/$bundleKey',
    getParentRoute: () => AppCatalogRoute,
  } as any,
)

const AppBillingInvoicesInvoiceKeyRoute =
  AppBillingInvoicesInvoiceKeyImport.update({
    id: '/billing/invoices/$invoiceKey',
    path: '/billing/invoices/$invoiceKey',
    getParentRoute: () => AppRoute,
  } as any)

const AppAssetsAssetKeyTicketsRoute = AppAssetsAssetKeyTicketsImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => AppAssetsAssetKeyRoute,
} as any)

const AppAssetsAssetKeyMetadataRoute = AppAssetsAssetKeyMetadataImport.update({
  id: '/metadata',
  path: '/metadata',
  getParentRoute: () => AppAssetsAssetKeyRoute,
} as any)

const AppAssetsAssetKeyAuditRoute = AppAssetsAssetKeyAuditImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppAssetsAssetKeyRoute,
} as any)

const AppAssetsAssetKeyAttachmentsRoute =
  AppAssetsAssetKeyAttachmentsImport.update({
    id: '/attachments',
    path: '/attachments',
    getParentRoute: () => AppAssetsAssetKeyRoute,
  } as any)

const AppAssetsAssetKeyAccountingRoute =
  AppAssetsAssetKeyAccountingImport.update({
    id: '/accounting',
    path: '/accounting',
    getParentRoute: () => AppAssetsAssetKeyRoute,
  } as any)

const AppAccountingInitialTrueUpIsoRoute =
  AppAccountingInitialTrueUpIsoImport.update({
    id: '/$iso',
    path: '/$iso',
    getParentRoute: () => AppAccountingInitialTrueUpRoute,
  } as any)

const AppCatalogItemsItemKeyIndexRoute =
  AppCatalogItemsItemKeyIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCatalogItemsItemKeyRoute,
  } as any)

const AppCatalogBundlesBundleKeyIndexRoute =
  AppCatalogBundlesBundleKeyIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCatalogBundlesBundleKeyRoute,
  } as any)

const AppReportsExceptionAssetTabTypeRoute =
  AppReportsExceptionAssetTabTypeImport.update({
    id: '/reports/exception/asset/$tabType',
    path: '/reports/exception/asset/$tabType',
    getParentRoute: () => AppRoute,
  } as any)

const AppCatalogItemsItemKeyUnitsRoute =
  AppCatalogItemsItemKeyUnitsImport.update({
    id: '/units',
    path: '/units',
    getParentRoute: () => AppCatalogItemsItemKeyRoute,
  } as any)

const AppCatalogItemsItemKeyPricingRoute =
  AppCatalogItemsItemKeyPricingImport.update({
    id: '/pricing',
    path: '/pricing',
    getParentRoute: () => AppCatalogItemsItemKeyRoute,
  } as any)

const AppCatalogItemsItemKeyMovementRoute =
  AppCatalogItemsItemKeyMovementImport.update({
    id: '/movement',
    path: '/movement',
    getParentRoute: () => AppCatalogItemsItemKeyRoute,
  } as any)

const AppCatalogItemsItemKeyBomRoute = AppCatalogItemsItemKeyBomImport.update({
  id: '/bom',
  path: '/bom',
  getParentRoute: () => AppCatalogItemsItemKeyRoute,
} as any)

const AppCatalogItemsItemKeyAuditRoute =
  AppCatalogItemsItemKeyAuditImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => AppCatalogItemsItemKeyRoute,
  } as any)

const AppCatalogItemsItemKeyAssetsRoute =
  AppCatalogItemsItemKeyAssetsImport.update({
    id: '/assets',
    path: '/assets',
    getParentRoute: () => AppCatalogItemsItemKeyRoute,
  } as any)

const AppCatalogItemsItemKeyAccountingRoute =
  AppCatalogItemsItemKeyAccountingImport.update({
    id: '/accounting',
    path: '/accounting',
    getParentRoute: () => AppCatalogItemsItemKeyRoute,
  } as any)

const AppCatalogBundlesBundleKeyAuditRoute =
  AppCatalogBundlesBundleKeyAuditImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => AppCatalogBundlesBundleKeyRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterImport
      parentRoute: typeof rootRoute
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountImport
      parentRoute: typeof AppImport
    }
    '/_app/audit': {
      id: '/_app/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AppAuditImport
      parentRoute: typeof AppImport
    }
    '/_app/catalog': {
      id: '/_app/catalog'
      path: '/catalog'
      fullPath: '/catalog'
      preLoaderRoute: typeof AppCatalogImport
      parentRoute: typeof AppImport
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardImport
      parentRoute: typeof AppImport
    }
    '/_app/fulfillment': {
      id: '/_app/fulfillment'
      path: '/fulfillment'
      fullPath: '/fulfillment'
      preLoaderRoute: typeof AppFulfillmentImport
      parentRoute: typeof AppImport
    }
    '/_app/integrations': {
      id: '/_app/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AppIntegrationsImport
      parentRoute: typeof AppImport
    }
    '/_app/inventory': {
      id: '/_app/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof AppInventoryImport
      parentRoute: typeof AppImport
    }
    '/_app/organization': {
      id: '/_app/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof AppOrganizationImport
      parentRoute: typeof AppImport
    }
    '/_app/purchase-order': {
      id: '/_app/purchase-order'
      path: '/purchase-order'
      fullPath: '/purchase-order'
      preLoaderRoute: typeof AppPurchaseOrderImport
      parentRoute: typeof AppImport
    }
    '/_app/return-order': {
      id: '/_app/return-order'
      path: '/return-order'
      fullPath: '/return-order'
      preLoaderRoute: typeof AppReturnOrderImport
      parentRoute: typeof AppImport
    }
    '/_app/accounting/close-workflow': {
      id: '/_app/accounting/close-workflow'
      path: '/accounting/close-workflow'
      fullPath: '/accounting/close-workflow'
      preLoaderRoute: typeof AppAccountingCloseWorkflowImport
      parentRoute: typeof AppImport
    }
    '/_app/accounting/initial-true-up': {
      id: '/_app/accounting/initial-true-up'
      path: '/accounting/initial-true-up'
      fullPath: '/accounting/initial-true-up'
      preLoaderRoute: typeof AppAccountingInitialTrueUpImport
      parentRoute: typeof AppImport
    }
    '/_app/accounting/period-review': {
      id: '/_app/accounting/period-review'
      path: '/accounting/period-review'
      fullPath: '/accounting/period-review'
      preLoaderRoute: typeof AppAccountingPeriodReviewImport
      parentRoute: typeof AppImport
    }
    '/_app/assemblies/$registrationStatus': {
      id: '/_app/assemblies/$registrationStatus'
      path: '/assemblies/$registrationStatus'
      fullPath: '/assemblies/$registrationStatus'
      preLoaderRoute: typeof AppAssembliesRegistrationStatusImport
      parentRoute: typeof AppImport
    }
    '/_app/assets/$assetKey': {
      id: '/_app/assets/$assetKey'
      path: '/assets/$assetKey'
      fullPath: '/assets/$assetKey'
      preLoaderRoute: typeof AppAssetsAssetKeyImport
      parentRoute: typeof AppImport
    }
    '/_app/billing/aging': {
      id: '/_app/billing/aging'
      path: '/billing/aging'
      fullPath: '/billing/aging'
      preLoaderRoute: typeof AppBillingAgingImport
      parentRoute: typeof AppImport
    }
    '/_app/billing/charges': {
      id: '/_app/billing/charges'
      path: '/billing/charges'
      fullPath: '/billing/charges'
      preLoaderRoute: typeof AppBillingChargesImport
      parentRoute: typeof AppImport
    }
    '/_app/billing/invoice-line-items': {
      id: '/_app/billing/invoice-line-items'
      path: '/billing/invoice-line-items'
      fullPath: '/billing/invoice-line-items'
      preLoaderRoute: typeof AppBillingInvoiceLineItemsImport
      parentRoute: typeof AppImport
    }
    '/_app/billing/lifecycle': {
      id: '/_app/billing/lifecycle'
      path: '/billing/lifecycle'
      fullPath: '/billing/lifecycle'
      preLoaderRoute: typeof AppBillingLifecycleImport
      parentRoute: typeof AppImport
    }
    '/_app/billing/plans': {
      id: '/_app/billing/plans'
      path: '/billing/plans'
      fullPath: '/billing/plans'
      preLoaderRoute: typeof AppBillingPlansImport
      parentRoute: typeof AppImport
    }
    '/_app/catalog/items': {
      id: '/_app/catalog/items'
      path: '/items'
      fullPath: '/catalog/items'
      preLoaderRoute: typeof AppCatalogItemsImport
      parentRoute: typeof AppCatalogImport
    }
    '/_app/companies/$companyKey': {
      id: '/_app/companies/$companyKey'
      path: '/companies/$companyKey'
      fullPath: '/companies/$companyKey'
      preLoaderRoute: typeof AppCompaniesCompanyKeyImport
      parentRoute: typeof AppImport
    }
    '/_app/contacts/$contactKey': {
      id: '/_app/contacts/$contactKey'
      path: '/contacts/$contactKey'
      fullPath: '/contacts/$contactKey'
      preLoaderRoute: typeof AppContactsContactKeyImport
      parentRoute: typeof AppImport
    }
    '/_app/customers/$customerKey': {
      id: '/_app/customers/$customerKey'
      path: '/customers/$customerKey'
      fullPath: '/customers/$customerKey'
      preLoaderRoute: typeof AppCustomersCustomerKeyImport
      parentRoute: typeof AppImport
    }
    '/_app/dashboard/asset': {
      id: '/_app/dashboard/asset'
      path: '/asset'
      fullPath: '/dashboard/asset'
      preLoaderRoute: typeof AppDashboardAssetImport
      parentRoute: typeof AppDashboardImport
    }
    '/_app/dashboard/customer': {
      id: '/_app/dashboard/customer'
      path: '/customer'
      fullPath: '/dashboard/customer'
      preLoaderRoute: typeof AppDashboardCustomerImport
      parentRoute: typeof AppDashboardImport
    }
    '/_app/dashboard/location': {
      id: '/_app/dashboard/location'
      path: '/location'
      fullPath: '/dashboard/location'
      preLoaderRoute: typeof AppDashboardLocationImport
      parentRoute: typeof AppDashboardImport
    }
    '/_app/fulfillment/$fulfillmentKey': {
      id: '/_app/fulfillment/$fulfillmentKey'
      path: '/$fulfillmentKey'
      fullPath: '/fulfillment/$fulfillmentKey'
      preLoaderRoute: typeof AppFulfillmentFulfillmentKeyImport
      parentRoute: typeof AppFulfillmentImport
    }
    '/_app/fulfillments/$fulfillmentKey': {
      id: '/_app/fulfillments/$fulfillmentKey'
      path: '/fulfillments/$fulfillmentKey'
      fullPath: '/fulfillments/$fulfillmentKey'
      preLoaderRoute: typeof AppFulfillmentsFulfillmentKeyImport
      parentRoute: typeof AppImport
    }
    '/_app/locations/$locationKey': {
      id: '/_app/locations/$locationKey'
      path: '/locations/$locationKey'
      fullPath: '/locations/$locationKey'
      preLoaderRoute: typeof AppLocationsLocationKeyImport
      parentRoute: typeof AppImport
    }
    '/_app/notifications/subscriptions': {
      id: '/_app/notifications/subscriptions'
      path: '/notifications/subscriptions'
      fullPath: '/notifications/subscriptions'
      preLoaderRoute: typeof AppNotificationsSubscriptionsImport
      parentRoute: typeof AppImport
    }
    '/_app/projects/$projectKey': {
      id: '/_app/projects/$projectKey'
      path: '/projects/$projectKey'
      fullPath: '/projects/$projectKey'
      preLoaderRoute: typeof AppProjectsProjectKeyImport
      parentRoute: typeof AppImport
    }
    '/_app/purchase-order/$purchaseOrderKey': {
      id: '/_app/purchase-order/$purchaseOrderKey'
      path: '/$purchaseOrderKey'
      fullPath: '/purchase-order/$purchaseOrderKey'
      preLoaderRoute: typeof AppPurchaseOrderPurchaseOrderKeyImport
      parentRoute: typeof AppPurchaseOrderImport
    }
    '/_app/purchase-orders/$purchaseOrderKey': {
      id: '/_app/purchase-orders/$purchaseOrderKey'
      path: '/purchase-orders/$purchaseOrderKey'
      fullPath: '/purchase-orders/$purchaseOrderKey'
      preLoaderRoute: typeof AppPurchaseOrdersPurchaseOrderKeyImport
      parentRoute: typeof AppImport
    }
    '/_app/reports/active-projects': {
      id: '/_app/reports/active-projects'
      path: '/reports/active-projects'
      fullPath: '/reports/active-projects'
      preLoaderRoute: typeof AppReportsActiveProjectsImport
      parentRoute: typeof AppImport
    }
    '/_app/reports/depreciation-schedule': {
      id: '/_app/reports/depreciation-schedule'
      path: '/reports/depreciation-schedule'
      fullPath: '/reports/depreciation-schedule'
      preLoaderRoute: typeof AppReportsDepreciationScheduleImport
      parentRoute: typeof AppImport
    }
    '/_app/reports/field': {
      id: '/_app/reports/field'
      path: '/reports/field'
      fullPath: '/reports/field'
      preLoaderRoute: typeof AppReportsFieldImport
      parentRoute: typeof AppImport
    }
    '/_app/reports/fulfillment': {
      id: '/_app/reports/fulfillment'
      path: '/reports/fulfillment'
      fullPath: '/reports/fulfillment'
      preLoaderRoute: typeof AppReportsFulfillmentImport
      parentRoute: typeof AppImport
    }
    '/_app/reports/inventory': {
      id: '/_app/reports/inventory'
      path: '/reports/inventory'
      fullPath: '/reports/inventory'
      preLoaderRoute: typeof AppReportsInventoryImport
      parentRoute: typeof AppImport
    }
    '/_app/reports/past-projects': {
      id: '/_app/reports/past-projects'
      path: '/reports/past-projects'
      fullPath: '/reports/past-projects'
      preLoaderRoute: typeof AppReportsPastProjectsImport
      parentRoute: typeof AppImport
    }
    '/_app/reports/transit': {
      id: '/_app/reports/transit'
      path: '/reports/transit'
      fullPath: '/reports/transit'
      preLoaderRoute: typeof AppReportsTransitImport
      parentRoute: typeof AppImport
    }
    '/_app/reports/upcoming-project-completions': {
      id: '/_app/reports/upcoming-project-completions'
      path: '/reports/upcoming-project-completions'
      fullPath: '/reports/upcoming-project-completions'
      preLoaderRoute: typeof AppReportsUpcomingProjectCompletionsImport
      parentRoute: typeof AppImport
    }
    '/_app/reports/upcoming-project-starts': {
      id: '/_app/reports/upcoming-project-starts'
      path: '/reports/upcoming-project-starts'
      fullPath: '/reports/upcoming-project-starts'
      preLoaderRoute: typeof AppReportsUpcomingProjectStartsImport
      parentRoute: typeof AppImport
    }
    '/_app/reports/upcoming-projects': {
      id: '/_app/reports/upcoming-projects'
      path: '/reports/upcoming-projects'
      fullPath: '/reports/upcoming-projects'
      preLoaderRoute: typeof AppReportsUpcomingProjectsImport
      parentRoute: typeof AppImport
    }
    '/_app/return-order/$returnOrderKey': {
      id: '/_app/return-order/$returnOrderKey'
      path: '/$returnOrderKey'
      fullPath: '/return-order/$returnOrderKey'
      preLoaderRoute: typeof AppReturnOrderReturnOrderKeyImport
      parentRoute: typeof AppReturnOrderImport
    }
    '/_app/return-orders/$returnOrderKey': {
      id: '/_app/return-orders/$returnOrderKey'
      path: '/return-orders/$returnOrderKey'
      fullPath: '/return-orders/$returnOrderKey'
      preLoaderRoute: typeof AppReturnOrdersReturnOrderKeyImport
      parentRoute: typeof AppImport
    }
    '/_app/shipments/$shipmentKey': {
      id: '/_app/shipments/$shipmentKey'
      path: '/shipments/$shipmentKey'
      fullPath: '/shipments/$shipmentKey'
      preLoaderRoute: typeof AppShipmentsShipmentKeyImport
      parentRoute: typeof AppImport
    }
    '/_app/tickets/$ticketKey': {
      id: '/_app/tickets/$ticketKey'
      path: '/tickets/$ticketKey'
      fullPath: '/tickets/$ticketKey'
      preLoaderRoute: typeof AppTicketsTicketKeyImport
      parentRoute: typeof AppImport
    }
    '/_app/accounting/': {
      id: '/_app/accounting/'
      path: '/accounting'
      fullPath: '/accounting'
      preLoaderRoute: typeof AppAccountingIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/assemblies/': {
      id: '/_app/assemblies/'
      path: '/assemblies'
      fullPath: '/assemblies'
      preLoaderRoute: typeof AppAssembliesIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/assets/': {
      id: '/_app/assets/'
      path: '/assets'
      fullPath: '/assets'
      preLoaderRoute: typeof AppAssetsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/billing/': {
      id: '/_app/billing/'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AppBillingIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/catalog/': {
      id: '/_app/catalog/'
      path: '/'
      fullPath: '/catalog/'
      preLoaderRoute: typeof AppCatalogIndexImport
      parentRoute: typeof AppCatalogImport
    }
    '/_app/companies/': {
      id: '/_app/companies/'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof AppCompaniesIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/contacts/': {
      id: '/_app/contacts/'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof AppContactsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/costs/': {
      id: '/_app/costs/'
      path: '/costs'
      fullPath: '/costs'
      preLoaderRoute: typeof AppCostsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/customers/': {
      id: '/_app/customers/'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AppCustomersIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/exchange/': {
      id: '/_app/exchange/'
      path: '/exchange'
      fullPath: '/exchange'
      preLoaderRoute: typeof AppExchangeIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/exchanges/': {
      id: '/_app/exchanges/'
      path: '/exchanges'
      fullPath: '/exchanges'
      preLoaderRoute: typeof AppExchangesIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/fulfillments/': {
      id: '/_app/fulfillments/'
      path: '/fulfillments'
      fullPath: '/fulfillments'
      preLoaderRoute: typeof AppFulfillmentsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/integrations/': {
      id: '/_app/integrations/'
      path: '/'
      fullPath: '/integrations/'
      preLoaderRoute: typeof AppIntegrationsIndexImport
      parentRoute: typeof AppIntegrationsImport
    }
    '/_app/items/': {
      id: '/_app/items/'
      path: '/items'
      fullPath: '/items'
      preLoaderRoute: typeof AppItemsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/locations/': {
      id: '/_app/locations/'
      path: '/locations'
      fullPath: '/locations'
      preLoaderRoute: typeof AppLocationsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/movements/': {
      id: '/_app/movements/'
      path: '/movements'
      fullPath: '/movements'
      preLoaderRoute: typeof AppMovementsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/notifications/': {
      id: '/_app/notifications/'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/parts/': {
      id: '/_app/parts/'
      path: '/parts'
      fullPath: '/parts'
      preLoaderRoute: typeof AppPartsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof AppProjectsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/purchase-orders/': {
      id: '/_app/purchase-orders/'
      path: '/purchase-orders'
      fullPath: '/purchase-orders'
      preLoaderRoute: typeof AppPurchaseOrdersIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/reports/': {
      id: '/_app/reports/'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/return-orders/': {
      id: '/_app/return-orders/'
      path: '/return-orders'
      fullPath: '/return-orders'
      preLoaderRoute: typeof AppReturnOrdersIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/shipments/': {
      id: '/_app/shipments/'
      path: '/shipments'
      fullPath: '/shipments'
      preLoaderRoute: typeof AppShipmentsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/tickets/': {
      id: '/_app/tickets/'
      path: '/tickets'
      fullPath: '/tickets'
      preLoaderRoute: typeof AppTicketsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/time/': {
      id: '/_app/time/'
      path: '/time'
      fullPath: '/time'
      preLoaderRoute: typeof AppTimeIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/accounting/initial-true-up/$iso': {
      id: '/_app/accounting/initial-true-up/$iso'
      path: '/$iso'
      fullPath: '/accounting/initial-true-up/$iso'
      preLoaderRoute: typeof AppAccountingInitialTrueUpIsoImport
      parentRoute: typeof AppAccountingInitialTrueUpImport
    }
    '/_app/assets/$assetKey/accounting': {
      id: '/_app/assets/$assetKey/accounting'
      path: '/accounting'
      fullPath: '/assets/$assetKey/accounting'
      preLoaderRoute: typeof AppAssetsAssetKeyAccountingImport
      parentRoute: typeof AppAssetsAssetKeyImport
    }
    '/_app/assets/$assetKey/attachments': {
      id: '/_app/assets/$assetKey/attachments'
      path: '/attachments'
      fullPath: '/assets/$assetKey/attachments'
      preLoaderRoute: typeof AppAssetsAssetKeyAttachmentsImport
      parentRoute: typeof AppAssetsAssetKeyImport
    }
    '/_app/assets/$assetKey/audit': {
      id: '/_app/assets/$assetKey/audit'
      path: '/audit'
      fullPath: '/assets/$assetKey/audit'
      preLoaderRoute: typeof AppAssetsAssetKeyAuditImport
      parentRoute: typeof AppAssetsAssetKeyImport
    }
    '/_app/assets/$assetKey/metadata': {
      id: '/_app/assets/$assetKey/metadata'
      path: '/metadata'
      fullPath: '/assets/$assetKey/metadata'
      preLoaderRoute: typeof AppAssetsAssetKeyMetadataImport
      parentRoute: typeof AppAssetsAssetKeyImport
    }
    '/_app/assets/$assetKey/tickets': {
      id: '/_app/assets/$assetKey/tickets'
      path: '/tickets'
      fullPath: '/assets/$assetKey/tickets'
      preLoaderRoute: typeof AppAssetsAssetKeyTicketsImport
      parentRoute: typeof AppAssetsAssetKeyImport
    }
    '/_app/billing/invoices/$invoiceKey': {
      id: '/_app/billing/invoices/$invoiceKey'
      path: '/billing/invoices/$invoiceKey'
      fullPath: '/billing/invoices/$invoiceKey'
      preLoaderRoute: typeof AppBillingInvoicesInvoiceKeyImport
      parentRoute: typeof AppImport
    }
    '/_app/catalog/bundles/$bundleKey': {
      id: '/_app/catalog/bundles/$bundleKey'
      path: '/bundles/$bundleKey'
      fullPath: '/catalog/bundles/$bundleKey'
      preLoaderRoute: typeof AppCatalogBundlesBundleKeyImport
      parentRoute: typeof AppCatalogImport
    }
    '/_app/catalog/items/$itemKey': {
      id: '/_app/catalog/items/$itemKey'
      path: '/$itemKey'
      fullPath: '/catalog/items/$itemKey'
      preLoaderRoute: typeof AppCatalogItemsItemKeyImport
      parentRoute: typeof AppCatalogItemsImport
    }
    '/_app/companies/$companyKey/audit': {
      id: '/_app/companies/$companyKey/audit'
      path: '/audit'
      fullPath: '/companies/$companyKey/audit'
      preLoaderRoute: typeof AppCompaniesCompanyKeyAuditImport
      parentRoute: typeof AppCompaniesCompanyKeyImport
    }
    '/_app/companies/$companyKey/contacts': {
      id: '/_app/companies/$companyKey/contacts'
      path: '/contacts'
      fullPath: '/companies/$companyKey/contacts'
      preLoaderRoute: typeof AppCompaniesCompanyKeyContactsImport
      parentRoute: typeof AppCompaniesCompanyKeyImport
    }
    '/_app/companies/$companyKey/fulfillment': {
      id: '/_app/companies/$companyKey/fulfillment'
      path: '/fulfillment'
      fullPath: '/companies/$companyKey/fulfillment'
      preLoaderRoute: typeof AppCompaniesCompanyKeyFulfillmentImport
      parentRoute: typeof AppCompaniesCompanyKeyImport
    }
    '/_app/companies/$companyKey/location-assets': {
      id: '/_app/companies/$companyKey/location-assets'
      path: '/location-assets'
      fullPath: '/companies/$companyKey/location-assets'
      preLoaderRoute: typeof AppCompaniesCompanyKeyLocationAssetsImport
      parentRoute: typeof AppCompaniesCompanyKeyImport
    }
    '/_app/companies/$companyKey/locations': {
      id: '/_app/companies/$companyKey/locations'
      path: '/locations'
      fullPath: '/companies/$companyKey/locations'
      preLoaderRoute: typeof AppCompaniesCompanyKeyLocationsImport
      parentRoute: typeof AppCompaniesCompanyKeyImport
    }
    '/_app/companies/$companyKey/owned-assets': {
      id: '/_app/companies/$companyKey/owned-assets'
      path: '/owned-assets'
      fullPath: '/companies/$companyKey/owned-assets'
      preLoaderRoute: typeof AppCompaniesCompanyKeyOwnedAssetsImport
      parentRoute: typeof AppCompaniesCompanyKeyImport
    }
    '/_app/companies/$companyKey/projects': {
      id: '/_app/companies/$companyKey/projects'
      path: '/projects'
      fullPath: '/companies/$companyKey/projects'
      preLoaderRoute: typeof AppCompaniesCompanyKeyProjectsImport
      parentRoute: typeof AppCompaniesCompanyKeyImport
    }
    '/_app/contacts/$contactKey/audit': {
      id: '/_app/contacts/$contactKey/audit'
      path: '/audit'
      fullPath: '/contacts/$contactKey/audit'
      preLoaderRoute: typeof AppContactsContactKeyAuditImport
      parentRoute: typeof AppContactsContactKeyImport
    }
    '/_app/customers/$customerKey/audit': {
      id: '/_app/customers/$customerKey/audit'
      path: '/audit'
      fullPath: '/customers/$customerKey/audit'
      preLoaderRoute: typeof AppCustomersCustomerKeyAuditImport
      parentRoute: typeof AppCustomersCustomerKeyImport
    }
    '/_app/customers/$customerKey/fulfillment': {
      id: '/_app/customers/$customerKey/fulfillment'
      path: '/fulfillment'
      fullPath: '/customers/$customerKey/fulfillment'
      preLoaderRoute: typeof AppCustomersCustomerKeyFulfillmentImport
      parentRoute: typeof AppCustomersCustomerKeyImport
    }
    '/_app/customers/$customerKey/location-assets': {
      id: '/_app/customers/$customerKey/location-assets'
      path: '/location-assets'
      fullPath: '/customers/$customerKey/location-assets'
      preLoaderRoute: typeof AppCustomersCustomerKeyLocationAssetsImport
      parentRoute: typeof AppCustomersCustomerKeyImport
    }
    '/_app/customers/$customerKey/locations': {
      id: '/_app/customers/$customerKey/locations'
      path: '/locations'
      fullPath: '/customers/$customerKey/locations'
      preLoaderRoute: typeof AppCustomersCustomerKeyLocationsImport
      parentRoute: typeof AppCustomersCustomerKeyImport
    }
    '/_app/customers/$customerKey/owned-assets': {
      id: '/_app/customers/$customerKey/owned-assets'
      path: '/owned-assets'
      fullPath: '/customers/$customerKey/owned-assets'
      preLoaderRoute: typeof AppCustomersCustomerKeyOwnedAssetsImport
      parentRoute: typeof AppCustomersCustomerKeyImport
    }
    '/_app/customers/$customerKey/projects': {
      id: '/_app/customers/$customerKey/projects'
      path: '/projects'
      fullPath: '/customers/$customerKey/projects'
      preLoaderRoute: typeof AppCustomersCustomerKeyProjectsImport
      parentRoute: typeof AppCustomersCustomerKeyImport
    }
    '/_app/fulfillments/$fulfillmentKey/shipments': {
      id: '/_app/fulfillments/$fulfillmentKey/shipments'
      path: '/shipments'
      fullPath: '/fulfillments/$fulfillmentKey/shipments'
      preLoaderRoute: typeof AppFulfillmentsFulfillmentKeyShipmentsImport
      parentRoute: typeof AppFulfillmentsFulfillmentKeyImport
    }
    '/_app/integrations/triage/customers': {
      id: '/_app/integrations/triage/customers'
      path: '/triage/customers'
      fullPath: '/integrations/triage/customers'
      preLoaderRoute: typeof AppIntegrationsTriageCustomersImport
      parentRoute: typeof AppIntegrationsImport
    }
    '/_app/integrations/triage/items': {
      id: '/_app/integrations/triage/items'
      path: '/triage/items'
      fullPath: '/integrations/triage/items'
      preLoaderRoute: typeof AppIntegrationsTriageItemsImport
      parentRoute: typeof AppIntegrationsImport
    }
    '/_app/items/$itemKey/accounting': {
      id: '/_app/items/$itemKey/accounting'
      path: '/items/$itemKey/accounting'
      fullPath: '/items/$itemKey/accounting'
      preLoaderRoute: typeof AppItemsItemKeyAccountingImport
      parentRoute: typeof AppImport
    }
    '/_app/items/$itemKey/assets': {
      id: '/_app/items/$itemKey/assets'
      path: '/items/$itemKey/assets'
      fullPath: '/items/$itemKey/assets'
      preLoaderRoute: typeof AppItemsItemKeyAssetsImport
      parentRoute: typeof AppImport
    }
    '/_app/items/$itemKey/audit': {
      id: '/_app/items/$itemKey/audit'
      path: '/items/$itemKey/audit'
      fullPath: '/items/$itemKey/audit'
      preLoaderRoute: typeof AppItemsItemKeyAuditImport
      parentRoute: typeof AppImport
    }
    '/_app/items/$itemKey/bom': {
      id: '/_app/items/$itemKey/bom'
      path: '/items/$itemKey/bom'
      fullPath: '/items/$itemKey/bom'
      preLoaderRoute: typeof AppItemsItemKeyBomImport
      parentRoute: typeof AppImport
    }
    '/_app/items/$itemKey/movement': {
      id: '/_app/items/$itemKey/movement'
      path: '/items/$itemKey/movement'
      fullPath: '/items/$itemKey/movement'
      preLoaderRoute: typeof AppItemsItemKeyMovementImport
      parentRoute: typeof AppImport
    }
    '/_app/items/$itemKey/pricing': {
      id: '/_app/items/$itemKey/pricing'
      path: '/items/$itemKey/pricing'
      fullPath: '/items/$itemKey/pricing'
      preLoaderRoute: typeof AppItemsItemKeyPricingImport
      parentRoute: typeof AppImport
    }
    '/_app/items/$itemKey/units': {
      id: '/_app/items/$itemKey/units'
      path: '/items/$itemKey/units'
      fullPath: '/items/$itemKey/units'
      preLoaderRoute: typeof AppItemsItemKeyUnitsImport
      parentRoute: typeof AppImport
    }
    '/_app/locations/$locationKey/audit': {
      id: '/_app/locations/$locationKey/audit'
      path: '/audit'
      fullPath: '/locations/$locationKey/audit'
      preLoaderRoute: typeof AppLocationsLocationKeyAuditImport
      parentRoute: typeof AppLocationsLocationKeyImport
    }
    '/_app/locations/$locationKey/related-assets': {
      id: '/_app/locations/$locationKey/related-assets'
      path: '/related-assets'
      fullPath: '/locations/$locationKey/related-assets'
      preLoaderRoute: typeof AppLocationsLocationKeyRelatedAssetsImport
      parentRoute: typeof AppLocationsLocationKeyImport
    }
    '/_app/locations/$locationKey/related-projects': {
      id: '/_app/locations/$locationKey/related-projects'
      path: '/related-projects'
      fullPath: '/locations/$locationKey/related-projects'
      preLoaderRoute: typeof AppLocationsLocationKeyRelatedProjectsImport
      parentRoute: typeof AppLocationsLocationKeyImport
    }
    '/_app/locations/$locationKey/related-shipments': {
      id: '/_app/locations/$locationKey/related-shipments'
      path: '/related-shipments'
      fullPath: '/locations/$locationKey/related-shipments'
      preLoaderRoute: typeof AppLocationsLocationKeyRelatedShipmentsImport
      parentRoute: typeof AppLocationsLocationKeyImport
    }
    '/_app/projects/$projectKey/attachments': {
      id: '/_app/projects/$projectKey/attachments'
      path: '/attachments'
      fullPath: '/projects/$projectKey/attachments'
      preLoaderRoute: typeof AppProjectsProjectKeyAttachmentsImport
      parentRoute: typeof AppProjectsProjectKeyImport
    }
    '/_app/projects/$projectKey/audit': {
      id: '/_app/projects/$projectKey/audit'
      path: '/audit'
      fullPath: '/projects/$projectKey/audit'
      preLoaderRoute: typeof AppProjectsProjectKeyAuditImport
      parentRoute: typeof AppProjectsProjectKeyImport
    }
    '/_app/projects/$projectKey/billing-details': {
      id: '/_app/projects/$projectKey/billing-details'
      path: '/billing-details'
      fullPath: '/projects/$projectKey/billing-details'
      preLoaderRoute: typeof AppProjectsProjectKeyBillingDetailsImport
      parentRoute: typeof AppProjectsProjectKeyImport
    }
    '/_app/projects/$projectKey/costs': {
      id: '/_app/projects/$projectKey/costs'
      path: '/costs'
      fullPath: '/projects/$projectKey/costs'
      preLoaderRoute: typeof AppProjectsProjectKeyCostsImport
      parentRoute: typeof AppProjectsProjectKeyImport
    }
    '/_app/projects/$projectKey/fulfillment': {
      id: '/_app/projects/$projectKey/fulfillment'
      path: '/fulfillment'
      fullPath: '/projects/$projectKey/fulfillment'
      preLoaderRoute: typeof AppProjectsProjectKeyFulfillmentImport
      parentRoute: typeof AppProjectsProjectKeyImport
    }
    '/_app/projects/$projectKey/members': {
      id: '/_app/projects/$projectKey/members'
      path: '/members'
      fullPath: '/projects/$projectKey/members'
      preLoaderRoute: typeof AppProjectsProjectKeyMembersImport
      parentRoute: typeof AppProjectsProjectKeyImport
    }
    '/_app/projects/$projectKey/notes': {
      id: '/_app/projects/$projectKey/notes'
      path: '/notes'
      fullPath: '/projects/$projectKey/notes'
      preLoaderRoute: typeof AppProjectsProjectKeyNotesImport
      parentRoute: typeof AppProjectsProjectKeyImport
    }
    '/_app/projects/$projectKey/tickets': {
      id: '/_app/projects/$projectKey/tickets'
      path: '/tickets'
      fullPath: '/projects/$projectKey/tickets'
      preLoaderRoute: typeof AppProjectsProjectKeyTicketsImport
      parentRoute: typeof AppProjectsProjectKeyImport
    }
    '/_app/purchase-orders/$purchaseOrderKey/shipments': {
      id: '/_app/purchase-orders/$purchaseOrderKey/shipments'
      path: '/shipments'
      fullPath: '/purchase-orders/$purchaseOrderKey/shipments'
      preLoaderRoute: typeof AppPurchaseOrdersPurchaseOrderKeyShipmentsImport
      parentRoute: typeof AppPurchaseOrdersPurchaseOrderKeyImport
    }
    '/_app/reports/asset-bridge/$tabType': {
      id: '/_app/reports/asset-bridge/$tabType'
      path: '/reports/asset-bridge/$tabType'
      fullPath: '/reports/asset-bridge/$tabType'
      preLoaderRoute: typeof AppReportsAssetBridgeTabTypeImport
      parentRoute: typeof AppImport
    }
    '/_app/reports/asset-rollforward/$tabType': {
      id: '/_app/reports/asset-rollforward/$tabType'
      path: '/reports/asset-rollforward/$tabType'
      fullPath: '/reports/asset-rollforward/$tabType'
      preLoaderRoute: typeof AppReportsAssetRollforwardTabTypeImport
      parentRoute: typeof AppImport
    }
    '/_app/reports/asset-snapshot/$tabType': {
      id: '/_app/reports/asset-snapshot/$tabType'
      path: '/reports/asset-snapshot/$tabType'
      fullPath: '/reports/asset-snapshot/$tabType'
      preLoaderRoute: typeof AppReportsAssetSnapshotTabTypeImport
      parentRoute: typeof AppImport
    }
    '/_app/return-orders/$returnOrderKey/shipments': {
      id: '/_app/return-orders/$returnOrderKey/shipments'
      path: '/shipments'
      fullPath: '/return-orders/$returnOrderKey/shipments'
      preLoaderRoute: typeof AppReturnOrdersReturnOrderKeyShipmentsImport
      parentRoute: typeof AppReturnOrdersReturnOrderKeyImport
    }
    '/_app/tickets/$ticketKey/attachments': {
      id: '/_app/tickets/$ticketKey/attachments'
      path: '/attachments'
      fullPath: '/tickets/$ticketKey/attachments'
      preLoaderRoute: typeof AppTicketsTicketKeyAttachmentsImport
      parentRoute: typeof AppTicketsTicketKeyImport
    }
    '/_app/tickets/$ticketKey/audit': {
      id: '/_app/tickets/$ticketKey/audit'
      path: '/audit'
      fullPath: '/tickets/$ticketKey/audit'
      preLoaderRoute: typeof AppTicketsTicketKeyAuditImport
      parentRoute: typeof AppTicketsTicketKeyImport
    }
    '/_app/accounting/initial-true-up/': {
      id: '/_app/accounting/initial-true-up/'
      path: '/'
      fullPath: '/accounting/initial-true-up/'
      preLoaderRoute: typeof AppAccountingInitialTrueUpIndexImport
      parentRoute: typeof AppAccountingInitialTrueUpImport
    }
    '/_app/assets/$assetKey/': {
      id: '/_app/assets/$assetKey/'
      path: '/'
      fullPath: '/assets/$assetKey/'
      preLoaderRoute: typeof AppAssetsAssetKeyIndexImport
      parentRoute: typeof AppAssetsAssetKeyImport
    }
    '/_app/billing/invoices/': {
      id: '/_app/billing/invoices/'
      path: '/billing/invoices'
      fullPath: '/billing/invoices'
      preLoaderRoute: typeof AppBillingInvoicesIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/catalog/bundles/': {
      id: '/_app/catalog/bundles/'
      path: '/bundles'
      fullPath: '/catalog/bundles'
      preLoaderRoute: typeof AppCatalogBundlesIndexImport
      parentRoute: typeof AppCatalogImport
    }
    '/_app/catalog/items/': {
      id: '/_app/catalog/items/'
      path: '/'
      fullPath: '/catalog/items/'
      preLoaderRoute: typeof AppCatalogItemsIndexImport
      parentRoute: typeof AppCatalogItemsImport
    }
    '/_app/companies/$companyKey/': {
      id: '/_app/companies/$companyKey/'
      path: '/'
      fullPath: '/companies/$companyKey/'
      preLoaderRoute: typeof AppCompaniesCompanyKeyIndexImport
      parentRoute: typeof AppCompaniesCompanyKeyImport
    }
    '/_app/companies/customers/': {
      id: '/_app/companies/customers/'
      path: '/companies/customers'
      fullPath: '/companies/customers'
      preLoaderRoute: typeof AppCompaniesCustomersIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/companies/suppliers/': {
      id: '/_app/companies/suppliers/'
      path: '/companies/suppliers'
      fullPath: '/companies/suppliers'
      preLoaderRoute: typeof AppCompaniesSuppliersIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/contacts/$contactKey/': {
      id: '/_app/contacts/$contactKey/'
      path: '/'
      fullPath: '/contacts/$contactKey/'
      preLoaderRoute: typeof AppContactsContactKeyIndexImport
      parentRoute: typeof AppContactsContactKeyImport
    }
    '/_app/customers/$customerKey/': {
      id: '/_app/customers/$customerKey/'
      path: '/'
      fullPath: '/customers/$customerKey/'
      preLoaderRoute: typeof AppCustomersCustomerKeyIndexImport
      parentRoute: typeof AppCustomersCustomerKeyImport
    }
    '/_app/fulfillments/$fulfillmentKey/': {
      id: '/_app/fulfillments/$fulfillmentKey/'
      path: '/'
      fullPath: '/fulfillments/$fulfillmentKey/'
      preLoaderRoute: typeof AppFulfillmentsFulfillmentKeyIndexImport
      parentRoute: typeof AppFulfillmentsFulfillmentKeyImport
    }
    '/_app/items/$itemKey/': {
      id: '/_app/items/$itemKey/'
      path: '/items/$itemKey'
      fullPath: '/items/$itemKey'
      preLoaderRoute: typeof AppItemsItemKeyIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/locations/$locationKey/': {
      id: '/_app/locations/$locationKey/'
      path: '/'
      fullPath: '/locations/$locationKey/'
      preLoaderRoute: typeof AppLocationsLocationKeyIndexImport
      parentRoute: typeof AppLocationsLocationKeyImport
    }
    '/_app/projects/$projectKey/': {
      id: '/_app/projects/$projectKey/'
      path: '/'
      fullPath: '/projects/$projectKey/'
      preLoaderRoute: typeof AppProjectsProjectKeyIndexImport
      parentRoute: typeof AppProjectsProjectKeyImport
    }
    '/_app/purchase-orders/$purchaseOrderKey/': {
      id: '/_app/purchase-orders/$purchaseOrderKey/'
      path: '/'
      fullPath: '/purchase-orders/$purchaseOrderKey/'
      preLoaderRoute: typeof AppPurchaseOrdersPurchaseOrderKeyIndexImport
      parentRoute: typeof AppPurchaseOrdersPurchaseOrderKeyImport
    }
    '/_app/return-orders/$returnOrderKey/': {
      id: '/_app/return-orders/$returnOrderKey/'
      path: '/'
      fullPath: '/return-orders/$returnOrderKey/'
      preLoaderRoute: typeof AppReturnOrdersReturnOrderKeyIndexImport
      parentRoute: typeof AppReturnOrdersReturnOrderKeyImport
    }
    '/_app/tickets/$ticketKey/': {
      id: '/_app/tickets/$ticketKey/'
      path: '/'
      fullPath: '/tickets/$ticketKey/'
      preLoaderRoute: typeof AppTicketsTicketKeyIndexImport
      parentRoute: typeof AppTicketsTicketKeyImport
    }
    '/_app/catalog/bundles/$bundleKey/audit': {
      id: '/_app/catalog/bundles/$bundleKey/audit'
      path: '/audit'
      fullPath: '/catalog/bundles/$bundleKey/audit'
      preLoaderRoute: typeof AppCatalogBundlesBundleKeyAuditImport
      parentRoute: typeof AppCatalogBundlesBundleKeyImport
    }
    '/_app/catalog/items/$itemKey/accounting': {
      id: '/_app/catalog/items/$itemKey/accounting'
      path: '/accounting'
      fullPath: '/catalog/items/$itemKey/accounting'
      preLoaderRoute: typeof AppCatalogItemsItemKeyAccountingImport
      parentRoute: typeof AppCatalogItemsItemKeyImport
    }
    '/_app/catalog/items/$itemKey/assets': {
      id: '/_app/catalog/items/$itemKey/assets'
      path: '/assets'
      fullPath: '/catalog/items/$itemKey/assets'
      preLoaderRoute: typeof AppCatalogItemsItemKeyAssetsImport
      parentRoute: typeof AppCatalogItemsItemKeyImport
    }
    '/_app/catalog/items/$itemKey/audit': {
      id: '/_app/catalog/items/$itemKey/audit'
      path: '/audit'
      fullPath: '/catalog/items/$itemKey/audit'
      preLoaderRoute: typeof AppCatalogItemsItemKeyAuditImport
      parentRoute: typeof AppCatalogItemsItemKeyImport
    }
    '/_app/catalog/items/$itemKey/bom': {
      id: '/_app/catalog/items/$itemKey/bom'
      path: '/bom'
      fullPath: '/catalog/items/$itemKey/bom'
      preLoaderRoute: typeof AppCatalogItemsItemKeyBomImport
      parentRoute: typeof AppCatalogItemsItemKeyImport
    }
    '/_app/catalog/items/$itemKey/movement': {
      id: '/_app/catalog/items/$itemKey/movement'
      path: '/movement'
      fullPath: '/catalog/items/$itemKey/movement'
      preLoaderRoute: typeof AppCatalogItemsItemKeyMovementImport
      parentRoute: typeof AppCatalogItemsItemKeyImport
    }
    '/_app/catalog/items/$itemKey/pricing': {
      id: '/_app/catalog/items/$itemKey/pricing'
      path: '/pricing'
      fullPath: '/catalog/items/$itemKey/pricing'
      preLoaderRoute: typeof AppCatalogItemsItemKeyPricingImport
      parentRoute: typeof AppCatalogItemsItemKeyImport
    }
    '/_app/catalog/items/$itemKey/units': {
      id: '/_app/catalog/items/$itemKey/units'
      path: '/units'
      fullPath: '/catalog/items/$itemKey/units'
      preLoaderRoute: typeof AppCatalogItemsItemKeyUnitsImport
      parentRoute: typeof AppCatalogItemsItemKeyImport
    }
    '/_app/reports/exception/asset/$tabType': {
      id: '/_app/reports/exception/asset/$tabType'
      path: '/reports/exception/asset/$tabType'
      fullPath: '/reports/exception/asset/$tabType'
      preLoaderRoute: typeof AppReportsExceptionAssetTabTypeImport
      parentRoute: typeof AppImport
    }
    '/_app/catalog/bundles/$bundleKey/': {
      id: '/_app/catalog/bundles/$bundleKey/'
      path: '/'
      fullPath: '/catalog/bundles/$bundleKey/'
      preLoaderRoute: typeof AppCatalogBundlesBundleKeyIndexImport
      parentRoute: typeof AppCatalogBundlesBundleKeyImport
    }
    '/_app/catalog/items/$itemKey/': {
      id: '/_app/catalog/items/$itemKey/'
      path: '/'
      fullPath: '/catalog/items/$itemKey/'
      preLoaderRoute: typeof AppCatalogItemsItemKeyIndexImport
      parentRoute: typeof AppCatalogItemsItemKeyImport
    }
  }
}

// Create and export the route tree

interface AppCatalogItemsItemKeyRouteChildren {
  AppCatalogItemsItemKeyAccountingRoute: typeof AppCatalogItemsItemKeyAccountingRoute
  AppCatalogItemsItemKeyAssetsRoute: typeof AppCatalogItemsItemKeyAssetsRoute
  AppCatalogItemsItemKeyAuditRoute: typeof AppCatalogItemsItemKeyAuditRoute
  AppCatalogItemsItemKeyBomRoute: typeof AppCatalogItemsItemKeyBomRoute
  AppCatalogItemsItemKeyMovementRoute: typeof AppCatalogItemsItemKeyMovementRoute
  AppCatalogItemsItemKeyPricingRoute: typeof AppCatalogItemsItemKeyPricingRoute
  AppCatalogItemsItemKeyUnitsRoute: typeof AppCatalogItemsItemKeyUnitsRoute
  AppCatalogItemsItemKeyIndexRoute: typeof AppCatalogItemsItemKeyIndexRoute
}

const AppCatalogItemsItemKeyRouteChildren: AppCatalogItemsItemKeyRouteChildren =
  {
    AppCatalogItemsItemKeyAccountingRoute:
      AppCatalogItemsItemKeyAccountingRoute,
    AppCatalogItemsItemKeyAssetsRoute: AppCatalogItemsItemKeyAssetsRoute,
    AppCatalogItemsItemKeyAuditRoute: AppCatalogItemsItemKeyAuditRoute,
    AppCatalogItemsItemKeyBomRoute: AppCatalogItemsItemKeyBomRoute,
    AppCatalogItemsItemKeyMovementRoute: AppCatalogItemsItemKeyMovementRoute,
    AppCatalogItemsItemKeyPricingRoute: AppCatalogItemsItemKeyPricingRoute,
    AppCatalogItemsItemKeyUnitsRoute: AppCatalogItemsItemKeyUnitsRoute,
    AppCatalogItemsItemKeyIndexRoute: AppCatalogItemsItemKeyIndexRoute,
  }

const AppCatalogItemsItemKeyRouteWithChildren =
  AppCatalogItemsItemKeyRoute._addFileChildren(
    AppCatalogItemsItemKeyRouteChildren,
  )

interface AppCatalogItemsRouteChildren {
  AppCatalogItemsItemKeyRoute: typeof AppCatalogItemsItemKeyRouteWithChildren
  AppCatalogItemsIndexRoute: typeof AppCatalogItemsIndexRoute
}

const AppCatalogItemsRouteChildren: AppCatalogItemsRouteChildren = {
  AppCatalogItemsItemKeyRoute: AppCatalogItemsItemKeyRouteWithChildren,
  AppCatalogItemsIndexRoute: AppCatalogItemsIndexRoute,
}

const AppCatalogItemsRouteWithChildren = AppCatalogItemsRoute._addFileChildren(
  AppCatalogItemsRouteChildren,
)

interface AppCatalogBundlesBundleKeyRouteChildren {
  AppCatalogBundlesBundleKeyAuditRoute: typeof AppCatalogBundlesBundleKeyAuditRoute
  AppCatalogBundlesBundleKeyIndexRoute: typeof AppCatalogBundlesBundleKeyIndexRoute
}

const AppCatalogBundlesBundleKeyRouteChildren: AppCatalogBundlesBundleKeyRouteChildren =
  {
    AppCatalogBundlesBundleKeyAuditRoute: AppCatalogBundlesBundleKeyAuditRoute,
    AppCatalogBundlesBundleKeyIndexRoute: AppCatalogBundlesBundleKeyIndexRoute,
  }

const AppCatalogBundlesBundleKeyRouteWithChildren =
  AppCatalogBundlesBundleKeyRoute._addFileChildren(
    AppCatalogBundlesBundleKeyRouteChildren,
  )

interface AppCatalogRouteChildren {
  AppCatalogItemsRoute: typeof AppCatalogItemsRouteWithChildren
  AppCatalogIndexRoute: typeof AppCatalogIndexRoute
  AppCatalogBundlesBundleKeyRoute: typeof AppCatalogBundlesBundleKeyRouteWithChildren
  AppCatalogBundlesIndexRoute: typeof AppCatalogBundlesIndexRoute
}

const AppCatalogRouteChildren: AppCatalogRouteChildren = {
  AppCatalogItemsRoute: AppCatalogItemsRouteWithChildren,
  AppCatalogIndexRoute: AppCatalogIndexRoute,
  AppCatalogBundlesBundleKeyRoute: AppCatalogBundlesBundleKeyRouteWithChildren,
  AppCatalogBundlesIndexRoute: AppCatalogBundlesIndexRoute,
}

const AppCatalogRouteWithChildren = AppCatalogRoute._addFileChildren(
  AppCatalogRouteChildren,
)

interface AppDashboardRouteChildren {
  AppDashboardAssetRoute: typeof AppDashboardAssetRoute
  AppDashboardCustomerRoute: typeof AppDashboardCustomerRoute
  AppDashboardLocationRoute: typeof AppDashboardLocationRoute
}

const AppDashboardRouteChildren: AppDashboardRouteChildren = {
  AppDashboardAssetRoute: AppDashboardAssetRoute,
  AppDashboardCustomerRoute: AppDashboardCustomerRoute,
  AppDashboardLocationRoute: AppDashboardLocationRoute,
}

const AppDashboardRouteWithChildren = AppDashboardRoute._addFileChildren(
  AppDashboardRouteChildren,
)

interface AppFulfillmentRouteChildren {
  AppFulfillmentFulfillmentKeyRoute: typeof AppFulfillmentFulfillmentKeyRoute
}

const AppFulfillmentRouteChildren: AppFulfillmentRouteChildren = {
  AppFulfillmentFulfillmentKeyRoute: AppFulfillmentFulfillmentKeyRoute,
}

const AppFulfillmentRouteWithChildren = AppFulfillmentRoute._addFileChildren(
  AppFulfillmentRouteChildren,
)

interface AppIntegrationsRouteChildren {
  AppIntegrationsIndexRoute: typeof AppIntegrationsIndexRoute
  AppIntegrationsTriageCustomersRoute: typeof AppIntegrationsTriageCustomersRoute
  AppIntegrationsTriageItemsRoute: typeof AppIntegrationsTriageItemsRoute
}

const AppIntegrationsRouteChildren: AppIntegrationsRouteChildren = {
  AppIntegrationsIndexRoute: AppIntegrationsIndexRoute,
  AppIntegrationsTriageCustomersRoute: AppIntegrationsTriageCustomersRoute,
  AppIntegrationsTriageItemsRoute: AppIntegrationsTriageItemsRoute,
}

const AppIntegrationsRouteWithChildren = AppIntegrationsRoute._addFileChildren(
  AppIntegrationsRouteChildren,
)

interface AppPurchaseOrderRouteChildren {
  AppPurchaseOrderPurchaseOrderKeyRoute: typeof AppPurchaseOrderPurchaseOrderKeyRoute
}

const AppPurchaseOrderRouteChildren: AppPurchaseOrderRouteChildren = {
  AppPurchaseOrderPurchaseOrderKeyRoute: AppPurchaseOrderPurchaseOrderKeyRoute,
}

const AppPurchaseOrderRouteWithChildren =
  AppPurchaseOrderRoute._addFileChildren(AppPurchaseOrderRouteChildren)

interface AppReturnOrderRouteChildren {
  AppReturnOrderReturnOrderKeyRoute: typeof AppReturnOrderReturnOrderKeyRoute
}

const AppReturnOrderRouteChildren: AppReturnOrderRouteChildren = {
  AppReturnOrderReturnOrderKeyRoute: AppReturnOrderReturnOrderKeyRoute,
}

const AppReturnOrderRouteWithChildren = AppReturnOrderRoute._addFileChildren(
  AppReturnOrderRouteChildren,
)

interface AppAccountingInitialTrueUpRouteChildren {
  AppAccountingInitialTrueUpIsoRoute: typeof AppAccountingInitialTrueUpIsoRoute
  AppAccountingInitialTrueUpIndexRoute: typeof AppAccountingInitialTrueUpIndexRoute
}

const AppAccountingInitialTrueUpRouteChildren: AppAccountingInitialTrueUpRouteChildren =
  {
    AppAccountingInitialTrueUpIsoRoute: AppAccountingInitialTrueUpIsoRoute,
    AppAccountingInitialTrueUpIndexRoute: AppAccountingInitialTrueUpIndexRoute,
  }

const AppAccountingInitialTrueUpRouteWithChildren =
  AppAccountingInitialTrueUpRoute._addFileChildren(
    AppAccountingInitialTrueUpRouteChildren,
  )

interface AppAssetsAssetKeyRouteChildren {
  AppAssetsAssetKeyAccountingRoute: typeof AppAssetsAssetKeyAccountingRoute
  AppAssetsAssetKeyAttachmentsRoute: typeof AppAssetsAssetKeyAttachmentsRoute
  AppAssetsAssetKeyAuditRoute: typeof AppAssetsAssetKeyAuditRoute
  AppAssetsAssetKeyMetadataRoute: typeof AppAssetsAssetKeyMetadataRoute
  AppAssetsAssetKeyTicketsRoute: typeof AppAssetsAssetKeyTicketsRoute
  AppAssetsAssetKeyIndexRoute: typeof AppAssetsAssetKeyIndexRoute
}

const AppAssetsAssetKeyRouteChildren: AppAssetsAssetKeyRouteChildren = {
  AppAssetsAssetKeyAccountingRoute: AppAssetsAssetKeyAccountingRoute,
  AppAssetsAssetKeyAttachmentsRoute: AppAssetsAssetKeyAttachmentsRoute,
  AppAssetsAssetKeyAuditRoute: AppAssetsAssetKeyAuditRoute,
  AppAssetsAssetKeyMetadataRoute: AppAssetsAssetKeyMetadataRoute,
  AppAssetsAssetKeyTicketsRoute: AppAssetsAssetKeyTicketsRoute,
  AppAssetsAssetKeyIndexRoute: AppAssetsAssetKeyIndexRoute,
}

const AppAssetsAssetKeyRouteWithChildren =
  AppAssetsAssetKeyRoute._addFileChildren(AppAssetsAssetKeyRouteChildren)

interface AppCompaniesCompanyKeyRouteChildren {
  AppCompaniesCompanyKeyAuditRoute: typeof AppCompaniesCompanyKeyAuditRoute
  AppCompaniesCompanyKeyContactsRoute: typeof AppCompaniesCompanyKeyContactsRoute
  AppCompaniesCompanyKeyFulfillmentRoute: typeof AppCompaniesCompanyKeyFulfillmentRoute
  AppCompaniesCompanyKeyLocationAssetsRoute: typeof AppCompaniesCompanyKeyLocationAssetsRoute
  AppCompaniesCompanyKeyLocationsRoute: typeof AppCompaniesCompanyKeyLocationsRoute
  AppCompaniesCompanyKeyOwnedAssetsRoute: typeof AppCompaniesCompanyKeyOwnedAssetsRoute
  AppCompaniesCompanyKeyProjectsRoute: typeof AppCompaniesCompanyKeyProjectsRoute
  AppCompaniesCompanyKeyIndexRoute: typeof AppCompaniesCompanyKeyIndexRoute
}

const AppCompaniesCompanyKeyRouteChildren: AppCompaniesCompanyKeyRouteChildren =
  {
    AppCompaniesCompanyKeyAuditRoute: AppCompaniesCompanyKeyAuditRoute,
    AppCompaniesCompanyKeyContactsRoute: AppCompaniesCompanyKeyContactsRoute,
    AppCompaniesCompanyKeyFulfillmentRoute:
      AppCompaniesCompanyKeyFulfillmentRoute,
    AppCompaniesCompanyKeyLocationAssetsRoute:
      AppCompaniesCompanyKeyLocationAssetsRoute,
    AppCompaniesCompanyKeyLocationsRoute: AppCompaniesCompanyKeyLocationsRoute,
    AppCompaniesCompanyKeyOwnedAssetsRoute:
      AppCompaniesCompanyKeyOwnedAssetsRoute,
    AppCompaniesCompanyKeyProjectsRoute: AppCompaniesCompanyKeyProjectsRoute,
    AppCompaniesCompanyKeyIndexRoute: AppCompaniesCompanyKeyIndexRoute,
  }

const AppCompaniesCompanyKeyRouteWithChildren =
  AppCompaniesCompanyKeyRoute._addFileChildren(
    AppCompaniesCompanyKeyRouteChildren,
  )

interface AppContactsContactKeyRouteChildren {
  AppContactsContactKeyAuditRoute: typeof AppContactsContactKeyAuditRoute
  AppContactsContactKeyIndexRoute: typeof AppContactsContactKeyIndexRoute
}

const AppContactsContactKeyRouteChildren: AppContactsContactKeyRouteChildren = {
  AppContactsContactKeyAuditRoute: AppContactsContactKeyAuditRoute,
  AppContactsContactKeyIndexRoute: AppContactsContactKeyIndexRoute,
}

const AppContactsContactKeyRouteWithChildren =
  AppContactsContactKeyRoute._addFileChildren(
    AppContactsContactKeyRouteChildren,
  )

interface AppCustomersCustomerKeyRouteChildren {
  AppCustomersCustomerKeyAuditRoute: typeof AppCustomersCustomerKeyAuditRoute
  AppCustomersCustomerKeyFulfillmentRoute: typeof AppCustomersCustomerKeyFulfillmentRoute
  AppCustomersCustomerKeyLocationAssetsRoute: typeof AppCustomersCustomerKeyLocationAssetsRoute
  AppCustomersCustomerKeyLocationsRoute: typeof AppCustomersCustomerKeyLocationsRoute
  AppCustomersCustomerKeyOwnedAssetsRoute: typeof AppCustomersCustomerKeyOwnedAssetsRoute
  AppCustomersCustomerKeyProjectsRoute: typeof AppCustomersCustomerKeyProjectsRoute
  AppCustomersCustomerKeyIndexRoute: typeof AppCustomersCustomerKeyIndexRoute
}

const AppCustomersCustomerKeyRouteChildren: AppCustomersCustomerKeyRouteChildren =
  {
    AppCustomersCustomerKeyAuditRoute: AppCustomersCustomerKeyAuditRoute,
    AppCustomersCustomerKeyFulfillmentRoute:
      AppCustomersCustomerKeyFulfillmentRoute,
    AppCustomersCustomerKeyLocationAssetsRoute:
      AppCustomersCustomerKeyLocationAssetsRoute,
    AppCustomersCustomerKeyLocationsRoute:
      AppCustomersCustomerKeyLocationsRoute,
    AppCustomersCustomerKeyOwnedAssetsRoute:
      AppCustomersCustomerKeyOwnedAssetsRoute,
    AppCustomersCustomerKeyProjectsRoute: AppCustomersCustomerKeyProjectsRoute,
    AppCustomersCustomerKeyIndexRoute: AppCustomersCustomerKeyIndexRoute,
  }

const AppCustomersCustomerKeyRouteWithChildren =
  AppCustomersCustomerKeyRoute._addFileChildren(
    AppCustomersCustomerKeyRouteChildren,
  )

interface AppFulfillmentsFulfillmentKeyRouteChildren {
  AppFulfillmentsFulfillmentKeyShipmentsRoute: typeof AppFulfillmentsFulfillmentKeyShipmentsRoute
  AppFulfillmentsFulfillmentKeyIndexRoute: typeof AppFulfillmentsFulfillmentKeyIndexRoute
}

const AppFulfillmentsFulfillmentKeyRouteChildren: AppFulfillmentsFulfillmentKeyRouteChildren =
  {
    AppFulfillmentsFulfillmentKeyShipmentsRoute:
      AppFulfillmentsFulfillmentKeyShipmentsRoute,
    AppFulfillmentsFulfillmentKeyIndexRoute:
      AppFulfillmentsFulfillmentKeyIndexRoute,
  }

const AppFulfillmentsFulfillmentKeyRouteWithChildren =
  AppFulfillmentsFulfillmentKeyRoute._addFileChildren(
    AppFulfillmentsFulfillmentKeyRouteChildren,
  )

interface AppLocationsLocationKeyRouteChildren {
  AppLocationsLocationKeyAuditRoute: typeof AppLocationsLocationKeyAuditRoute
  AppLocationsLocationKeyRelatedAssetsRoute: typeof AppLocationsLocationKeyRelatedAssetsRoute
  AppLocationsLocationKeyRelatedProjectsRoute: typeof AppLocationsLocationKeyRelatedProjectsRoute
  AppLocationsLocationKeyRelatedShipmentsRoute: typeof AppLocationsLocationKeyRelatedShipmentsRoute
  AppLocationsLocationKeyIndexRoute: typeof AppLocationsLocationKeyIndexRoute
}

const AppLocationsLocationKeyRouteChildren: AppLocationsLocationKeyRouteChildren =
  {
    AppLocationsLocationKeyAuditRoute: AppLocationsLocationKeyAuditRoute,
    AppLocationsLocationKeyRelatedAssetsRoute:
      AppLocationsLocationKeyRelatedAssetsRoute,
    AppLocationsLocationKeyRelatedProjectsRoute:
      AppLocationsLocationKeyRelatedProjectsRoute,
    AppLocationsLocationKeyRelatedShipmentsRoute:
      AppLocationsLocationKeyRelatedShipmentsRoute,
    AppLocationsLocationKeyIndexRoute: AppLocationsLocationKeyIndexRoute,
  }

const AppLocationsLocationKeyRouteWithChildren =
  AppLocationsLocationKeyRoute._addFileChildren(
    AppLocationsLocationKeyRouteChildren,
  )

interface AppProjectsProjectKeyRouteChildren {
  AppProjectsProjectKeyAttachmentsRoute: typeof AppProjectsProjectKeyAttachmentsRoute
  AppProjectsProjectKeyAuditRoute: typeof AppProjectsProjectKeyAuditRoute
  AppProjectsProjectKeyBillingDetailsRoute: typeof AppProjectsProjectKeyBillingDetailsRoute
  AppProjectsProjectKeyCostsRoute: typeof AppProjectsProjectKeyCostsRoute
  AppProjectsProjectKeyFulfillmentRoute: typeof AppProjectsProjectKeyFulfillmentRoute
  AppProjectsProjectKeyMembersRoute: typeof AppProjectsProjectKeyMembersRoute
  AppProjectsProjectKeyNotesRoute: typeof AppProjectsProjectKeyNotesRoute
  AppProjectsProjectKeyTicketsRoute: typeof AppProjectsProjectKeyTicketsRoute
  AppProjectsProjectKeyIndexRoute: typeof AppProjectsProjectKeyIndexRoute
}

const AppProjectsProjectKeyRouteChildren: AppProjectsProjectKeyRouteChildren = {
  AppProjectsProjectKeyAttachmentsRoute: AppProjectsProjectKeyAttachmentsRoute,
  AppProjectsProjectKeyAuditRoute: AppProjectsProjectKeyAuditRoute,
  AppProjectsProjectKeyBillingDetailsRoute:
    AppProjectsProjectKeyBillingDetailsRoute,
  AppProjectsProjectKeyCostsRoute: AppProjectsProjectKeyCostsRoute,
  AppProjectsProjectKeyFulfillmentRoute: AppProjectsProjectKeyFulfillmentRoute,
  AppProjectsProjectKeyMembersRoute: AppProjectsProjectKeyMembersRoute,
  AppProjectsProjectKeyNotesRoute: AppProjectsProjectKeyNotesRoute,
  AppProjectsProjectKeyTicketsRoute: AppProjectsProjectKeyTicketsRoute,
  AppProjectsProjectKeyIndexRoute: AppProjectsProjectKeyIndexRoute,
}

const AppProjectsProjectKeyRouteWithChildren =
  AppProjectsProjectKeyRoute._addFileChildren(
    AppProjectsProjectKeyRouteChildren,
  )

interface AppPurchaseOrdersPurchaseOrderKeyRouteChildren {
  AppPurchaseOrdersPurchaseOrderKeyShipmentsRoute: typeof AppPurchaseOrdersPurchaseOrderKeyShipmentsRoute
  AppPurchaseOrdersPurchaseOrderKeyIndexRoute: typeof AppPurchaseOrdersPurchaseOrderKeyIndexRoute
}

const AppPurchaseOrdersPurchaseOrderKeyRouteChildren: AppPurchaseOrdersPurchaseOrderKeyRouteChildren =
  {
    AppPurchaseOrdersPurchaseOrderKeyShipmentsRoute:
      AppPurchaseOrdersPurchaseOrderKeyShipmentsRoute,
    AppPurchaseOrdersPurchaseOrderKeyIndexRoute:
      AppPurchaseOrdersPurchaseOrderKeyIndexRoute,
  }

const AppPurchaseOrdersPurchaseOrderKeyRouteWithChildren =
  AppPurchaseOrdersPurchaseOrderKeyRoute._addFileChildren(
    AppPurchaseOrdersPurchaseOrderKeyRouteChildren,
  )

interface AppReturnOrdersReturnOrderKeyRouteChildren {
  AppReturnOrdersReturnOrderKeyShipmentsRoute: typeof AppReturnOrdersReturnOrderKeyShipmentsRoute
  AppReturnOrdersReturnOrderKeyIndexRoute: typeof AppReturnOrdersReturnOrderKeyIndexRoute
}

const AppReturnOrdersReturnOrderKeyRouteChildren: AppReturnOrdersReturnOrderKeyRouteChildren =
  {
    AppReturnOrdersReturnOrderKeyShipmentsRoute:
      AppReturnOrdersReturnOrderKeyShipmentsRoute,
    AppReturnOrdersReturnOrderKeyIndexRoute:
      AppReturnOrdersReturnOrderKeyIndexRoute,
  }

const AppReturnOrdersReturnOrderKeyRouteWithChildren =
  AppReturnOrdersReturnOrderKeyRoute._addFileChildren(
    AppReturnOrdersReturnOrderKeyRouteChildren,
  )

interface AppTicketsTicketKeyRouteChildren {
  AppTicketsTicketKeyAttachmentsRoute: typeof AppTicketsTicketKeyAttachmentsRoute
  AppTicketsTicketKeyAuditRoute: typeof AppTicketsTicketKeyAuditRoute
  AppTicketsTicketKeyIndexRoute: typeof AppTicketsTicketKeyIndexRoute
}

const AppTicketsTicketKeyRouteChildren: AppTicketsTicketKeyRouteChildren = {
  AppTicketsTicketKeyAttachmentsRoute: AppTicketsTicketKeyAttachmentsRoute,
  AppTicketsTicketKeyAuditRoute: AppTicketsTicketKeyAuditRoute,
  AppTicketsTicketKeyIndexRoute: AppTicketsTicketKeyIndexRoute,
}

const AppTicketsTicketKeyRouteWithChildren =
  AppTicketsTicketKeyRoute._addFileChildren(AppTicketsTicketKeyRouteChildren)

interface AppRouteChildren {
  AppAccountRoute: typeof AppAccountRoute
  AppAuditRoute: typeof AppAuditRoute
  AppCatalogRoute: typeof AppCatalogRouteWithChildren
  AppDashboardRoute: typeof AppDashboardRouteWithChildren
  AppFulfillmentRoute: typeof AppFulfillmentRouteWithChildren
  AppIntegrationsRoute: typeof AppIntegrationsRouteWithChildren
  AppInventoryRoute: typeof AppInventoryRoute
  AppOrganizationRoute: typeof AppOrganizationRoute
  AppPurchaseOrderRoute: typeof AppPurchaseOrderRouteWithChildren
  AppReturnOrderRoute: typeof AppReturnOrderRouteWithChildren
  AppAccountingCloseWorkflowRoute: typeof AppAccountingCloseWorkflowRoute
  AppAccountingInitialTrueUpRoute: typeof AppAccountingInitialTrueUpRouteWithChildren
  AppAccountingPeriodReviewRoute: typeof AppAccountingPeriodReviewRoute
  AppAssembliesRegistrationStatusRoute: typeof AppAssembliesRegistrationStatusRoute
  AppAssetsAssetKeyRoute: typeof AppAssetsAssetKeyRouteWithChildren
  AppBillingAgingRoute: typeof AppBillingAgingRoute
  AppBillingChargesRoute: typeof AppBillingChargesRoute
  AppBillingInvoiceLineItemsRoute: typeof AppBillingInvoiceLineItemsRoute
  AppBillingLifecycleRoute: typeof AppBillingLifecycleRoute
  AppBillingPlansRoute: typeof AppBillingPlansRoute
  AppCompaniesCompanyKeyRoute: typeof AppCompaniesCompanyKeyRouteWithChildren
  AppContactsContactKeyRoute: typeof AppContactsContactKeyRouteWithChildren
  AppCustomersCustomerKeyRoute: typeof AppCustomersCustomerKeyRouteWithChildren
  AppFulfillmentsFulfillmentKeyRoute: typeof AppFulfillmentsFulfillmentKeyRouteWithChildren
  AppLocationsLocationKeyRoute: typeof AppLocationsLocationKeyRouteWithChildren
  AppNotificationsSubscriptionsRoute: typeof AppNotificationsSubscriptionsRoute
  AppProjectsProjectKeyRoute: typeof AppProjectsProjectKeyRouteWithChildren
  AppPurchaseOrdersPurchaseOrderKeyRoute: typeof AppPurchaseOrdersPurchaseOrderKeyRouteWithChildren
  AppReportsActiveProjectsRoute: typeof AppReportsActiveProjectsRoute
  AppReportsDepreciationScheduleRoute: typeof AppReportsDepreciationScheduleRoute
  AppReportsFieldRoute: typeof AppReportsFieldRoute
  AppReportsFulfillmentRoute: typeof AppReportsFulfillmentRoute
  AppReportsInventoryRoute: typeof AppReportsInventoryRoute
  AppReportsPastProjectsRoute: typeof AppReportsPastProjectsRoute
  AppReportsTransitRoute: typeof AppReportsTransitRoute
  AppReportsUpcomingProjectCompletionsRoute: typeof AppReportsUpcomingProjectCompletionsRoute
  AppReportsUpcomingProjectStartsRoute: typeof AppReportsUpcomingProjectStartsRoute
  AppReportsUpcomingProjectsRoute: typeof AppReportsUpcomingProjectsRoute
  AppReturnOrdersReturnOrderKeyRoute: typeof AppReturnOrdersReturnOrderKeyRouteWithChildren
  AppShipmentsShipmentKeyRoute: typeof AppShipmentsShipmentKeyRoute
  AppTicketsTicketKeyRoute: typeof AppTicketsTicketKeyRouteWithChildren
  AppAccountingIndexRoute: typeof AppAccountingIndexRoute
  AppAssembliesIndexRoute: typeof AppAssembliesIndexRoute
  AppAssetsIndexRoute: typeof AppAssetsIndexRoute
  AppBillingIndexRoute: typeof AppBillingIndexRoute
  AppCompaniesIndexRoute: typeof AppCompaniesIndexRoute
  AppContactsIndexRoute: typeof AppContactsIndexRoute
  AppCostsIndexRoute: typeof AppCostsIndexRoute
  AppCustomersIndexRoute: typeof AppCustomersIndexRoute
  AppExchangeIndexRoute: typeof AppExchangeIndexRoute
  AppExchangesIndexRoute: typeof AppExchangesIndexRoute
  AppFulfillmentsIndexRoute: typeof AppFulfillmentsIndexRoute
  AppItemsIndexRoute: typeof AppItemsIndexRoute
  AppLocationsIndexRoute: typeof AppLocationsIndexRoute
  AppMovementsIndexRoute: typeof AppMovementsIndexRoute
  AppNotificationsIndexRoute: typeof AppNotificationsIndexRoute
  AppPartsIndexRoute: typeof AppPartsIndexRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
  AppPurchaseOrdersIndexRoute: typeof AppPurchaseOrdersIndexRoute
  AppReportsIndexRoute: typeof AppReportsIndexRoute
  AppReturnOrdersIndexRoute: typeof AppReturnOrdersIndexRoute
  AppShipmentsIndexRoute: typeof AppShipmentsIndexRoute
  AppTicketsIndexRoute: typeof AppTicketsIndexRoute
  AppTimeIndexRoute: typeof AppTimeIndexRoute
  AppBillingInvoicesInvoiceKeyRoute: typeof AppBillingInvoicesInvoiceKeyRoute
  AppItemsItemKeyAccountingRoute: typeof AppItemsItemKeyAccountingRoute
  AppItemsItemKeyAssetsRoute: typeof AppItemsItemKeyAssetsRoute
  AppItemsItemKeyAuditRoute: typeof AppItemsItemKeyAuditRoute
  AppItemsItemKeyBomRoute: typeof AppItemsItemKeyBomRoute
  AppItemsItemKeyMovementRoute: typeof AppItemsItemKeyMovementRoute
  AppItemsItemKeyPricingRoute: typeof AppItemsItemKeyPricingRoute
  AppItemsItemKeyUnitsRoute: typeof AppItemsItemKeyUnitsRoute
  AppReportsAssetBridgeTabTypeRoute: typeof AppReportsAssetBridgeTabTypeRoute
  AppReportsAssetRollforwardTabTypeRoute: typeof AppReportsAssetRollforwardTabTypeRoute
  AppReportsAssetSnapshotTabTypeRoute: typeof AppReportsAssetSnapshotTabTypeRoute
  AppBillingInvoicesIndexRoute: typeof AppBillingInvoicesIndexRoute
  AppCompaniesCustomersIndexRoute: typeof AppCompaniesCustomersIndexRoute
  AppCompaniesSuppliersIndexRoute: typeof AppCompaniesSuppliersIndexRoute
  AppItemsItemKeyIndexRoute: typeof AppItemsItemKeyIndexRoute
  AppReportsExceptionAssetTabTypeRoute: typeof AppReportsExceptionAssetTabTypeRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRoute: AppAccountRoute,
  AppAuditRoute: AppAuditRoute,
  AppCatalogRoute: AppCatalogRouteWithChildren,
  AppDashboardRoute: AppDashboardRouteWithChildren,
  AppFulfillmentRoute: AppFulfillmentRouteWithChildren,
  AppIntegrationsRoute: AppIntegrationsRouteWithChildren,
  AppInventoryRoute: AppInventoryRoute,
  AppOrganizationRoute: AppOrganizationRoute,
  AppPurchaseOrderRoute: AppPurchaseOrderRouteWithChildren,
  AppReturnOrderRoute: AppReturnOrderRouteWithChildren,
  AppAccountingCloseWorkflowRoute: AppAccountingCloseWorkflowRoute,
  AppAccountingInitialTrueUpRoute: AppAccountingInitialTrueUpRouteWithChildren,
  AppAccountingPeriodReviewRoute: AppAccountingPeriodReviewRoute,
  AppAssembliesRegistrationStatusRoute: AppAssembliesRegistrationStatusRoute,
  AppAssetsAssetKeyRoute: AppAssetsAssetKeyRouteWithChildren,
  AppBillingAgingRoute: AppBillingAgingRoute,
  AppBillingChargesRoute: AppBillingChargesRoute,
  AppBillingInvoiceLineItemsRoute: AppBillingInvoiceLineItemsRoute,
  AppBillingLifecycleRoute: AppBillingLifecycleRoute,
  AppBillingPlansRoute: AppBillingPlansRoute,
  AppCompaniesCompanyKeyRoute: AppCompaniesCompanyKeyRouteWithChildren,
  AppContactsContactKeyRoute: AppContactsContactKeyRouteWithChildren,
  AppCustomersCustomerKeyRoute: AppCustomersCustomerKeyRouteWithChildren,
  AppFulfillmentsFulfillmentKeyRoute:
    AppFulfillmentsFulfillmentKeyRouteWithChildren,
  AppLocationsLocationKeyRoute: AppLocationsLocationKeyRouteWithChildren,
  AppNotificationsSubscriptionsRoute: AppNotificationsSubscriptionsRoute,
  AppProjectsProjectKeyRoute: AppProjectsProjectKeyRouteWithChildren,
  AppPurchaseOrdersPurchaseOrderKeyRoute:
    AppPurchaseOrdersPurchaseOrderKeyRouteWithChildren,
  AppReportsActiveProjectsRoute: AppReportsActiveProjectsRoute,
  AppReportsDepreciationScheduleRoute: AppReportsDepreciationScheduleRoute,
  AppReportsFieldRoute: AppReportsFieldRoute,
  AppReportsFulfillmentRoute: AppReportsFulfillmentRoute,
  AppReportsInventoryRoute: AppReportsInventoryRoute,
  AppReportsPastProjectsRoute: AppReportsPastProjectsRoute,
  AppReportsTransitRoute: AppReportsTransitRoute,
  AppReportsUpcomingProjectCompletionsRoute:
    AppReportsUpcomingProjectCompletionsRoute,
  AppReportsUpcomingProjectStartsRoute: AppReportsUpcomingProjectStartsRoute,
  AppReportsUpcomingProjectsRoute: AppReportsUpcomingProjectsRoute,
  AppReturnOrdersReturnOrderKeyRoute:
    AppReturnOrdersReturnOrderKeyRouteWithChildren,
  AppShipmentsShipmentKeyRoute: AppShipmentsShipmentKeyRoute,
  AppTicketsTicketKeyRoute: AppTicketsTicketKeyRouteWithChildren,
  AppAccountingIndexRoute: AppAccountingIndexRoute,
  AppAssembliesIndexRoute: AppAssembliesIndexRoute,
  AppAssetsIndexRoute: AppAssetsIndexRoute,
  AppBillingIndexRoute: AppBillingIndexRoute,
  AppCompaniesIndexRoute: AppCompaniesIndexRoute,
  AppContactsIndexRoute: AppContactsIndexRoute,
  AppCostsIndexRoute: AppCostsIndexRoute,
  AppCustomersIndexRoute: AppCustomersIndexRoute,
  AppExchangeIndexRoute: AppExchangeIndexRoute,
  AppExchangesIndexRoute: AppExchangesIndexRoute,
  AppFulfillmentsIndexRoute: AppFulfillmentsIndexRoute,
  AppItemsIndexRoute: AppItemsIndexRoute,
  AppLocationsIndexRoute: AppLocationsIndexRoute,
  AppMovementsIndexRoute: AppMovementsIndexRoute,
  AppNotificationsIndexRoute: AppNotificationsIndexRoute,
  AppPartsIndexRoute: AppPartsIndexRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
  AppPurchaseOrdersIndexRoute: AppPurchaseOrdersIndexRoute,
  AppReportsIndexRoute: AppReportsIndexRoute,
  AppReturnOrdersIndexRoute: AppReturnOrdersIndexRoute,
  AppShipmentsIndexRoute: AppShipmentsIndexRoute,
  AppTicketsIndexRoute: AppTicketsIndexRoute,
  AppTimeIndexRoute: AppTimeIndexRoute,
  AppBillingInvoicesInvoiceKeyRoute: AppBillingInvoicesInvoiceKeyRoute,
  AppItemsItemKeyAccountingRoute: AppItemsItemKeyAccountingRoute,
  AppItemsItemKeyAssetsRoute: AppItemsItemKeyAssetsRoute,
  AppItemsItemKeyAuditRoute: AppItemsItemKeyAuditRoute,
  AppItemsItemKeyBomRoute: AppItemsItemKeyBomRoute,
  AppItemsItemKeyMovementRoute: AppItemsItemKeyMovementRoute,
  AppItemsItemKeyPricingRoute: AppItemsItemKeyPricingRoute,
  AppItemsItemKeyUnitsRoute: AppItemsItemKeyUnitsRoute,
  AppReportsAssetBridgeTabTypeRoute: AppReportsAssetBridgeTabTypeRoute,
  AppReportsAssetRollforwardTabTypeRoute:
    AppReportsAssetRollforwardTabTypeRoute,
  AppReportsAssetSnapshotTabTypeRoute: AppReportsAssetSnapshotTabTypeRoute,
  AppBillingInvoicesIndexRoute: AppBillingInvoicesIndexRoute,
  AppCompaniesCustomersIndexRoute: AppCompaniesCustomersIndexRoute,
  AppCompaniesSuppliersIndexRoute: AppCompaniesSuppliersIndexRoute,
  AppItemsItemKeyIndexRoute: AppItemsItemKeyIndexRoute,
  AppReportsExceptionAssetTabTypeRoute: AppReportsExceptionAssetTabTypeRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/account': typeof AppAccountRoute
  '/audit': typeof AppAuditRoute
  '/catalog': typeof AppCatalogRouteWithChildren
  '/dashboard': typeof AppDashboardRouteWithChildren
  '/fulfillment': typeof AppFulfillmentRouteWithChildren
  '/integrations': typeof AppIntegrationsRouteWithChildren
  '/inventory': typeof AppInventoryRoute
  '/organization': typeof AppOrganizationRoute
  '/purchase-order': typeof AppPurchaseOrderRouteWithChildren
  '/return-order': typeof AppReturnOrderRouteWithChildren
  '/accounting/close-workflow': typeof AppAccountingCloseWorkflowRoute
  '/accounting/initial-true-up': typeof AppAccountingInitialTrueUpRouteWithChildren
  '/accounting/period-review': typeof AppAccountingPeriodReviewRoute
  '/assemblies/$registrationStatus': typeof AppAssembliesRegistrationStatusRoute
  '/assets/$assetKey': typeof AppAssetsAssetKeyRouteWithChildren
  '/billing/aging': typeof AppBillingAgingRoute
  '/billing/charges': typeof AppBillingChargesRoute
  '/billing/invoice-line-items': typeof AppBillingInvoiceLineItemsRoute
  '/billing/lifecycle': typeof AppBillingLifecycleRoute
  '/billing/plans': typeof AppBillingPlansRoute
  '/catalog/items': typeof AppCatalogItemsRouteWithChildren
  '/companies/$companyKey': typeof AppCompaniesCompanyKeyRouteWithChildren
  '/contacts/$contactKey': typeof AppContactsContactKeyRouteWithChildren
  '/customers/$customerKey': typeof AppCustomersCustomerKeyRouteWithChildren
  '/dashboard/asset': typeof AppDashboardAssetRoute
  '/dashboard/customer': typeof AppDashboardCustomerRoute
  '/dashboard/location': typeof AppDashboardLocationRoute
  '/fulfillment/$fulfillmentKey': typeof AppFulfillmentFulfillmentKeyRoute
  '/fulfillments/$fulfillmentKey': typeof AppFulfillmentsFulfillmentKeyRouteWithChildren
  '/locations/$locationKey': typeof AppLocationsLocationKeyRouteWithChildren
  '/notifications/subscriptions': typeof AppNotificationsSubscriptionsRoute
  '/projects/$projectKey': typeof AppProjectsProjectKeyRouteWithChildren
  '/purchase-order/$purchaseOrderKey': typeof AppPurchaseOrderPurchaseOrderKeyRoute
  '/purchase-orders/$purchaseOrderKey': typeof AppPurchaseOrdersPurchaseOrderKeyRouteWithChildren
  '/reports/active-projects': typeof AppReportsActiveProjectsRoute
  '/reports/depreciation-schedule': typeof AppReportsDepreciationScheduleRoute
  '/reports/field': typeof AppReportsFieldRoute
  '/reports/fulfillment': typeof AppReportsFulfillmentRoute
  '/reports/inventory': typeof AppReportsInventoryRoute
  '/reports/past-projects': typeof AppReportsPastProjectsRoute
  '/reports/transit': typeof AppReportsTransitRoute
  '/reports/upcoming-project-completions': typeof AppReportsUpcomingProjectCompletionsRoute
  '/reports/upcoming-project-starts': typeof AppReportsUpcomingProjectStartsRoute
  '/reports/upcoming-projects': typeof AppReportsUpcomingProjectsRoute
  '/return-order/$returnOrderKey': typeof AppReturnOrderReturnOrderKeyRoute
  '/return-orders/$returnOrderKey': typeof AppReturnOrdersReturnOrderKeyRouteWithChildren
  '/shipments/$shipmentKey': typeof AppShipmentsShipmentKeyRoute
  '/tickets/$ticketKey': typeof AppTicketsTicketKeyRouteWithChildren
  '/accounting': typeof AppAccountingIndexRoute
  '/assemblies': typeof AppAssembliesIndexRoute
  '/assets': typeof AppAssetsIndexRoute
  '/billing': typeof AppBillingIndexRoute
  '/catalog/': typeof AppCatalogIndexRoute
  '/companies': typeof AppCompaniesIndexRoute
  '/contacts': typeof AppContactsIndexRoute
  '/costs': typeof AppCostsIndexRoute
  '/customers': typeof AppCustomersIndexRoute
  '/exchange': typeof AppExchangeIndexRoute
  '/exchanges': typeof AppExchangesIndexRoute
  '/fulfillments': typeof AppFulfillmentsIndexRoute
  '/integrations/': typeof AppIntegrationsIndexRoute
  '/items': typeof AppItemsIndexRoute
  '/locations': typeof AppLocationsIndexRoute
  '/movements': typeof AppMovementsIndexRoute
  '/notifications': typeof AppNotificationsIndexRoute
  '/parts': typeof AppPartsIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/purchase-orders': typeof AppPurchaseOrdersIndexRoute
  '/reports': typeof AppReportsIndexRoute
  '/return-orders': typeof AppReturnOrdersIndexRoute
  '/shipments': typeof AppShipmentsIndexRoute
  '/tickets': typeof AppTicketsIndexRoute
  '/time': typeof AppTimeIndexRoute
  '/accounting/initial-true-up/$iso': typeof AppAccountingInitialTrueUpIsoRoute
  '/assets/$assetKey/accounting': typeof AppAssetsAssetKeyAccountingRoute
  '/assets/$assetKey/attachments': typeof AppAssetsAssetKeyAttachmentsRoute
  '/assets/$assetKey/audit': typeof AppAssetsAssetKeyAuditRoute
  '/assets/$assetKey/metadata': typeof AppAssetsAssetKeyMetadataRoute
  '/assets/$assetKey/tickets': typeof AppAssetsAssetKeyTicketsRoute
  '/billing/invoices/$invoiceKey': typeof AppBillingInvoicesInvoiceKeyRoute
  '/catalog/bundles/$bundleKey': typeof AppCatalogBundlesBundleKeyRouteWithChildren
  '/catalog/items/$itemKey': typeof AppCatalogItemsItemKeyRouteWithChildren
  '/companies/$companyKey/audit': typeof AppCompaniesCompanyKeyAuditRoute
  '/companies/$companyKey/contacts': typeof AppCompaniesCompanyKeyContactsRoute
  '/companies/$companyKey/fulfillment': typeof AppCompaniesCompanyKeyFulfillmentRoute
  '/companies/$companyKey/location-assets': typeof AppCompaniesCompanyKeyLocationAssetsRoute
  '/companies/$companyKey/locations': typeof AppCompaniesCompanyKeyLocationsRoute
  '/companies/$companyKey/owned-assets': typeof AppCompaniesCompanyKeyOwnedAssetsRoute
  '/companies/$companyKey/projects': typeof AppCompaniesCompanyKeyProjectsRoute
  '/contacts/$contactKey/audit': typeof AppContactsContactKeyAuditRoute
  '/customers/$customerKey/audit': typeof AppCustomersCustomerKeyAuditRoute
  '/customers/$customerKey/fulfillment': typeof AppCustomersCustomerKeyFulfillmentRoute
  '/customers/$customerKey/location-assets': typeof AppCustomersCustomerKeyLocationAssetsRoute
  '/customers/$customerKey/locations': typeof AppCustomersCustomerKeyLocationsRoute
  '/customers/$customerKey/owned-assets': typeof AppCustomersCustomerKeyOwnedAssetsRoute
  '/customers/$customerKey/projects': typeof AppCustomersCustomerKeyProjectsRoute
  '/fulfillments/$fulfillmentKey/shipments': typeof AppFulfillmentsFulfillmentKeyShipmentsRoute
  '/integrations/triage/customers': typeof AppIntegrationsTriageCustomersRoute
  '/integrations/triage/items': typeof AppIntegrationsTriageItemsRoute
  '/items/$itemKey/accounting': typeof AppItemsItemKeyAccountingRoute
  '/items/$itemKey/assets': typeof AppItemsItemKeyAssetsRoute
  '/items/$itemKey/audit': typeof AppItemsItemKeyAuditRoute
  '/items/$itemKey/bom': typeof AppItemsItemKeyBomRoute
  '/items/$itemKey/movement': typeof AppItemsItemKeyMovementRoute
  '/items/$itemKey/pricing': typeof AppItemsItemKeyPricingRoute
  '/items/$itemKey/units': typeof AppItemsItemKeyUnitsRoute
  '/locations/$locationKey/audit': typeof AppLocationsLocationKeyAuditRoute
  '/locations/$locationKey/related-assets': typeof AppLocationsLocationKeyRelatedAssetsRoute
  '/locations/$locationKey/related-projects': typeof AppLocationsLocationKeyRelatedProjectsRoute
  '/locations/$locationKey/related-shipments': typeof AppLocationsLocationKeyRelatedShipmentsRoute
  '/projects/$projectKey/attachments': typeof AppProjectsProjectKeyAttachmentsRoute
  '/projects/$projectKey/audit': typeof AppProjectsProjectKeyAuditRoute
  '/projects/$projectKey/billing-details': typeof AppProjectsProjectKeyBillingDetailsRoute
  '/projects/$projectKey/costs': typeof AppProjectsProjectKeyCostsRoute
  '/projects/$projectKey/fulfillment': typeof AppProjectsProjectKeyFulfillmentRoute
  '/projects/$projectKey/members': typeof AppProjectsProjectKeyMembersRoute
  '/projects/$projectKey/notes': typeof AppProjectsProjectKeyNotesRoute
  '/projects/$projectKey/tickets': typeof AppProjectsProjectKeyTicketsRoute
  '/purchase-orders/$purchaseOrderKey/shipments': typeof AppPurchaseOrdersPurchaseOrderKeyShipmentsRoute
  '/reports/asset-bridge/$tabType': typeof AppReportsAssetBridgeTabTypeRoute
  '/reports/asset-rollforward/$tabType': typeof AppReportsAssetRollforwardTabTypeRoute
  '/reports/asset-snapshot/$tabType': typeof AppReportsAssetSnapshotTabTypeRoute
  '/return-orders/$returnOrderKey/shipments': typeof AppReturnOrdersReturnOrderKeyShipmentsRoute
  '/tickets/$ticketKey/attachments': typeof AppTicketsTicketKeyAttachmentsRoute
  '/tickets/$ticketKey/audit': typeof AppTicketsTicketKeyAuditRoute
  '/accounting/initial-true-up/': typeof AppAccountingInitialTrueUpIndexRoute
  '/assets/$assetKey/': typeof AppAssetsAssetKeyIndexRoute
  '/billing/invoices': typeof AppBillingInvoicesIndexRoute
  '/catalog/bundles': typeof AppCatalogBundlesIndexRoute
  '/catalog/items/': typeof AppCatalogItemsIndexRoute
  '/companies/$companyKey/': typeof AppCompaniesCompanyKeyIndexRoute
  '/companies/customers': typeof AppCompaniesCustomersIndexRoute
  '/companies/suppliers': typeof AppCompaniesSuppliersIndexRoute
  '/contacts/$contactKey/': typeof AppContactsContactKeyIndexRoute
  '/customers/$customerKey/': typeof AppCustomersCustomerKeyIndexRoute
  '/fulfillments/$fulfillmentKey/': typeof AppFulfillmentsFulfillmentKeyIndexRoute
  '/items/$itemKey': typeof AppItemsItemKeyIndexRoute
  '/locations/$locationKey/': typeof AppLocationsLocationKeyIndexRoute
  '/projects/$projectKey/': typeof AppProjectsProjectKeyIndexRoute
  '/purchase-orders/$purchaseOrderKey/': typeof AppPurchaseOrdersPurchaseOrderKeyIndexRoute
  '/return-orders/$returnOrderKey/': typeof AppReturnOrdersReturnOrderKeyIndexRoute
  '/tickets/$ticketKey/': typeof AppTicketsTicketKeyIndexRoute
  '/catalog/bundles/$bundleKey/audit': typeof AppCatalogBundlesBundleKeyAuditRoute
  '/catalog/items/$itemKey/accounting': typeof AppCatalogItemsItemKeyAccountingRoute
  '/catalog/items/$itemKey/assets': typeof AppCatalogItemsItemKeyAssetsRoute
  '/catalog/items/$itemKey/audit': typeof AppCatalogItemsItemKeyAuditRoute
  '/catalog/items/$itemKey/bom': typeof AppCatalogItemsItemKeyBomRoute
  '/catalog/items/$itemKey/movement': typeof AppCatalogItemsItemKeyMovementRoute
  '/catalog/items/$itemKey/pricing': typeof AppCatalogItemsItemKeyPricingRoute
  '/catalog/items/$itemKey/units': typeof AppCatalogItemsItemKeyUnitsRoute
  '/reports/exception/asset/$tabType': typeof AppReportsExceptionAssetTabTypeRoute
  '/catalog/bundles/$bundleKey/': typeof AppCatalogBundlesBundleKeyIndexRoute
  '/catalog/items/$itemKey/': typeof AppCatalogItemsItemKeyIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/account': typeof AppAccountRoute
  '/audit': typeof AppAuditRoute
  '/dashboard': typeof AppDashboardRouteWithChildren
  '/fulfillment': typeof AppFulfillmentRouteWithChildren
  '/inventory': typeof AppInventoryRoute
  '/organization': typeof AppOrganizationRoute
  '/purchase-order': typeof AppPurchaseOrderRouteWithChildren
  '/return-order': typeof AppReturnOrderRouteWithChildren
  '/accounting/close-workflow': typeof AppAccountingCloseWorkflowRoute
  '/accounting/period-review': typeof AppAccountingPeriodReviewRoute
  '/assemblies/$registrationStatus': typeof AppAssembliesRegistrationStatusRoute
  '/billing/aging': typeof AppBillingAgingRoute
  '/billing/charges': typeof AppBillingChargesRoute
  '/billing/invoice-line-items': typeof AppBillingInvoiceLineItemsRoute
  '/billing/lifecycle': typeof AppBillingLifecycleRoute
  '/billing/plans': typeof AppBillingPlansRoute
  '/dashboard/asset': typeof AppDashboardAssetRoute
  '/dashboard/customer': typeof AppDashboardCustomerRoute
  '/dashboard/location': typeof AppDashboardLocationRoute
  '/fulfillment/$fulfillmentKey': typeof AppFulfillmentFulfillmentKeyRoute
  '/notifications/subscriptions': typeof AppNotificationsSubscriptionsRoute
  '/purchase-order/$purchaseOrderKey': typeof AppPurchaseOrderPurchaseOrderKeyRoute
  '/reports/active-projects': typeof AppReportsActiveProjectsRoute
  '/reports/depreciation-schedule': typeof AppReportsDepreciationScheduleRoute
  '/reports/field': typeof AppReportsFieldRoute
  '/reports/fulfillment': typeof AppReportsFulfillmentRoute
  '/reports/inventory': typeof AppReportsInventoryRoute
  '/reports/past-projects': typeof AppReportsPastProjectsRoute
  '/reports/transit': typeof AppReportsTransitRoute
  '/reports/upcoming-project-completions': typeof AppReportsUpcomingProjectCompletionsRoute
  '/reports/upcoming-project-starts': typeof AppReportsUpcomingProjectStartsRoute
  '/reports/upcoming-projects': typeof AppReportsUpcomingProjectsRoute
  '/return-order/$returnOrderKey': typeof AppReturnOrderReturnOrderKeyRoute
  '/shipments/$shipmentKey': typeof AppShipmentsShipmentKeyRoute
  '/accounting': typeof AppAccountingIndexRoute
  '/assemblies': typeof AppAssembliesIndexRoute
  '/assets': typeof AppAssetsIndexRoute
  '/billing': typeof AppBillingIndexRoute
  '/catalog': typeof AppCatalogIndexRoute
  '/companies': typeof AppCompaniesIndexRoute
  '/contacts': typeof AppContactsIndexRoute
  '/costs': typeof AppCostsIndexRoute
  '/customers': typeof AppCustomersIndexRoute
  '/exchange': typeof AppExchangeIndexRoute
  '/exchanges': typeof AppExchangesIndexRoute
  '/fulfillments': typeof AppFulfillmentsIndexRoute
  '/integrations': typeof AppIntegrationsIndexRoute
  '/items': typeof AppItemsIndexRoute
  '/locations': typeof AppLocationsIndexRoute
  '/movements': typeof AppMovementsIndexRoute
  '/notifications': typeof AppNotificationsIndexRoute
  '/parts': typeof AppPartsIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/purchase-orders': typeof AppPurchaseOrdersIndexRoute
  '/reports': typeof AppReportsIndexRoute
  '/return-orders': typeof AppReturnOrdersIndexRoute
  '/shipments': typeof AppShipmentsIndexRoute
  '/tickets': typeof AppTicketsIndexRoute
  '/time': typeof AppTimeIndexRoute
  '/accounting/initial-true-up/$iso': typeof AppAccountingInitialTrueUpIsoRoute
  '/assets/$assetKey/accounting': typeof AppAssetsAssetKeyAccountingRoute
  '/assets/$assetKey/attachments': typeof AppAssetsAssetKeyAttachmentsRoute
  '/assets/$assetKey/audit': typeof AppAssetsAssetKeyAuditRoute
  '/assets/$assetKey/metadata': typeof AppAssetsAssetKeyMetadataRoute
  '/assets/$assetKey/tickets': typeof AppAssetsAssetKeyTicketsRoute
  '/billing/invoices/$invoiceKey': typeof AppBillingInvoicesInvoiceKeyRoute
  '/companies/$companyKey/audit': typeof AppCompaniesCompanyKeyAuditRoute
  '/companies/$companyKey/contacts': typeof AppCompaniesCompanyKeyContactsRoute
  '/companies/$companyKey/fulfillment': typeof AppCompaniesCompanyKeyFulfillmentRoute
  '/companies/$companyKey/location-assets': typeof AppCompaniesCompanyKeyLocationAssetsRoute
  '/companies/$companyKey/locations': typeof AppCompaniesCompanyKeyLocationsRoute
  '/companies/$companyKey/owned-assets': typeof AppCompaniesCompanyKeyOwnedAssetsRoute
  '/companies/$companyKey/projects': typeof AppCompaniesCompanyKeyProjectsRoute
  '/contacts/$contactKey/audit': typeof AppContactsContactKeyAuditRoute
  '/customers/$customerKey/audit': typeof AppCustomersCustomerKeyAuditRoute
  '/customers/$customerKey/fulfillment': typeof AppCustomersCustomerKeyFulfillmentRoute
  '/customers/$customerKey/location-assets': typeof AppCustomersCustomerKeyLocationAssetsRoute
  '/customers/$customerKey/locations': typeof AppCustomersCustomerKeyLocationsRoute
  '/customers/$customerKey/owned-assets': typeof AppCustomersCustomerKeyOwnedAssetsRoute
  '/customers/$customerKey/projects': typeof AppCustomersCustomerKeyProjectsRoute
  '/fulfillments/$fulfillmentKey/shipments': typeof AppFulfillmentsFulfillmentKeyShipmentsRoute
  '/integrations/triage/customers': typeof AppIntegrationsTriageCustomersRoute
  '/integrations/triage/items': typeof AppIntegrationsTriageItemsRoute
  '/items/$itemKey/accounting': typeof AppItemsItemKeyAccountingRoute
  '/items/$itemKey/assets': typeof AppItemsItemKeyAssetsRoute
  '/items/$itemKey/audit': typeof AppItemsItemKeyAuditRoute
  '/items/$itemKey/bom': typeof AppItemsItemKeyBomRoute
  '/items/$itemKey/movement': typeof AppItemsItemKeyMovementRoute
  '/items/$itemKey/pricing': typeof AppItemsItemKeyPricingRoute
  '/items/$itemKey/units': typeof AppItemsItemKeyUnitsRoute
  '/locations/$locationKey/audit': typeof AppLocationsLocationKeyAuditRoute
  '/locations/$locationKey/related-assets': typeof AppLocationsLocationKeyRelatedAssetsRoute
  '/locations/$locationKey/related-projects': typeof AppLocationsLocationKeyRelatedProjectsRoute
  '/locations/$locationKey/related-shipments': typeof AppLocationsLocationKeyRelatedShipmentsRoute
  '/projects/$projectKey/attachments': typeof AppProjectsProjectKeyAttachmentsRoute
  '/projects/$projectKey/audit': typeof AppProjectsProjectKeyAuditRoute
  '/projects/$projectKey/billing-details': typeof AppProjectsProjectKeyBillingDetailsRoute
  '/projects/$projectKey/costs': typeof AppProjectsProjectKeyCostsRoute
  '/projects/$projectKey/fulfillment': typeof AppProjectsProjectKeyFulfillmentRoute
  '/projects/$projectKey/members': typeof AppProjectsProjectKeyMembersRoute
  '/projects/$projectKey/notes': typeof AppProjectsProjectKeyNotesRoute
  '/projects/$projectKey/tickets': typeof AppProjectsProjectKeyTicketsRoute
  '/purchase-orders/$purchaseOrderKey/shipments': typeof AppPurchaseOrdersPurchaseOrderKeyShipmentsRoute
  '/reports/asset-bridge/$tabType': typeof AppReportsAssetBridgeTabTypeRoute
  '/reports/asset-rollforward/$tabType': typeof AppReportsAssetRollforwardTabTypeRoute
  '/reports/asset-snapshot/$tabType': typeof AppReportsAssetSnapshotTabTypeRoute
  '/return-orders/$returnOrderKey/shipments': typeof AppReturnOrdersReturnOrderKeyShipmentsRoute
  '/tickets/$ticketKey/attachments': typeof AppTicketsTicketKeyAttachmentsRoute
  '/tickets/$ticketKey/audit': typeof AppTicketsTicketKeyAuditRoute
  '/accounting/initial-true-up': typeof AppAccountingInitialTrueUpIndexRoute
  '/assets/$assetKey': typeof AppAssetsAssetKeyIndexRoute
  '/billing/invoices': typeof AppBillingInvoicesIndexRoute
  '/catalog/bundles': typeof AppCatalogBundlesIndexRoute
  '/catalog/items': typeof AppCatalogItemsIndexRoute
  '/companies/$companyKey': typeof AppCompaniesCompanyKeyIndexRoute
  '/companies/customers': typeof AppCompaniesCustomersIndexRoute
  '/companies/suppliers': typeof AppCompaniesSuppliersIndexRoute
  '/contacts/$contactKey': typeof AppContactsContactKeyIndexRoute
  '/customers/$customerKey': typeof AppCustomersCustomerKeyIndexRoute
  '/fulfillments/$fulfillmentKey': typeof AppFulfillmentsFulfillmentKeyIndexRoute
  '/items/$itemKey': typeof AppItemsItemKeyIndexRoute
  '/locations/$locationKey': typeof AppLocationsLocationKeyIndexRoute
  '/projects/$projectKey': typeof AppProjectsProjectKeyIndexRoute
  '/purchase-orders/$purchaseOrderKey': typeof AppPurchaseOrdersPurchaseOrderKeyIndexRoute
  '/return-orders/$returnOrderKey': typeof AppReturnOrdersReturnOrderKeyIndexRoute
  '/tickets/$ticketKey': typeof AppTicketsTicketKeyIndexRoute
  '/catalog/bundles/$bundleKey/audit': typeof AppCatalogBundlesBundleKeyAuditRoute
  '/catalog/items/$itemKey/accounting': typeof AppCatalogItemsItemKeyAccountingRoute
  '/catalog/items/$itemKey/assets': typeof AppCatalogItemsItemKeyAssetsRoute
  '/catalog/items/$itemKey/audit': typeof AppCatalogItemsItemKeyAuditRoute
  '/catalog/items/$itemKey/bom': typeof AppCatalogItemsItemKeyBomRoute
  '/catalog/items/$itemKey/movement': typeof AppCatalogItemsItemKeyMovementRoute
  '/catalog/items/$itemKey/pricing': typeof AppCatalogItemsItemKeyPricingRoute
  '/catalog/items/$itemKey/units': typeof AppCatalogItemsItemKeyUnitsRoute
  '/reports/exception/asset/$tabType': typeof AppReportsExceptionAssetTabTypeRoute
  '/catalog/bundles/$bundleKey': typeof AppCatalogBundlesBundleKeyIndexRoute
  '/catalog/items/$itemKey': typeof AppCatalogItemsItemKeyIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/_app/account': typeof AppAccountRoute
  '/_app/audit': typeof AppAuditRoute
  '/_app/catalog': typeof AppCatalogRouteWithChildren
  '/_app/dashboard': typeof AppDashboardRouteWithChildren
  '/_app/fulfillment': typeof AppFulfillmentRouteWithChildren
  '/_app/integrations': typeof AppIntegrationsRouteWithChildren
  '/_app/inventory': typeof AppInventoryRoute
  '/_app/organization': typeof AppOrganizationRoute
  '/_app/purchase-order': typeof AppPurchaseOrderRouteWithChildren
  '/_app/return-order': typeof AppReturnOrderRouteWithChildren
  '/_app/accounting/close-workflow': typeof AppAccountingCloseWorkflowRoute
  '/_app/accounting/initial-true-up': typeof AppAccountingInitialTrueUpRouteWithChildren
  '/_app/accounting/period-review': typeof AppAccountingPeriodReviewRoute
  '/_app/assemblies/$registrationStatus': typeof AppAssembliesRegistrationStatusRoute
  '/_app/assets/$assetKey': typeof AppAssetsAssetKeyRouteWithChildren
  '/_app/billing/aging': typeof AppBillingAgingRoute
  '/_app/billing/charges': typeof AppBillingChargesRoute
  '/_app/billing/invoice-line-items': typeof AppBillingInvoiceLineItemsRoute
  '/_app/billing/lifecycle': typeof AppBillingLifecycleRoute
  '/_app/billing/plans': typeof AppBillingPlansRoute
  '/_app/catalog/items': typeof AppCatalogItemsRouteWithChildren
  '/_app/companies/$companyKey': typeof AppCompaniesCompanyKeyRouteWithChildren
  '/_app/contacts/$contactKey': typeof AppContactsContactKeyRouteWithChildren
  '/_app/customers/$customerKey': typeof AppCustomersCustomerKeyRouteWithChildren
  '/_app/dashboard/asset': typeof AppDashboardAssetRoute
  '/_app/dashboard/customer': typeof AppDashboardCustomerRoute
  '/_app/dashboard/location': typeof AppDashboardLocationRoute
  '/_app/fulfillment/$fulfillmentKey': typeof AppFulfillmentFulfillmentKeyRoute
  '/_app/fulfillments/$fulfillmentKey': typeof AppFulfillmentsFulfillmentKeyRouteWithChildren
  '/_app/locations/$locationKey': typeof AppLocationsLocationKeyRouteWithChildren
  '/_app/notifications/subscriptions': typeof AppNotificationsSubscriptionsRoute
  '/_app/projects/$projectKey': typeof AppProjectsProjectKeyRouteWithChildren
  '/_app/purchase-order/$purchaseOrderKey': typeof AppPurchaseOrderPurchaseOrderKeyRoute
  '/_app/purchase-orders/$purchaseOrderKey': typeof AppPurchaseOrdersPurchaseOrderKeyRouteWithChildren
  '/_app/reports/active-projects': typeof AppReportsActiveProjectsRoute
  '/_app/reports/depreciation-schedule': typeof AppReportsDepreciationScheduleRoute
  '/_app/reports/field': typeof AppReportsFieldRoute
  '/_app/reports/fulfillment': typeof AppReportsFulfillmentRoute
  '/_app/reports/inventory': typeof AppReportsInventoryRoute
  '/_app/reports/past-projects': typeof AppReportsPastProjectsRoute
  '/_app/reports/transit': typeof AppReportsTransitRoute
  '/_app/reports/upcoming-project-completions': typeof AppReportsUpcomingProjectCompletionsRoute
  '/_app/reports/upcoming-project-starts': typeof AppReportsUpcomingProjectStartsRoute
  '/_app/reports/upcoming-projects': typeof AppReportsUpcomingProjectsRoute
  '/_app/return-order/$returnOrderKey': typeof AppReturnOrderReturnOrderKeyRoute
  '/_app/return-orders/$returnOrderKey': typeof AppReturnOrdersReturnOrderKeyRouteWithChildren
  '/_app/shipments/$shipmentKey': typeof AppShipmentsShipmentKeyRoute
  '/_app/tickets/$ticketKey': typeof AppTicketsTicketKeyRouteWithChildren
  '/_app/accounting/': typeof AppAccountingIndexRoute
  '/_app/assemblies/': typeof AppAssembliesIndexRoute
  '/_app/assets/': typeof AppAssetsIndexRoute
  '/_app/billing/': typeof AppBillingIndexRoute
  '/_app/catalog/': typeof AppCatalogIndexRoute
  '/_app/companies/': typeof AppCompaniesIndexRoute
  '/_app/contacts/': typeof AppContactsIndexRoute
  '/_app/costs/': typeof AppCostsIndexRoute
  '/_app/customers/': typeof AppCustomersIndexRoute
  '/_app/exchange/': typeof AppExchangeIndexRoute
  '/_app/exchanges/': typeof AppExchangesIndexRoute
  '/_app/fulfillments/': typeof AppFulfillmentsIndexRoute
  '/_app/integrations/': typeof AppIntegrationsIndexRoute
  '/_app/items/': typeof AppItemsIndexRoute
  '/_app/locations/': typeof AppLocationsIndexRoute
  '/_app/movements/': typeof AppMovementsIndexRoute
  '/_app/notifications/': typeof AppNotificationsIndexRoute
  '/_app/parts/': typeof AppPartsIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/purchase-orders/': typeof AppPurchaseOrdersIndexRoute
  '/_app/reports/': typeof AppReportsIndexRoute
  '/_app/return-orders/': typeof AppReturnOrdersIndexRoute
  '/_app/shipments/': typeof AppShipmentsIndexRoute
  '/_app/tickets/': typeof AppTicketsIndexRoute
  '/_app/time/': typeof AppTimeIndexRoute
  '/_app/accounting/initial-true-up/$iso': typeof AppAccountingInitialTrueUpIsoRoute
  '/_app/assets/$assetKey/accounting': typeof AppAssetsAssetKeyAccountingRoute
  '/_app/assets/$assetKey/attachments': typeof AppAssetsAssetKeyAttachmentsRoute
  '/_app/assets/$assetKey/audit': typeof AppAssetsAssetKeyAuditRoute
  '/_app/assets/$assetKey/metadata': typeof AppAssetsAssetKeyMetadataRoute
  '/_app/assets/$assetKey/tickets': typeof AppAssetsAssetKeyTicketsRoute
  '/_app/billing/invoices/$invoiceKey': typeof AppBillingInvoicesInvoiceKeyRoute
  '/_app/catalog/bundles/$bundleKey': typeof AppCatalogBundlesBundleKeyRouteWithChildren
  '/_app/catalog/items/$itemKey': typeof AppCatalogItemsItemKeyRouteWithChildren
  '/_app/companies/$companyKey/audit': typeof AppCompaniesCompanyKeyAuditRoute
  '/_app/companies/$companyKey/contacts': typeof AppCompaniesCompanyKeyContactsRoute
  '/_app/companies/$companyKey/fulfillment': typeof AppCompaniesCompanyKeyFulfillmentRoute
  '/_app/companies/$companyKey/location-assets': typeof AppCompaniesCompanyKeyLocationAssetsRoute
  '/_app/companies/$companyKey/locations': typeof AppCompaniesCompanyKeyLocationsRoute
  '/_app/companies/$companyKey/owned-assets': typeof AppCompaniesCompanyKeyOwnedAssetsRoute
  '/_app/companies/$companyKey/projects': typeof AppCompaniesCompanyKeyProjectsRoute
  '/_app/contacts/$contactKey/audit': typeof AppContactsContactKeyAuditRoute
  '/_app/customers/$customerKey/audit': typeof AppCustomersCustomerKeyAuditRoute
  '/_app/customers/$customerKey/fulfillment': typeof AppCustomersCustomerKeyFulfillmentRoute
  '/_app/customers/$customerKey/location-assets': typeof AppCustomersCustomerKeyLocationAssetsRoute
  '/_app/customers/$customerKey/locations': typeof AppCustomersCustomerKeyLocationsRoute
  '/_app/customers/$customerKey/owned-assets': typeof AppCustomersCustomerKeyOwnedAssetsRoute
  '/_app/customers/$customerKey/projects': typeof AppCustomersCustomerKeyProjectsRoute
  '/_app/fulfillments/$fulfillmentKey/shipments': typeof AppFulfillmentsFulfillmentKeyShipmentsRoute
  '/_app/integrations/triage/customers': typeof AppIntegrationsTriageCustomersRoute
  '/_app/integrations/triage/items': typeof AppIntegrationsTriageItemsRoute
  '/_app/items/$itemKey/accounting': typeof AppItemsItemKeyAccountingRoute
  '/_app/items/$itemKey/assets': typeof AppItemsItemKeyAssetsRoute
  '/_app/items/$itemKey/audit': typeof AppItemsItemKeyAuditRoute
  '/_app/items/$itemKey/bom': typeof AppItemsItemKeyBomRoute
  '/_app/items/$itemKey/movement': typeof AppItemsItemKeyMovementRoute
  '/_app/items/$itemKey/pricing': typeof AppItemsItemKeyPricingRoute
  '/_app/items/$itemKey/units': typeof AppItemsItemKeyUnitsRoute
  '/_app/locations/$locationKey/audit': typeof AppLocationsLocationKeyAuditRoute
  '/_app/locations/$locationKey/related-assets': typeof AppLocationsLocationKeyRelatedAssetsRoute
  '/_app/locations/$locationKey/related-projects': typeof AppLocationsLocationKeyRelatedProjectsRoute
  '/_app/locations/$locationKey/related-shipments': typeof AppLocationsLocationKeyRelatedShipmentsRoute
  '/_app/projects/$projectKey/attachments': typeof AppProjectsProjectKeyAttachmentsRoute
  '/_app/projects/$projectKey/audit': typeof AppProjectsProjectKeyAuditRoute
  '/_app/projects/$projectKey/billing-details': typeof AppProjectsProjectKeyBillingDetailsRoute
  '/_app/projects/$projectKey/costs': typeof AppProjectsProjectKeyCostsRoute
  '/_app/projects/$projectKey/fulfillment': typeof AppProjectsProjectKeyFulfillmentRoute
  '/_app/projects/$projectKey/members': typeof AppProjectsProjectKeyMembersRoute
  '/_app/projects/$projectKey/notes': typeof AppProjectsProjectKeyNotesRoute
  '/_app/projects/$projectKey/tickets': typeof AppProjectsProjectKeyTicketsRoute
  '/_app/purchase-orders/$purchaseOrderKey/shipments': typeof AppPurchaseOrdersPurchaseOrderKeyShipmentsRoute
  '/_app/reports/asset-bridge/$tabType': typeof AppReportsAssetBridgeTabTypeRoute
  '/_app/reports/asset-rollforward/$tabType': typeof AppReportsAssetRollforwardTabTypeRoute
  '/_app/reports/asset-snapshot/$tabType': typeof AppReportsAssetSnapshotTabTypeRoute
  '/_app/return-orders/$returnOrderKey/shipments': typeof AppReturnOrdersReturnOrderKeyShipmentsRoute
  '/_app/tickets/$ticketKey/attachments': typeof AppTicketsTicketKeyAttachmentsRoute
  '/_app/tickets/$ticketKey/audit': typeof AppTicketsTicketKeyAuditRoute
  '/_app/accounting/initial-true-up/': typeof AppAccountingInitialTrueUpIndexRoute
  '/_app/assets/$assetKey/': typeof AppAssetsAssetKeyIndexRoute
  '/_app/billing/invoices/': typeof AppBillingInvoicesIndexRoute
  '/_app/catalog/bundles/': typeof AppCatalogBundlesIndexRoute
  '/_app/catalog/items/': typeof AppCatalogItemsIndexRoute
  '/_app/companies/$companyKey/': typeof AppCompaniesCompanyKeyIndexRoute
  '/_app/companies/customers/': typeof AppCompaniesCustomersIndexRoute
  '/_app/companies/suppliers/': typeof AppCompaniesSuppliersIndexRoute
  '/_app/contacts/$contactKey/': typeof AppContactsContactKeyIndexRoute
  '/_app/customers/$customerKey/': typeof AppCustomersCustomerKeyIndexRoute
  '/_app/fulfillments/$fulfillmentKey/': typeof AppFulfillmentsFulfillmentKeyIndexRoute
  '/_app/items/$itemKey/': typeof AppItemsItemKeyIndexRoute
  '/_app/locations/$locationKey/': typeof AppLocationsLocationKeyIndexRoute
  '/_app/projects/$projectKey/': typeof AppProjectsProjectKeyIndexRoute
  '/_app/purchase-orders/$purchaseOrderKey/': typeof AppPurchaseOrdersPurchaseOrderKeyIndexRoute
  '/_app/return-orders/$returnOrderKey/': typeof AppReturnOrdersReturnOrderKeyIndexRoute
  '/_app/tickets/$ticketKey/': typeof AppTicketsTicketKeyIndexRoute
  '/_app/catalog/bundles/$bundleKey/audit': typeof AppCatalogBundlesBundleKeyAuditRoute
  '/_app/catalog/items/$itemKey/accounting': typeof AppCatalogItemsItemKeyAccountingRoute
  '/_app/catalog/items/$itemKey/assets': typeof AppCatalogItemsItemKeyAssetsRoute
  '/_app/catalog/items/$itemKey/audit': typeof AppCatalogItemsItemKeyAuditRoute
  '/_app/catalog/items/$itemKey/bom': typeof AppCatalogItemsItemKeyBomRoute
  '/_app/catalog/items/$itemKey/movement': typeof AppCatalogItemsItemKeyMovementRoute
  '/_app/catalog/items/$itemKey/pricing': typeof AppCatalogItemsItemKeyPricingRoute
  '/_app/catalog/items/$itemKey/units': typeof AppCatalogItemsItemKeyUnitsRoute
  '/_app/reports/exception/asset/$tabType': typeof AppReportsExceptionAssetTabTypeRoute
  '/_app/catalog/bundles/$bundleKey/': typeof AppCatalogBundlesBundleKeyIndexRoute
  '/_app/catalog/items/$itemKey/': typeof AppCatalogItemsItemKeyIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/login'
    | '/register'
    | '/account'
    | '/audit'
    | '/catalog'
    | '/dashboard'
    | '/fulfillment'
    | '/integrations'
    | '/inventory'
    | '/organization'
    | '/purchase-order'
    | '/return-order'
    | '/accounting/close-workflow'
    | '/accounting/initial-true-up'
    | '/accounting/period-review'
    | '/assemblies/$registrationStatus'
    | '/assets/$assetKey'
    | '/billing/aging'
    | '/billing/charges'
    | '/billing/invoice-line-items'
    | '/billing/lifecycle'
    | '/billing/plans'
    | '/catalog/items'
    | '/companies/$companyKey'
    | '/contacts/$contactKey'
    | '/customers/$customerKey'
    | '/dashboard/asset'
    | '/dashboard/customer'
    | '/dashboard/location'
    | '/fulfillment/$fulfillmentKey'
    | '/fulfillments/$fulfillmentKey'
    | '/locations/$locationKey'
    | '/notifications/subscriptions'
    | '/projects/$projectKey'
    | '/purchase-order/$purchaseOrderKey'
    | '/purchase-orders/$purchaseOrderKey'
    | '/reports/active-projects'
    | '/reports/depreciation-schedule'
    | '/reports/field'
    | '/reports/fulfillment'
    | '/reports/inventory'
    | '/reports/past-projects'
    | '/reports/transit'
    | '/reports/upcoming-project-completions'
    | '/reports/upcoming-project-starts'
    | '/reports/upcoming-projects'
    | '/return-order/$returnOrderKey'
    | '/return-orders/$returnOrderKey'
    | '/shipments/$shipmentKey'
    | '/tickets/$ticketKey'
    | '/accounting'
    | '/assemblies'
    | '/assets'
    | '/billing'
    | '/catalog/'
    | '/companies'
    | '/contacts'
    | '/costs'
    | '/customers'
    | '/exchange'
    | '/exchanges'
    | '/fulfillments'
    | '/integrations/'
    | '/items'
    | '/locations'
    | '/movements'
    | '/notifications'
    | '/parts'
    | '/projects'
    | '/purchase-orders'
    | '/reports'
    | '/return-orders'
    | '/shipments'
    | '/tickets'
    | '/time'
    | '/accounting/initial-true-up/$iso'
    | '/assets/$assetKey/accounting'
    | '/assets/$assetKey/attachments'
    | '/assets/$assetKey/audit'
    | '/assets/$assetKey/metadata'
    | '/assets/$assetKey/tickets'
    | '/billing/invoices/$invoiceKey'
    | '/catalog/bundles/$bundleKey'
    | '/catalog/items/$itemKey'
    | '/companies/$companyKey/audit'
    | '/companies/$companyKey/contacts'
    | '/companies/$companyKey/fulfillment'
    | '/companies/$companyKey/location-assets'
    | '/companies/$companyKey/locations'
    | '/companies/$companyKey/owned-assets'
    | '/companies/$companyKey/projects'
    | '/contacts/$contactKey/audit'
    | '/customers/$customerKey/audit'
    | '/customers/$customerKey/fulfillment'
    | '/customers/$customerKey/location-assets'
    | '/customers/$customerKey/locations'
    | '/customers/$customerKey/owned-assets'
    | '/customers/$customerKey/projects'
    | '/fulfillments/$fulfillmentKey/shipments'
    | '/integrations/triage/customers'
    | '/integrations/triage/items'
    | '/items/$itemKey/accounting'
    | '/items/$itemKey/assets'
    | '/items/$itemKey/audit'
    | '/items/$itemKey/bom'
    | '/items/$itemKey/movement'
    | '/items/$itemKey/pricing'
    | '/items/$itemKey/units'
    | '/locations/$locationKey/audit'
    | '/locations/$locationKey/related-assets'
    | '/locations/$locationKey/related-projects'
    | '/locations/$locationKey/related-shipments'
    | '/projects/$projectKey/attachments'
    | '/projects/$projectKey/audit'
    | '/projects/$projectKey/billing-details'
    | '/projects/$projectKey/costs'
    | '/projects/$projectKey/fulfillment'
    | '/projects/$projectKey/members'
    | '/projects/$projectKey/notes'
    | '/projects/$projectKey/tickets'
    | '/purchase-orders/$purchaseOrderKey/shipments'
    | '/reports/asset-bridge/$tabType'
    | '/reports/asset-rollforward/$tabType'
    | '/reports/asset-snapshot/$tabType'
    | '/return-orders/$returnOrderKey/shipments'
    | '/tickets/$ticketKey/attachments'
    | '/tickets/$ticketKey/audit'
    | '/accounting/initial-true-up/'
    | '/assets/$assetKey/'
    | '/billing/invoices'
    | '/catalog/bundles'
    | '/catalog/items/'
    | '/companies/$companyKey/'
    | '/companies/customers'
    | '/companies/suppliers'
    | '/contacts/$contactKey/'
    | '/customers/$customerKey/'
    | '/fulfillments/$fulfillmentKey/'
    | '/items/$itemKey'
    | '/locations/$locationKey/'
    | '/projects/$projectKey/'
    | '/purchase-orders/$purchaseOrderKey/'
    | '/return-orders/$returnOrderKey/'
    | '/tickets/$ticketKey/'
    | '/catalog/bundles/$bundleKey/audit'
    | '/catalog/items/$itemKey/accounting'
    | '/catalog/items/$itemKey/assets'
    | '/catalog/items/$itemKey/audit'
    | '/catalog/items/$itemKey/bom'
    | '/catalog/items/$itemKey/movement'
    | '/catalog/items/$itemKey/pricing'
    | '/catalog/items/$itemKey/units'
    | '/reports/exception/asset/$tabType'
    | '/catalog/bundles/$bundleKey/'
    | '/catalog/items/$itemKey/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/login'
    | '/register'
    | '/account'
    | '/audit'
    | '/dashboard'
    | '/fulfillment'
    | '/inventory'
    | '/organization'
    | '/purchase-order'
    | '/return-order'
    | '/accounting/close-workflow'
    | '/accounting/period-review'
    | '/assemblies/$registrationStatus'
    | '/billing/aging'
    | '/billing/charges'
    | '/billing/invoice-line-items'
    | '/billing/lifecycle'
    | '/billing/plans'
    | '/dashboard/asset'
    | '/dashboard/customer'
    | '/dashboard/location'
    | '/fulfillment/$fulfillmentKey'
    | '/notifications/subscriptions'
    | '/purchase-order/$purchaseOrderKey'
    | '/reports/active-projects'
    | '/reports/depreciation-schedule'
    | '/reports/field'
    | '/reports/fulfillment'
    | '/reports/inventory'
    | '/reports/past-projects'
    | '/reports/transit'
    | '/reports/upcoming-project-completions'
    | '/reports/upcoming-project-starts'
    | '/reports/upcoming-projects'
    | '/return-order/$returnOrderKey'
    | '/shipments/$shipmentKey'
    | '/accounting'
    | '/assemblies'
    | '/assets'
    | '/billing'
    | '/catalog'
    | '/companies'
    | '/contacts'
    | '/costs'
    | '/customers'
    | '/exchange'
    | '/exchanges'
    | '/fulfillments'
    | '/integrations'
    | '/items'
    | '/locations'
    | '/movements'
    | '/notifications'
    | '/parts'
    | '/projects'
    | '/purchase-orders'
    | '/reports'
    | '/return-orders'
    | '/shipments'
    | '/tickets'
    | '/time'
    | '/accounting/initial-true-up/$iso'
    | '/assets/$assetKey/accounting'
    | '/assets/$assetKey/attachments'
    | '/assets/$assetKey/audit'
    | '/assets/$assetKey/metadata'
    | '/assets/$assetKey/tickets'
    | '/billing/invoices/$invoiceKey'
    | '/companies/$companyKey/audit'
    | '/companies/$companyKey/contacts'
    | '/companies/$companyKey/fulfillment'
    | '/companies/$companyKey/location-assets'
    | '/companies/$companyKey/locations'
    | '/companies/$companyKey/owned-assets'
    | '/companies/$companyKey/projects'
    | '/contacts/$contactKey/audit'
    | '/customers/$customerKey/audit'
    | '/customers/$customerKey/fulfillment'
    | '/customers/$customerKey/location-assets'
    | '/customers/$customerKey/locations'
    | '/customers/$customerKey/owned-assets'
    | '/customers/$customerKey/projects'
    | '/fulfillments/$fulfillmentKey/shipments'
    | '/integrations/triage/customers'
    | '/integrations/triage/items'
    | '/items/$itemKey/accounting'
    | '/items/$itemKey/assets'
    | '/items/$itemKey/audit'
    | '/items/$itemKey/bom'
    | '/items/$itemKey/movement'
    | '/items/$itemKey/pricing'
    | '/items/$itemKey/units'
    | '/locations/$locationKey/audit'
    | '/locations/$locationKey/related-assets'
    | '/locations/$locationKey/related-projects'
    | '/locations/$locationKey/related-shipments'
    | '/projects/$projectKey/attachments'
    | '/projects/$projectKey/audit'
    | '/projects/$projectKey/billing-details'
    | '/projects/$projectKey/costs'
    | '/projects/$projectKey/fulfillment'
    | '/projects/$projectKey/members'
    | '/projects/$projectKey/notes'
    | '/projects/$projectKey/tickets'
    | '/purchase-orders/$purchaseOrderKey/shipments'
    | '/reports/asset-bridge/$tabType'
    | '/reports/asset-rollforward/$tabType'
    | '/reports/asset-snapshot/$tabType'
    | '/return-orders/$returnOrderKey/shipments'
    | '/tickets/$ticketKey/attachments'
    | '/tickets/$ticketKey/audit'
    | '/accounting/initial-true-up'
    | '/assets/$assetKey'
    | '/billing/invoices'
    | '/catalog/bundles'
    | '/catalog/items'
    | '/companies/$companyKey'
    | '/companies/customers'
    | '/companies/suppliers'
    | '/contacts/$contactKey'
    | '/customers/$customerKey'
    | '/fulfillments/$fulfillmentKey'
    | '/items/$itemKey'
    | '/locations/$locationKey'
    | '/projects/$projectKey'
    | '/purchase-orders/$purchaseOrderKey'
    | '/return-orders/$returnOrderKey'
    | '/tickets/$ticketKey'
    | '/catalog/bundles/$bundleKey/audit'
    | '/catalog/items/$itemKey/accounting'
    | '/catalog/items/$itemKey/assets'
    | '/catalog/items/$itemKey/audit'
    | '/catalog/items/$itemKey/bom'
    | '/catalog/items/$itemKey/movement'
    | '/catalog/items/$itemKey/pricing'
    | '/catalog/items/$itemKey/units'
    | '/reports/exception/asset/$tabType'
    | '/catalog/bundles/$bundleKey'
    | '/catalog/items/$itemKey'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/login'
    | '/register'
    | '/_app/account'
    | '/_app/audit'
    | '/_app/catalog'
    | '/_app/dashboard'
    | '/_app/fulfillment'
    | '/_app/integrations'
    | '/_app/inventory'
    | '/_app/organization'
    | '/_app/purchase-order'
    | '/_app/return-order'
    | '/_app/accounting/close-workflow'
    | '/_app/accounting/initial-true-up'
    | '/_app/accounting/period-review'
    | '/_app/assemblies/$registrationStatus'
    | '/_app/assets/$assetKey'
    | '/_app/billing/aging'
    | '/_app/billing/charges'
    | '/_app/billing/invoice-line-items'
    | '/_app/billing/lifecycle'
    | '/_app/billing/plans'
    | '/_app/catalog/items'
    | '/_app/companies/$companyKey'
    | '/_app/contacts/$contactKey'
    | '/_app/customers/$customerKey'
    | '/_app/dashboard/asset'
    | '/_app/dashboard/customer'
    | '/_app/dashboard/location'
    | '/_app/fulfillment/$fulfillmentKey'
    | '/_app/fulfillments/$fulfillmentKey'
    | '/_app/locations/$locationKey'
    | '/_app/notifications/subscriptions'
    | '/_app/projects/$projectKey'
    | '/_app/purchase-order/$purchaseOrderKey'
    | '/_app/purchase-orders/$purchaseOrderKey'
    | '/_app/reports/active-projects'
    | '/_app/reports/depreciation-schedule'
    | '/_app/reports/field'
    | '/_app/reports/fulfillment'
    | '/_app/reports/inventory'
    | '/_app/reports/past-projects'
    | '/_app/reports/transit'
    | '/_app/reports/upcoming-project-completions'
    | '/_app/reports/upcoming-project-starts'
    | '/_app/reports/upcoming-projects'
    | '/_app/return-order/$returnOrderKey'
    | '/_app/return-orders/$returnOrderKey'
    | '/_app/shipments/$shipmentKey'
    | '/_app/tickets/$ticketKey'
    | '/_app/accounting/'
    | '/_app/assemblies/'
    | '/_app/assets/'
    | '/_app/billing/'
    | '/_app/catalog/'
    | '/_app/companies/'
    | '/_app/contacts/'
    | '/_app/costs/'
    | '/_app/customers/'
    | '/_app/exchange/'
    | '/_app/exchanges/'
    | '/_app/fulfillments/'
    | '/_app/integrations/'
    | '/_app/items/'
    | '/_app/locations/'
    | '/_app/movements/'
    | '/_app/notifications/'
    | '/_app/parts/'
    | '/_app/projects/'
    | '/_app/purchase-orders/'
    | '/_app/reports/'
    | '/_app/return-orders/'
    | '/_app/shipments/'
    | '/_app/tickets/'
    | '/_app/time/'
    | '/_app/accounting/initial-true-up/$iso'
    | '/_app/assets/$assetKey/accounting'
    | '/_app/assets/$assetKey/attachments'
    | '/_app/assets/$assetKey/audit'
    | '/_app/assets/$assetKey/metadata'
    | '/_app/assets/$assetKey/tickets'
    | '/_app/billing/invoices/$invoiceKey'
    | '/_app/catalog/bundles/$bundleKey'
    | '/_app/catalog/items/$itemKey'
    | '/_app/companies/$companyKey/audit'
    | '/_app/companies/$companyKey/contacts'
    | '/_app/companies/$companyKey/fulfillment'
    | '/_app/companies/$companyKey/location-assets'
    | '/_app/companies/$companyKey/locations'
    | '/_app/companies/$companyKey/owned-assets'
    | '/_app/companies/$companyKey/projects'
    | '/_app/contacts/$contactKey/audit'
    | '/_app/customers/$customerKey/audit'
    | '/_app/customers/$customerKey/fulfillment'
    | '/_app/customers/$customerKey/location-assets'
    | '/_app/customers/$customerKey/locations'
    | '/_app/customers/$customerKey/owned-assets'
    | '/_app/customers/$customerKey/projects'
    | '/_app/fulfillments/$fulfillmentKey/shipments'
    | '/_app/integrations/triage/customers'
    | '/_app/integrations/triage/items'
    | '/_app/items/$itemKey/accounting'
    | '/_app/items/$itemKey/assets'
    | '/_app/items/$itemKey/audit'
    | '/_app/items/$itemKey/bom'
    | '/_app/items/$itemKey/movement'
    | '/_app/items/$itemKey/pricing'
    | '/_app/items/$itemKey/units'
    | '/_app/locations/$locationKey/audit'
    | '/_app/locations/$locationKey/related-assets'
    | '/_app/locations/$locationKey/related-projects'
    | '/_app/locations/$locationKey/related-shipments'
    | '/_app/projects/$projectKey/attachments'
    | '/_app/projects/$projectKey/audit'
    | '/_app/projects/$projectKey/billing-details'
    | '/_app/projects/$projectKey/costs'
    | '/_app/projects/$projectKey/fulfillment'
    | '/_app/projects/$projectKey/members'
    | '/_app/projects/$projectKey/notes'
    | '/_app/projects/$projectKey/tickets'
    | '/_app/purchase-orders/$purchaseOrderKey/shipments'
    | '/_app/reports/asset-bridge/$tabType'
    | '/_app/reports/asset-rollforward/$tabType'
    | '/_app/reports/asset-snapshot/$tabType'
    | '/_app/return-orders/$returnOrderKey/shipments'
    | '/_app/tickets/$ticketKey/attachments'
    | '/_app/tickets/$ticketKey/audit'
    | '/_app/accounting/initial-true-up/'
    | '/_app/assets/$assetKey/'
    | '/_app/billing/invoices/'
    | '/_app/catalog/bundles/'
    | '/_app/catalog/items/'
    | '/_app/companies/$companyKey/'
    | '/_app/companies/customers/'
    | '/_app/companies/suppliers/'
    | '/_app/contacts/$contactKey/'
    | '/_app/customers/$customerKey/'
    | '/_app/fulfillments/$fulfillmentKey/'
    | '/_app/items/$itemKey/'
    | '/_app/locations/$locationKey/'
    | '/_app/projects/$projectKey/'
    | '/_app/purchase-orders/$purchaseOrderKey/'
    | '/_app/return-orders/$returnOrderKey/'
    | '/_app/tickets/$ticketKey/'
    | '/_app/catalog/bundles/$bundleKey/audit'
    | '/_app/catalog/items/$itemKey/accounting'
    | '/_app/catalog/items/$itemKey/assets'
    | '/_app/catalog/items/$itemKey/audit'
    | '/_app/catalog/items/$itemKey/bom'
    | '/_app/catalog/items/$itemKey/movement'
    | '/_app/catalog/items/$itemKey/pricing'
    | '/_app/catalog/items/$itemKey/units'
    | '/_app/reports/exception/asset/$tabType'
    | '/_app/catalog/bundles/$bundleKey/'
    | '/_app/catalog/items/$itemKey/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_app",
        "/login",
        "/register"
      ]
    },
    "/": {
      "filePath": "index.ts"
    },
    "/_app": {
      "filePath": "_app.tsx",
      "children": [
        "/_app/account",
        "/_app/audit",
        "/_app/catalog",
        "/_app/dashboard",
        "/_app/fulfillment",
        "/_app/integrations",
        "/_app/inventory",
        "/_app/organization",
        "/_app/purchase-order",
        "/_app/return-order",
        "/_app/accounting/close-workflow",
        "/_app/accounting/initial-true-up",
        "/_app/accounting/period-review",
        "/_app/assemblies/$registrationStatus",
        "/_app/assets/$assetKey",
        "/_app/billing/aging",
        "/_app/billing/charges",
        "/_app/billing/invoice-line-items",
        "/_app/billing/lifecycle",
        "/_app/billing/plans",
        "/_app/companies/$companyKey",
        "/_app/contacts/$contactKey",
        "/_app/customers/$customerKey",
        "/_app/fulfillments/$fulfillmentKey",
        "/_app/locations/$locationKey",
        "/_app/notifications/subscriptions",
        "/_app/projects/$projectKey",
        "/_app/purchase-orders/$purchaseOrderKey",
        "/_app/reports/active-projects",
        "/_app/reports/depreciation-schedule",
        "/_app/reports/field",
        "/_app/reports/fulfillment",
        "/_app/reports/inventory",
        "/_app/reports/past-projects",
        "/_app/reports/transit",
        "/_app/reports/upcoming-project-completions",
        "/_app/reports/upcoming-project-starts",
        "/_app/reports/upcoming-projects",
        "/_app/return-orders/$returnOrderKey",
        "/_app/shipments/$shipmentKey",
        "/_app/tickets/$ticketKey",
        "/_app/accounting/",
        "/_app/assemblies/",
        "/_app/assets/",
        "/_app/billing/",
        "/_app/companies/",
        "/_app/contacts/",
        "/_app/costs/",
        "/_app/customers/",
        "/_app/exchange/",
        "/_app/exchanges/",
        "/_app/fulfillments/",
        "/_app/items/",
        "/_app/locations/",
        "/_app/movements/",
        "/_app/notifications/",
        "/_app/parts/",
        "/_app/projects/",
        "/_app/purchase-orders/",
        "/_app/reports/",
        "/_app/return-orders/",
        "/_app/shipments/",
        "/_app/tickets/",
        "/_app/time/",
        "/_app/billing/invoices/$invoiceKey",
        "/_app/items/$itemKey/accounting",
        "/_app/items/$itemKey/assets",
        "/_app/items/$itemKey/audit",
        "/_app/items/$itemKey/bom",
        "/_app/items/$itemKey/movement",
        "/_app/items/$itemKey/pricing",
        "/_app/items/$itemKey/units",
        "/_app/reports/asset-bridge/$tabType",
        "/_app/reports/asset-rollforward/$tabType",
        "/_app/reports/asset-snapshot/$tabType",
        "/_app/billing/invoices/",
        "/_app/companies/customers/",
        "/_app/companies/suppliers/",
        "/_app/items/$itemKey/",
        "/_app/reports/exception/asset/$tabType"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/register": {
      "filePath": "register.tsx"
    },
    "/_app/account": {
      "filePath": "_app/account.tsx",
      "parent": "/_app"
    },
    "/_app/audit": {
      "filePath": "_app/audit.tsx",
      "parent": "/_app"
    },
    "/_app/catalog": {
      "filePath": "_app/catalog.tsx",
      "parent": "/_app",
      "children": [
        "/_app/catalog/items",
        "/_app/catalog/",
        "/_app/catalog/bundles/$bundleKey",
        "/_app/catalog/bundles/"
      ]
    },
    "/_app/dashboard": {
      "filePath": "_app/dashboard.tsx",
      "parent": "/_app",
      "children": [
        "/_app/dashboard/asset",
        "/_app/dashboard/customer",
        "/_app/dashboard/location"
      ]
    },
    "/_app/fulfillment": {
      "filePath": "_app/fulfillment.tsx",
      "parent": "/_app",
      "children": [
        "/_app/fulfillment/$fulfillmentKey"
      ]
    },
    "/_app/integrations": {
      "filePath": "_app/integrations.tsx",
      "parent": "/_app",
      "children": [
        "/_app/integrations/",
        "/_app/integrations/triage/customers",
        "/_app/integrations/triage/items"
      ]
    },
    "/_app/inventory": {
      "filePath": "_app/inventory.tsx",
      "parent": "/_app"
    },
    "/_app/organization": {
      "filePath": "_app/organization.tsx",
      "parent": "/_app"
    },
    "/_app/purchase-order": {
      "filePath": "_app/purchase-order.tsx",
      "parent": "/_app",
      "children": [
        "/_app/purchase-order/$purchaseOrderKey"
      ]
    },
    "/_app/return-order": {
      "filePath": "_app/return-order.tsx",
      "parent": "/_app",
      "children": [
        "/_app/return-order/$returnOrderKey"
      ]
    },
    "/_app/accounting/close-workflow": {
      "filePath": "_app/accounting.close-workflow.tsx",
      "parent": "/_app"
    },
    "/_app/accounting/initial-true-up": {
      "filePath": "_app/accounting.initial-true-up.tsx",
      "parent": "/_app",
      "children": [
        "/_app/accounting/initial-true-up/$iso",
        "/_app/accounting/initial-true-up/"
      ]
    },
    "/_app/accounting/period-review": {
      "filePath": "_app/accounting.period-review.tsx",
      "parent": "/_app"
    },
    "/_app/assemblies/$registrationStatus": {
      "filePath": "_app/assemblies/$registrationStatus.tsx",
      "parent": "/_app"
    },
    "/_app/assets/$assetKey": {
      "filePath": "_app/assets.$assetKey.tsx",
      "parent": "/_app",
      "children": [
        "/_app/assets/$assetKey/accounting",
        "/_app/assets/$assetKey/attachments",
        "/_app/assets/$assetKey/audit",
        "/_app/assets/$assetKey/metadata",
        "/_app/assets/$assetKey/tickets",
        "/_app/assets/$assetKey/"
      ]
    },
    "/_app/billing/aging": {
      "filePath": "_app/billing.aging.tsx",
      "parent": "/_app"
    },
    "/_app/billing/charges": {
      "filePath": "_app/billing.charges.tsx",
      "parent": "/_app"
    },
    "/_app/billing/invoice-line-items": {
      "filePath": "_app/billing.invoice-line-items.tsx",
      "parent": "/_app"
    },
    "/_app/billing/lifecycle": {
      "filePath": "_app/billing.lifecycle.tsx",
      "parent": "/_app"
    },
    "/_app/billing/plans": {
      "filePath": "_app/billing.plans.tsx",
      "parent": "/_app"
    },
    "/_app/catalog/items": {
      "filePath": "_app/catalog.items.tsx",
      "parent": "/_app/catalog",
      "children": [
        "/_app/catalog/items/$itemKey",
        "/_app/catalog/items/"
      ]
    },
    "/_app/companies/$companyKey": {
      "filePath": "_app/companies.$companyKey.tsx",
      "parent": "/_app",
      "children": [
        "/_app/companies/$companyKey/audit",
        "/_app/companies/$companyKey/contacts",
        "/_app/companies/$companyKey/fulfillment",
        "/_app/companies/$companyKey/location-assets",
        "/_app/companies/$companyKey/locations",
        "/_app/companies/$companyKey/owned-assets",
        "/_app/companies/$companyKey/projects",
        "/_app/companies/$companyKey/"
      ]
    },
    "/_app/contacts/$contactKey": {
      "filePath": "_app/contacts.$contactKey.tsx",
      "parent": "/_app",
      "children": [
        "/_app/contacts/$contactKey/audit",
        "/_app/contacts/$contactKey/"
      ]
    },
    "/_app/customers/$customerKey": {
      "filePath": "_app/customers.$customerKey.tsx",
      "parent": "/_app",
      "children": [
        "/_app/customers/$customerKey/audit",
        "/_app/customers/$customerKey/fulfillment",
        "/_app/customers/$customerKey/location-assets",
        "/_app/customers/$customerKey/locations",
        "/_app/customers/$customerKey/owned-assets",
        "/_app/customers/$customerKey/projects",
        "/_app/customers/$customerKey/"
      ]
    },
    "/_app/dashboard/asset": {
      "filePath": "_app/dashboard.asset.tsx",
      "parent": "/_app/dashboard"
    },
    "/_app/dashboard/customer": {
      "filePath": "_app/dashboard.customer.tsx",
      "parent": "/_app/dashboard"
    },
    "/_app/dashboard/location": {
      "filePath": "_app/dashboard.location.tsx",
      "parent": "/_app/dashboard"
    },
    "/_app/fulfillment/$fulfillmentKey": {
      "filePath": "_app/fulfillment.$fulfillmentKey.tsx",
      "parent": "/_app/fulfillment"
    },
    "/_app/fulfillments/$fulfillmentKey": {
      "filePath": "_app/fulfillments.$fulfillmentKey.tsx",
      "parent": "/_app",
      "children": [
        "/_app/fulfillments/$fulfillmentKey/shipments",
        "/_app/fulfillments/$fulfillmentKey/"
      ]
    },
    "/_app/locations/$locationKey": {
      "filePath": "_app/locations.$locationKey.tsx",
      "parent": "/_app",
      "children": [
        "/_app/locations/$locationKey/audit",
        "/_app/locations/$locationKey/related-assets",
        "/_app/locations/$locationKey/related-projects",
        "/_app/locations/$locationKey/related-shipments",
        "/_app/locations/$locationKey/"
      ]
    },
    "/_app/notifications/subscriptions": {
      "filePath": "_app/notifications.subscriptions.tsx",
      "parent": "/_app"
    },
    "/_app/projects/$projectKey": {
      "filePath": "_app/projects.$projectKey.tsx",
      "parent": "/_app",
      "children": [
        "/_app/projects/$projectKey/attachments",
        "/_app/projects/$projectKey/audit",
        "/_app/projects/$projectKey/billing-details",
        "/_app/projects/$projectKey/costs",
        "/_app/projects/$projectKey/fulfillment",
        "/_app/projects/$projectKey/members",
        "/_app/projects/$projectKey/notes",
        "/_app/projects/$projectKey/tickets",
        "/_app/projects/$projectKey/"
      ]
    },
    "/_app/purchase-order/$purchaseOrderKey": {
      "filePath": "_app/purchase-order.$purchaseOrderKey.tsx",
      "parent": "/_app/purchase-order"
    },
    "/_app/purchase-orders/$purchaseOrderKey": {
      "filePath": "_app/purchase-orders.$purchaseOrderKey.tsx",
      "parent": "/_app",
      "children": [
        "/_app/purchase-orders/$purchaseOrderKey/shipments",
        "/_app/purchase-orders/$purchaseOrderKey/"
      ]
    },
    "/_app/reports/active-projects": {
      "filePath": "_app/reports.active-projects.tsx",
      "parent": "/_app"
    },
    "/_app/reports/depreciation-schedule": {
      "filePath": "_app/reports.depreciation-schedule.tsx",
      "parent": "/_app"
    },
    "/_app/reports/field": {
      "filePath": "_app/reports.field.tsx",
      "parent": "/_app"
    },
    "/_app/reports/fulfillment": {
      "filePath": "_app/reports.fulfillment.tsx",
      "parent": "/_app"
    },
    "/_app/reports/inventory": {
      "filePath": "_app/reports.inventory.tsx",
      "parent": "/_app"
    },
    "/_app/reports/past-projects": {
      "filePath": "_app/reports.past-projects.tsx",
      "parent": "/_app"
    },
    "/_app/reports/transit": {
      "filePath": "_app/reports.transit.tsx",
      "parent": "/_app"
    },
    "/_app/reports/upcoming-project-completions": {
      "filePath": "_app/reports.upcoming-project-completions.tsx",
      "parent": "/_app"
    },
    "/_app/reports/upcoming-project-starts": {
      "filePath": "_app/reports.upcoming-project-starts.tsx",
      "parent": "/_app"
    },
    "/_app/reports/upcoming-projects": {
      "filePath": "_app/reports.upcoming-projects.tsx",
      "parent": "/_app"
    },
    "/_app/return-order/$returnOrderKey": {
      "filePath": "_app/return-order.$returnOrderKey.tsx",
      "parent": "/_app/return-order"
    },
    "/_app/return-orders/$returnOrderKey": {
      "filePath": "_app/return-orders.$returnOrderKey.tsx",
      "parent": "/_app",
      "children": [
        "/_app/return-orders/$returnOrderKey/shipments",
        "/_app/return-orders/$returnOrderKey/"
      ]
    },
    "/_app/shipments/$shipmentKey": {
      "filePath": "_app/shipments.$shipmentKey.tsx",
      "parent": "/_app"
    },
    "/_app/tickets/$ticketKey": {
      "filePath": "_app/tickets/$ticketKey.tsx",
      "parent": "/_app",
      "children": [
        "/_app/tickets/$ticketKey/attachments",
        "/_app/tickets/$ticketKey/audit",
        "/_app/tickets/$ticketKey/"
      ]
    },
    "/_app/accounting/": {
      "filePath": "_app/accounting.index.tsx",
      "parent": "/_app"
    },
    "/_app/assemblies/": {
      "filePath": "_app/assemblies.index.tsx",
      "parent": "/_app"
    },
    "/_app/assets/": {
      "filePath": "_app/assets.index.tsx",
      "parent": "/_app"
    },
    "/_app/billing/": {
      "filePath": "_app/billing.index.tsx",
      "parent": "/_app"
    },
    "/_app/catalog/": {
      "filePath": "_app/catalog.index.tsx",
      "parent": "/_app/catalog"
    },
    "/_app/companies/": {
      "filePath": "_app/companies.index.tsx",
      "parent": "/_app"
    },
    "/_app/contacts/": {
      "filePath": "_app/contacts.index.tsx",
      "parent": "/_app"
    },
    "/_app/costs/": {
      "filePath": "_app/costs.index.tsx",
      "parent": "/_app"
    },
    "/_app/customers/": {
      "filePath": "_app/customers.index.tsx",
      "parent": "/_app"
    },
    "/_app/exchange/": {
      "filePath": "_app/exchange.index.tsx",
      "parent": "/_app"
    },
    "/_app/exchanges/": {
      "filePath": "_app/exchanges.index.tsx",
      "parent": "/_app"
    },
    "/_app/fulfillments/": {
      "filePath": "_app/fulfillments.index.tsx",
      "parent": "/_app"
    },
    "/_app/integrations/": {
      "filePath": "_app/integrations.index.tsx",
      "parent": "/_app/integrations"
    },
    "/_app/items/": {
      "filePath": "_app/items.index.tsx",
      "parent": "/_app"
    },
    "/_app/locations/": {
      "filePath": "_app/locations.index.tsx",
      "parent": "/_app"
    },
    "/_app/movements/": {
      "filePath": "_app/movements.index.tsx",
      "parent": "/_app"
    },
    "/_app/notifications/": {
      "filePath": "_app/notifications.index.tsx",
      "parent": "/_app"
    },
    "/_app/parts/": {
      "filePath": "_app/parts.index.tsx",
      "parent": "/_app"
    },
    "/_app/projects/": {
      "filePath": "_app/projects.index.tsx",
      "parent": "/_app"
    },
    "/_app/purchase-orders/": {
      "filePath": "_app/purchase-orders.index.tsx",
      "parent": "/_app"
    },
    "/_app/reports/": {
      "filePath": "_app/reports.index.tsx",
      "parent": "/_app"
    },
    "/_app/return-orders/": {
      "filePath": "_app/return-orders.index.tsx",
      "parent": "/_app"
    },
    "/_app/shipments/": {
      "filePath": "_app/shipments.index.tsx",
      "parent": "/_app"
    },
    "/_app/tickets/": {
      "filePath": "_app/tickets/index.tsx",
      "parent": "/_app"
    },
    "/_app/time/": {
      "filePath": "_app/time.index.tsx",
      "parent": "/_app"
    },
    "/_app/accounting/initial-true-up/$iso": {
      "filePath": "_app/accounting.initial-true-up.$iso.tsx",
      "parent": "/_app/accounting/initial-true-up"
    },
    "/_app/assets/$assetKey/accounting": {
      "filePath": "_app/assets.$assetKey.accounting.tsx",
      "parent": "/_app/assets/$assetKey"
    },
    "/_app/assets/$assetKey/attachments": {
      "filePath": "_app/assets.$assetKey.attachments.tsx",
      "parent": "/_app/assets/$assetKey"
    },
    "/_app/assets/$assetKey/audit": {
      "filePath": "_app/assets.$assetKey.audit.tsx",
      "parent": "/_app/assets/$assetKey"
    },
    "/_app/assets/$assetKey/metadata": {
      "filePath": "_app/assets.$assetKey.metadata.tsx",
      "parent": "/_app/assets/$assetKey"
    },
    "/_app/assets/$assetKey/tickets": {
      "filePath": "_app/assets.$assetKey.tickets.tsx",
      "parent": "/_app/assets/$assetKey"
    },
    "/_app/billing/invoices/$invoiceKey": {
      "filePath": "_app/billing.invoices.$invoiceKey.tsx",
      "parent": "/_app"
    },
    "/_app/catalog/bundles/$bundleKey": {
      "filePath": "_app/catalog.bundles.$bundleKey.tsx",
      "parent": "/_app/catalog",
      "children": [
        "/_app/catalog/bundles/$bundleKey/audit",
        "/_app/catalog/bundles/$bundleKey/"
      ]
    },
    "/_app/catalog/items/$itemKey": {
      "filePath": "_app/catalog.items.$itemKey.tsx",
      "parent": "/_app/catalog/items",
      "children": [
        "/_app/catalog/items/$itemKey/accounting",
        "/_app/catalog/items/$itemKey/assets",
        "/_app/catalog/items/$itemKey/audit",
        "/_app/catalog/items/$itemKey/bom",
        "/_app/catalog/items/$itemKey/movement",
        "/_app/catalog/items/$itemKey/pricing",
        "/_app/catalog/items/$itemKey/units",
        "/_app/catalog/items/$itemKey/"
      ]
    },
    "/_app/companies/$companyKey/audit": {
      "filePath": "_app/companies.$companyKey.audit.tsx",
      "parent": "/_app/companies/$companyKey"
    },
    "/_app/companies/$companyKey/contacts": {
      "filePath": "_app/companies.$companyKey.contacts.tsx",
      "parent": "/_app/companies/$companyKey"
    },
    "/_app/companies/$companyKey/fulfillment": {
      "filePath": "_app/companies.$companyKey.fulfillment.tsx",
      "parent": "/_app/companies/$companyKey"
    },
    "/_app/companies/$companyKey/location-assets": {
      "filePath": "_app/companies.$companyKey.location-assets.tsx",
      "parent": "/_app/companies/$companyKey"
    },
    "/_app/companies/$companyKey/locations": {
      "filePath": "_app/companies.$companyKey.locations.tsx",
      "parent": "/_app/companies/$companyKey"
    },
    "/_app/companies/$companyKey/owned-assets": {
      "filePath": "_app/companies.$companyKey.owned-assets.tsx",
      "parent": "/_app/companies/$companyKey"
    },
    "/_app/companies/$companyKey/projects": {
      "filePath": "_app/companies.$companyKey.projects.tsx",
      "parent": "/_app/companies/$companyKey"
    },
    "/_app/contacts/$contactKey/audit": {
      "filePath": "_app/contacts.$contactKey.audit.tsx",
      "parent": "/_app/contacts/$contactKey"
    },
    "/_app/customers/$customerKey/audit": {
      "filePath": "_app/customers.$customerKey.audit.tsx",
      "parent": "/_app/customers/$customerKey"
    },
    "/_app/customers/$customerKey/fulfillment": {
      "filePath": "_app/customers.$customerKey.fulfillment.tsx",
      "parent": "/_app/customers/$customerKey"
    },
    "/_app/customers/$customerKey/location-assets": {
      "filePath": "_app/customers.$customerKey.location-assets.tsx",
      "parent": "/_app/customers/$customerKey"
    },
    "/_app/customers/$customerKey/locations": {
      "filePath": "_app/customers.$customerKey.locations.tsx",
      "parent": "/_app/customers/$customerKey"
    },
    "/_app/customers/$customerKey/owned-assets": {
      "filePath": "_app/customers.$customerKey.owned-assets.tsx",
      "parent": "/_app/customers/$customerKey"
    },
    "/_app/customers/$customerKey/projects": {
      "filePath": "_app/customers.$customerKey.projects.tsx",
      "parent": "/_app/customers/$customerKey"
    },
    "/_app/fulfillments/$fulfillmentKey/shipments": {
      "filePath": "_app/fulfillments.$fulfillmentKey.shipments.tsx",
      "parent": "/_app/fulfillments/$fulfillmentKey"
    },
    "/_app/integrations/triage/customers": {
      "filePath": "_app/integrations.triage.customers.tsx",
      "parent": "/_app/integrations"
    },
    "/_app/integrations/triage/items": {
      "filePath": "_app/integrations.triage.items.tsx",
      "parent": "/_app/integrations"
    },
    "/_app/items/$itemKey/accounting": {
      "filePath": "_app/items.$itemKey.accounting.tsx",
      "parent": "/_app"
    },
    "/_app/items/$itemKey/assets": {
      "filePath": "_app/items.$itemKey.assets.tsx",
      "parent": "/_app"
    },
    "/_app/items/$itemKey/audit": {
      "filePath": "_app/items.$itemKey.audit.tsx",
      "parent": "/_app"
    },
    "/_app/items/$itemKey/bom": {
      "filePath": "_app/items.$itemKey.bom.tsx",
      "parent": "/_app"
    },
    "/_app/items/$itemKey/movement": {
      "filePath": "_app/items.$itemKey.movement.tsx",
      "parent": "/_app"
    },
    "/_app/items/$itemKey/pricing": {
      "filePath": "_app/items.$itemKey.pricing.tsx",
      "parent": "/_app"
    },
    "/_app/items/$itemKey/units": {
      "filePath": "_app/items.$itemKey.units.tsx",
      "parent": "/_app"
    },
    "/_app/locations/$locationKey/audit": {
      "filePath": "_app/locations.$locationKey.audit.tsx",
      "parent": "/_app/locations/$locationKey"
    },
    "/_app/locations/$locationKey/related-assets": {
      "filePath": "_app/locations.$locationKey.related-assets.tsx",
      "parent": "/_app/locations/$locationKey"
    },
    "/_app/locations/$locationKey/related-projects": {
      "filePath": "_app/locations.$locationKey.related-projects.tsx",
      "parent": "/_app/locations/$locationKey"
    },
    "/_app/locations/$locationKey/related-shipments": {
      "filePath": "_app/locations.$locationKey.related-shipments.tsx",
      "parent": "/_app/locations/$locationKey"
    },
    "/_app/projects/$projectKey/attachments": {
      "filePath": "_app/projects.$projectKey.attachments.tsx",
      "parent": "/_app/projects/$projectKey"
    },
    "/_app/projects/$projectKey/audit": {
      "filePath": "_app/projects.$projectKey.audit.tsx",
      "parent": "/_app/projects/$projectKey"
    },
    "/_app/projects/$projectKey/billing-details": {
      "filePath": "_app/projects.$projectKey.billing-details.tsx",
      "parent": "/_app/projects/$projectKey"
    },
    "/_app/projects/$projectKey/costs": {
      "filePath": "_app/projects.$projectKey.costs.tsx",
      "parent": "/_app/projects/$projectKey"
    },
    "/_app/projects/$projectKey/fulfillment": {
      "filePath": "_app/projects.$projectKey.fulfillment.tsx",
      "parent": "/_app/projects/$projectKey"
    },
    "/_app/projects/$projectKey/members": {
      "filePath": "_app/projects.$projectKey.members.tsx",
      "parent": "/_app/projects/$projectKey"
    },
    "/_app/projects/$projectKey/notes": {
      "filePath": "_app/projects.$projectKey.notes.tsx",
      "parent": "/_app/projects/$projectKey"
    },
    "/_app/projects/$projectKey/tickets": {
      "filePath": "_app/projects.$projectKey.tickets.tsx",
      "parent": "/_app/projects/$projectKey"
    },
    "/_app/purchase-orders/$purchaseOrderKey/shipments": {
      "filePath": "_app/purchase-orders.$purchaseOrderKey.shipments.tsx",
      "parent": "/_app/purchase-orders/$purchaseOrderKey"
    },
    "/_app/reports/asset-bridge/$tabType": {
      "filePath": "_app/reports.asset-bridge.$tabType.tsx",
      "parent": "/_app"
    },
    "/_app/reports/asset-rollforward/$tabType": {
      "filePath": "_app/reports.asset-rollforward.$tabType.tsx",
      "parent": "/_app"
    },
    "/_app/reports/asset-snapshot/$tabType": {
      "filePath": "_app/reports.asset-snapshot.$tabType.tsx",
      "parent": "/_app"
    },
    "/_app/return-orders/$returnOrderKey/shipments": {
      "filePath": "_app/return-orders.$returnOrderKey.shipments.tsx",
      "parent": "/_app/return-orders/$returnOrderKey"
    },
    "/_app/tickets/$ticketKey/attachments": {
      "filePath": "_app/tickets/$ticketKey.attachments.tsx",
      "parent": "/_app/tickets/$ticketKey"
    },
    "/_app/tickets/$ticketKey/audit": {
      "filePath": "_app/tickets/$ticketKey.audit.tsx",
      "parent": "/_app/tickets/$ticketKey"
    },
    "/_app/accounting/initial-true-up/": {
      "filePath": "_app/accounting.initial-true-up.index.tsx",
      "parent": "/_app/accounting/initial-true-up"
    },
    "/_app/assets/$assetKey/": {
      "filePath": "_app/assets.$assetKey.index.tsx",
      "parent": "/_app/assets/$assetKey"
    },
    "/_app/billing/invoices/": {
      "filePath": "_app/billing.invoices.index.tsx",
      "parent": "/_app"
    },
    "/_app/catalog/bundles/": {
      "filePath": "_app/catalog.bundles.index.tsx",
      "parent": "/_app/catalog"
    },
    "/_app/catalog/items/": {
      "filePath": "_app/catalog.items.index.tsx",
      "parent": "/_app/catalog/items"
    },
    "/_app/companies/$companyKey/": {
      "filePath": "_app/companies.$companyKey.index.tsx",
      "parent": "/_app/companies/$companyKey"
    },
    "/_app/companies/customers/": {
      "filePath": "_app/companies.customers.index.tsx",
      "parent": "/_app"
    },
    "/_app/companies/suppliers/": {
      "filePath": "_app/companies.suppliers.index.tsx",
      "parent": "/_app"
    },
    "/_app/contacts/$contactKey/": {
      "filePath": "_app/contacts.$contactKey.index.tsx",
      "parent": "/_app/contacts/$contactKey"
    },
    "/_app/customers/$customerKey/": {
      "filePath": "_app/customers.$customerKey.index.tsx",
      "parent": "/_app/customers/$customerKey"
    },
    "/_app/fulfillments/$fulfillmentKey/": {
      "filePath": "_app/fulfillments.$fulfillmentKey.index.tsx",
      "parent": "/_app/fulfillments/$fulfillmentKey"
    },
    "/_app/items/$itemKey/": {
      "filePath": "_app/items.$itemKey.index.tsx",
      "parent": "/_app"
    },
    "/_app/locations/$locationKey/": {
      "filePath": "_app/locations.$locationKey.index.tsx",
      "parent": "/_app/locations/$locationKey"
    },
    "/_app/projects/$projectKey/": {
      "filePath": "_app/projects.$projectKey.index.tsx",
      "parent": "/_app/projects/$projectKey"
    },
    "/_app/purchase-orders/$purchaseOrderKey/": {
      "filePath": "_app/purchase-orders.$purchaseOrderKey.index.tsx",
      "parent": "/_app/purchase-orders/$purchaseOrderKey"
    },
    "/_app/return-orders/$returnOrderKey/": {
      "filePath": "_app/return-orders.$returnOrderKey.index.tsx",
      "parent": "/_app/return-orders/$returnOrderKey"
    },
    "/_app/tickets/$ticketKey/": {
      "filePath": "_app/tickets/$ticketKey.index.tsx",
      "parent": "/_app/tickets/$ticketKey"
    },
    "/_app/catalog/bundles/$bundleKey/audit": {
      "filePath": "_app/catalog.bundles.$bundleKey.audit.tsx",
      "parent": "/_app/catalog/bundles/$bundleKey"
    },
    "/_app/catalog/items/$itemKey/accounting": {
      "filePath": "_app/catalog.items.$itemKey.accounting.tsx",
      "parent": "/_app/catalog/items/$itemKey"
    },
    "/_app/catalog/items/$itemKey/assets": {
      "filePath": "_app/catalog.items.$itemKey.assets.tsx",
      "parent": "/_app/catalog/items/$itemKey"
    },
    "/_app/catalog/items/$itemKey/audit": {
      "filePath": "_app/catalog.items.$itemKey.audit.tsx",
      "parent": "/_app/catalog/items/$itemKey"
    },
    "/_app/catalog/items/$itemKey/bom": {
      "filePath": "_app/catalog.items.$itemKey.bom.tsx",
      "parent": "/_app/catalog/items/$itemKey"
    },
    "/_app/catalog/items/$itemKey/movement": {
      "filePath": "_app/catalog.items.$itemKey.movement.tsx",
      "parent": "/_app/catalog/items/$itemKey"
    },
    "/_app/catalog/items/$itemKey/pricing": {
      "filePath": "_app/catalog.items.$itemKey.pricing.tsx",
      "parent": "/_app/catalog/items/$itemKey"
    },
    "/_app/catalog/items/$itemKey/units": {
      "filePath": "_app/catalog.items.$itemKey.units.tsx",
      "parent": "/_app/catalog/items/$itemKey"
    },
    "/_app/reports/exception/asset/$tabType": {
      "filePath": "_app/reports.exception.asset.$tabType.tsx",
      "parent": "/_app"
    },
    "/_app/catalog/bundles/$bundleKey/": {
      "filePath": "_app/catalog.bundles.$bundleKey.index.tsx",
      "parent": "/_app/catalog/bundles/$bundleKey"
    },
    "/_app/catalog/items/$itemKey/": {
      "filePath": "_app/catalog.items.$itemKey.index.tsx",
      "parent": "/_app/catalog/items/$itemKey"
    }
  }
}
ROUTE_MANIFEST_END */
